// src/components/AngebotWizard.jsx
import React, { useContext, useState, useEffect, useRef, useMemo } from "react";
import ReactDOM from "react-dom";
import ClientView from "./ClientView";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { subYears } from "date-fns";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import SignaturePad from 'react-signature-canvas';
import { generateLocalPdf } from "../utils/generateLocalPdf";
import { generateLocalPdf2 } from "../utils/generateLocalPdf2";
import { countries } from 'countries-list';
import { de } from 'date-fns/locale/de';
import "react-datepicker/dist/react-datepicker.css";
import KursplanPage from './Kursplan';
import axios from "axios";
import { CategoryContext } from "../contexts/CategoryContext";
import { ClassContext } from "../contexts/ClassContext";
import { CombinationContext } from "../contexts/CombinationContext";
import { LicenseContext } from "../contexts/LicenseContext";
import { AktionContext } from '../contexts/AktionContext';
import { PreisContext } from "../contexts/PreisContext";
import { PriceCategoryContext } from "../contexts/PriceCategoryContext";
import { useKurse } from "../contexts/KurseContext";
import { PlaceContext } from "../contexts/PlaceContext";
import { AusbildungContext } from "../contexts/AusbildungContext";
import { differenceInYears, differenceInDays, addYears } from "date-fns";
import { useAuth } from "../contexts/AuthContext";
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import InlineSvg from "./InlineSvg";
import styles from "../styles/Angebot.module.css"
import doneIcon from "../assets/done.svg";
import Step7Panel from "./Step7Panel";
import { fetchWithRetry } from "../utils/fetchWithRetry";
import DeleteIcon from "../assets/delete.svg";
import Loader from "./Loader";



registerLocale('de', de);




const getIconUrl = (icon) => {
  if (!icon || !icon.filename_disk) return null;
  const baseUrl =
    process.env.REACT_APP_API_BASE_URL + "/assets/";
  return `${baseUrl}${icon.filename_disk}`;
};

const getRequiredLicenseNames = (ausbildung, licenses) => {
  if (!ausbildung.Vorraussetzungen || !Array.isArray(ausbildung.Vorraussetzungen)) {
    return [];
  }

  const requiredSet = new Set();
  ausbildung.Vorraussetzungen.forEach((v) => {
    licenses.forEach((l) => {
      const klassenMatch =
        Array.isArray(l.Klassen) &&
        l.Klassen.some((kl) => String(kl.id) === String(v.Klassen_id));
      const berechtigungMatch =
        Array.isArray(l.Berechtigung) &&
        l.Berechtigung.some((b) => String(b.Klassen_id) === String(v.Klassen_id));
      if (klassenMatch || berechtigungMatch) {
        requiredSet.add(l.Name);
      } else {
        // console.log(`     ⛔ Keine Übereinstimmung mit Lizenz "${l.Name}"`);
      }
    });
  });
  const result = Array.from(requiredSet);
  return result;
};

const shouldShowVariant = (ausbildung, licenses, classId) => {
  if (ausbildung.Vorraussetzungen && Array.isArray(ausbildung.Vorraussetzungen) && ausbildung.Vorraussetzungen.length > 0) {
    const klassMatch = licenses.some(l =>
      Array.isArray(l.Klassen) &&
      l.Klassen.some(kl =>
        ausbildung.Vorraussetzungen.some(v => {
          const match = String(kl.id) === String(v.Klassen_id);
          if (match) {
            // console.log(`✅ Klassen-Match bei Ausbildung "${ausbildung.Name}" → Lizenz: "${l.Name}" | Klassen ID: ${kl.id} == Voraussetzung: ${v.Klassen_id}`);
          }
          return match;
        })
      )
    );
    if (klassMatch) {
      return true;
    }

    const berechtigungMatch = licenses.some(l =>
      Array.isArray(l.Berechtigung) &&
      l.Berechtigung.some(b =>
        ausbildung.Vorraussetzungen.some(v => {
          const match = String(b.Klassen_id) === String(v.Klassen_id);
          if (match) {
            // console.log(`✅ Berechtigung-Match bei Ausbildung "${ausbildung.Name}" → Lizenz: "${l.Name}" | Klassen ID: ${b.Klassen_id} == Voraussetzung: ${v.Klassen_id}`);
          }
          return match;
        })
      )
    );
    return berechtigungMatch;
  } else {
    const inBerechtigung = licenses.some(l =>
      Array.isArray(l.Berechtigung) &&
      l.Berechtigung.some(b => {
        const match = String(b.Klassen_id) === String(classId);
        if (match) {
          // console.log(`⛔ Ausbildung ohne Voraussetzungen, aber Klasse ${classId} ist in Berechtigung von Lizenz "${l.Name}"`);
        }
        return match;
      })
    );
    return !inBerechtigung;
  }
};


const pickAusbildungVariant = (variants, licenses, classId) => {
  if (!variants || variants.length === 0) return null;
  const validVariants = variants.filter(variant => {
    const ok = shouldShowVariant(variant, licenses, classId);
    if (ok) {
      // console.log(`✔️ Variante "${variant.Name}" wird berücksichtigt`);
    } else {
      // console.log(`❌ Variante "${variant.Name}" wird ausgeschlossen`);
    }
    return ok;
  });
  if (validVariants.length === 0) {
    // console.log(`⚠️ Keine gültigen Varianten für Klasse ${classId}`);
    return null;
  }
  const variantWithVoraussetzungen = validVariants.find(
    v => Array.isArray(v.Vorraussetzungen) && v.Vorraussetzungen.length > 0
  );
  const chosen = variantWithVoraussetzungen || validVariants[0];
  // console.log(`🎯 Gewählt: "${chosen.Name}" für Klasse ${classId}`);
  return chosen;
};

const pickAusbildungVariantCombi = (variants, licenses) => {
  if (!variants || variants.length === 0) return null;
  return variants[0];
};

const getNearestCourseDate = (courses) => {
  const todayPlus10 = new Date();
  todayPlus10.setDate(todayPlus10.getDate() + 1);
  const validDates = courses
    .filter((kurs) => kurs.Kurstyp !== "arzt")
    .map((kurs) => new Date(kurs.Start))
    .filter((startDate) => startDate >= todayPlus10);
  if (validDates.length === 0) return null;
  return new Date(Math.min(...validDates));
};


const getNearestCourse = (courses) => {
  const todayPlus10 = new Date();
  todayPlus10.setDate(todayPlus10.getDate() + 1);
  const validCourses = courses
    .filter((kurs) => kurs.Kurstyp !== "arzt")
    .filter((kurs) => new Date(kurs.Start) >= todayPlus10);
  if (validCourses.length === 0) return null;
  return validCourses.reduce((nearest, kurs) => {
    return new Date(kurs.Start) < new Date(nearest.Start) ? kurs : nearest;
  });
};


const getNearestTermine = (courses) => {
  const tomorrow = new Date();
  tomorrow.setHours(0, 0, 0, 0);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const filteredCourses = courses.filter((kurs) => kurs.Kurstyp !== "arzt");
  const allTermine = filteredCourses.flatMap(course => {
    if (course.Termine && Array.isArray(course.Termine)) {
      return course.Termine.map(termine => ({
        ...termine,
        modulName: termine.Modul ? termine.Modul.Name : null,
        course: course
      }));
    } else {
      console.log(`Kurs ID ${course.id} hat keine Termine`);
      return [];
    }
  });

  const validTermine = allTermine.filter(termine => {
    const termineDate = new Date(termine.Datum);
    return termineDate >= tomorrow;
  });

  if (validTermine.length === 0) {
    return null;
  }

  const nearestTermine = validTermine.reduce((nearest, current) => {
    const nearestDate = new Date(nearest.Datum);
    const currentDate = new Date(current.Datum);
    return currentDate < nearestDate ? current : nearest;
  });

  const result = {
    datum: nearestTermine.Datum,
    modulName: nearestTermine.modulName,
    course: nearestTermine.course,
  };
  return result;
};


const AngebotWizard = ({ onSubmissionSuccess }) => {
  const { accessToken, user } = useAuth();
  const { kategorien, loadingKategorien, errorKategorien } =
    useContext(CategoryContext);
  const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);
  const { kombinationen, loadingKombinationen, errorKombinationen } =
    useContext(CombinationContext);
  const { license, loadingLicense, errorLicense } = useContext(LicenseContext);
  const { aktionen, loadingAktionen, errorAktionen } = useContext(AktionContext);
  const { preise, loadingPreise, errorPreise } = useContext(PreisContext);
  const { priceCategories, loadingPriceCategories, errorPriceCategories } =
    useContext(PriceCategoryContext);
  const { kurse, loadingKurse, errorKurse, fetchKurse } = useKurse();
  const { places, loadingPlaces, errorPlaces } = useContext(PlaceContext);
  // const { ausbildungen, loadingAusbildungen, errorAusbildungen } =
  //   useContext(AusbildungContext);

  const {
    ausbildungen,
    loadingAusbildungen,
    errorAusbildungen,
    ausbildungenPreise,             // ← цены связки Ausbildung↔Preis из контекста
    loadingAusbildungenPreise,
    errorAusbildungenPreise
  } = useContext(AusbildungContext);

  const location = useLocation();
  const { pathname } = location;

  const hauptKategorien = kategorien.filter(
    (category) => category.Hauptkategorie === true
  );
  const zusatzKategorien = kategorien.filter(
    (category) => category.Hauptkategorie === false
  );

  const { id, uuid } = useParams();

  // --- id helpers ---
  const asId = (val) => (val && typeof val === "object") ? val.id : val;

  const findCategoryObj = (catIdOrObj) => {
    const cid = asId(catIdOrObj);
    return (kategorien || []).find(c => String(c.id) === String(cid)) || null;
  };

  // (опц.) единый компаратор id
  const eqId = (a, b) => String(asId(a)) === String(asId(b));



  useEffect(() => {
    fetchKurse();
  }, [fetchKurse]);

  const [klassenKombinationen, setKlassenKombinationen] = useState([]);
  const [loadingKlassenKombinationen, setLoadingKlassenKombinationen] =
    useState(true);
  const [errorKlassenKombinationen, setErrorKlassenKombinationen] =
    useState(null);
  const [categoryError, setCategoryError] = useState("");
  const [alterError, setAlterError] = useState("");
  const [licenseError, setLicenseError] = useState("");
  const [ausbildungError, setAusbildungError] = useState("");
  const [formError, setFormError] = useState("");

  // useEffect(() => {
  //   const fetchKlassenKombinationen = async () => {
  //     const url =
  //       process.env.REACT_APP_API_BASE_URL + "/items/Klassen_Kombinationen?fields=Kombinationen_id.*,Klassen_id.*";
  //     try {
  //       const response = await axios.get(url);
  //       if (response.data && response.data.data) {
  //         setKlassenKombinationen(response.data.data);
  //       } else {
  //         setErrorKlassenKombinationen("No data für Klassen_Kombinationen");
  //       }
  //     } catch (error) {
  //       setErrorKlassenKombinationen(
  //         "Fehler beim laden Klassen_Kombinationen"
  //       );
  //       console.error(error);
  //     } finally {
  //       setLoadingKlassenKombinationen(false);
  //     }
  //   };
  //   fetchKlassenKombinationen();
  // }, []);

  useEffect(() => {
    const ac = new AbortController();
    const fetchKlassenKombinationen = async () => {
      setLoadingKlassenKombinationen(true);
      setErrorKlassenKombinationen(null);

      const url = process.env.REACT_APP_API_BASE_URL + "/items/Klassen_Kombinationen?fields=Kombinationen_id.*,Klassen_id.*";

      try {
        const res = await fetchWithRetry(
          () => axios.get(url, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        const data = res?.data?.data ?? [];
        setKlassenKombinationen(data);
      } catch (error) {
        if (!ac.signal.aborted) {
          setErrorKlassenKombinationen("Fehler beim laden Klassen_Kombinationen");
          console.error(error);
        }
      } finally {
        if (!ac.signal.aborted) {
          setLoadingKlassenKombinationen(false);
        }
      }
    };

    fetchKlassenKombinationen();
    /* return () => ac.abort(); */
  }, []);


  // const [ausbildungenPreise, setAusbildungenPreise] = useState([]);
  // const [loadingAusbildungenPreise, setLoadingAusbildungenPreise] =
  //   useState(true);
  // const [errorAusbildungenPreise, setErrorAusbildungenPreise] = useState(null);

  // useEffect(() => {
  //   const fetchAusbildungenPreise = async () => {
  //     const url =
  //       process.env.REACT_APP_API_BASE_URL + "/items/Ausbildungen_Preise?fields=*&limit=500";
  //     try {
  //       const response = await axios.get(url);
  //       if (response.data && response.data.data) {
  //         setAusbildungenPreise(response.data.data);
  //       } else {
  //         setErrorAusbildungenPreise("No data für Ausbildungen_Preise");
  //       }
  //     } catch (error) {
  //       setErrorAusbildungenPreise("Fehler beim laden Ausbildungen_Preise");
  //       console.error(error);
  //     } finally {
  //       setLoadingAusbildungenPreise(false);
  //     }
  //   };
  //   fetchAusbildungenPreise();
  // }, []);

  const loadingOverall =
    loadingKategorien ||
    loadingKlassen ||
    loadingKombinationen ||
    loadingKlassenKombinationen ||
    loadingLicense ||
    loadingPreise ||
    loadingAusbildungenPreise ||
    loadingAusbildungen ||
    loadingPriceCategories ||
    loadingKurse ||
    loadingPlaces;
  const errorOverall =
    errorKategorien ||
    errorKlassen ||
    errorKombinationen ||
    errorKlassenKombinationen ||
    errorLicense ||
    errorPreise ||
    errorAusbildungenPreise ||
    errorAusbildungen ||
    errorPriceCategories ||
    errorKurse ||
    errorPlaces;


  const loadingCritical =
    loadingAusbildungen ||
    loadingKlassen ||
    loadingKombinationen ||
    loadingKurse ||
    loadingLicense;

  const errorCritical =
    errorAusbildungen ||
    errorKlassen ||
    errorKombinationen ||
    errorKurse ||
    errorLicense;

  // готовы запускаться: есть id, нет загрузок и ошибок
  const criticalReady = React.useMemo(
    () => Boolean(id) && !loadingCritical && !errorCritical,
    [id, loadingCritical, errorCritical]
  );

  // будем инициализироваться только ОДИН раз на конкретный id
  const initedForIdRef = React.useRef(null);

  const allowPostStep6GuardRef = React.useRef(false);


  const [currentStep, setCurrentStep] = useState(1);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [birthDate, setBirthDate] = useState("");
  const [userAge, setUserAge] = useState(null);
  const [visibleAge, setVisibleAge] = useState(null);
  const [applyAgeFilter, setApplyAgeFilter] = useState(false);
  const [selectedLicenses, setSelectedLicenses] = useState([]);
  const [selectedAusbildungId, setSelectedAusbildungId] = useState(null);
  const [selectedAusbildungName, setSelectedAusbildungName] = useState(null);
  const [selectedAusbildungCombiId, setSelectedAusbildungCombiId] = useState(null);
  const [selectedAusbildungCombiName, setSelectedAusbildungCombiName] = useState(null);
  const [selectedAusbildungBestCombiId, setSelectedAusbildungBestCombiId] = useState(null);
  const [selectedAusbildungTheorie, setSelectedAusbildungTheorie] = useState(null);
  const [selectedAusbildungPraxis, setSelectedAusbildungPraxis] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState("egal");
  const [selectedFerienKurs, setSelectedFerienKurs] = useState(null);
  const [selectedAbendKurs, setSelectedAbendKurs] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [titel, setTitel] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [email2, setEmail2] = useState("");
  const [telefon, setTelefon] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [submissionError, setSubmissionError] = useState(null);
  const [ageError, setAgeError] = useState(null);
  const [ageDays, setAgeDays] = useState(null);
  const [birthDay, setBirthDay] = useState("");
  const [birthMonth, setBirthMonth] = useState("");
  const [birthYear, setBirthYear] = useState("");
  const [activeSelector, setActiveSelector] = useState(null);
  const [hasLicense, setHasLicense] = useState(null);
  const [directOffer, setDirectOffer] = useState(false);
  const [combiAusbildungUrl, setCombiAusbildungUrl] = useState(false);
  const [showAllKombis, setShowAllKombis] = useState(false);
  const today = new Date();
  const isLoggedIn = !!user;
  const isModerator = isLoggedIn;
  const [expandedCombi, setExpandedCombi] = useState(false);
  const [chosenVariant, setChosenVariant] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [angebotAnfrageId, setAngebotAnfrageId] = useState(null);
  const [showAllFerien, setShowAllFerien] = useState(false);
  const [showAllAbend, setShowAllAbend] = useState(false);
  const [showAllWeitere, setShowAllWeitere] = useState(false);
  const [showAllCourses, setShowAllCourses] = useState(false);
  const [onlyKurz, setOnlyKurz] = useState(false);
  const isAngebotfromInfoPage = location.pathname.match(/^\/angebot\/\d+$/);
  const isAngebotForAgree = location.pathname.startsWith("/angebot/anfrage");
  const [anfrageId, setAnfrageId] = useState(null);
  const [angebotCreatedAt, setAngebotCreatedAt] = useState(null);
  const [preiseOptions, setPreiseOptions] = useState([]);
  const [angebotPreise, setAngebotPreise] = useState([]);
  const [werbungPreise, setWerbungPreise] = useState([]);
  const [codePreise, setCodePreise] = useState([]);
  const [selectedPreis, setSelectedPreis] = useState(null);
  const [selectedPreisIndex, setSelectedPreisIndex] = useState(null);
  const [agbChecked, setAgbChecked] = useState(false);
  const [fuehrerscheinNummer, setFuehrerscheinNummer] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [futureEd, setFutureEd] = useState(false);
  const [earliestUpcomingStartDate, setEarliestUpcomingStartDate] = useState(null);
  const [geburtsort, setGeburtsort] = useState("");
  const [staatsbuergerschaft, setStaatsbuergerschaft] = useState("");
  const [strasse, setStrasse] = useState("");
  const [hausnummer, setHausnummer] = useState("");
  const [plz, setPlz] = useState("");
  const [ort, setOrt] = useState("");
  const [geschlecht, setGeschlecht] = useState("");
  const [saved, setSaved] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [savedSummaryData, setSavedSummaryData] = useState(null);
  const [savedSummary2Data, setSavedSummary2Data] = useState(null);
  const [updateMessage, setUpdateMessage] = useState(null);
  const [updateMessage2, setUpdateMessage2] = useState(null);
  const navigate = useNavigate();
  const [showSignatureModal, setShowSignatureModal] = useState(false);


  // шаг подписи: 0 = Schüler, 1 = Erziehungsberechtigter
  const [sigStep, setSigStep] = useState(0);
  const [sigFileStudent, setSigFileStudent] = useState(null);
  const [sigFileGuardian, setSigFileGuardian] = useState(null);

  // если всегда нужно 2 подписи для Auftrag — оставь true
  const [needsGuardianSignature, setNeedsGuardianSignature] = useState(false);

const sigStudentIdRef = useRef(null);
const sigGuardianIdRef = useRef(null);


  const [selectedFirmaPreis, setSelectedFirmaPreis] = useState(0);
  const [rabatt, setRabatt] = useState(0);
  const [finalPreis, setFinalPreis] = useState(0);
  const [gutscheinCode, setGutscheinCode] = useState("");
  const [gutscheinValid, setGutscheinValid] = useState(false);
  const [gutscheinChecked, setGutscheinChecked] = useState(false);
  const [gutscheinError, setGutscheinError] = useState("");
  const [gutscheinAppliedData, setGutscheinAppliedData] = useState(null);
  const [availableGutscheine, setAvailableGutscheine] = useState([]);
  const [selectedGutscheinId, setSelectedGutscheinId] = useState(null);
  const [foundAusbildung, setFoundAusbildung] = useState(null);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [formMode, setFormMode] = React.useState("kunde");
  const [errors, setErrors] = useState({});
  const euCountries = [
    "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic",
    "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary",
    "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta",
    "Netherlands", "Poland", "Portugal", "Romania", "Slovakia", "Slovenia",
    "Spain", "Sweden"
  ];
  const allCountries = countries ? Object.values(countries).map(country => country.name) : [];
  const euCountryNames = allCountries.filter(country => euCountries.includes(country)).sort();
  const nonEuCountryNames = allCountries.filter(country => !euCountries.includes(country)).sort();
  const [signatureData, setSignatureData] = useState(null);
  const [clientWindow, setClientWindow] = useState(null);

  const openSignatureModal = () => {
    if (!validateStep7()) return;

    setSigStep(0);
    console.log(differenceInYears(today, birthDate));
    differenceInYears(today, birthDate) < 18 ? setNeedsGuardianSignature(true) : setNeedsGuardianSignature(false);
    setSigFileStudent(null);
    setSigFileGuardian(null);
    if (sigPadRef.current) sigPadRef.current.clear();
    setShowSignatureModal(true);
  };


  const uploadSignaturePng = async (dataUrl, fileName) => {
    const blob = await (await fetch(dataUrl)).blob();
    const formData = new FormData();
    formData.append("file", blob, fileName);

    const res = await axios.post(
      process.env.REACT_APP_API_BASE_URL + "/files",
      formData,
      accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : {}
    );

    return res.data.data.id; // directus_files.id
  };


  function openClientWindow() {
    const win = window.open("", "ClientWindow", "width=1200,height=800");
    if (win) {
      // два корня: для контента и для модалки
      win.document.write(`
      <html>
        <head>
          <title>Client View</title>
        </head>
        <body>
          <div id="client-root"></div>
          <div id="client-modal-root"></div>
        </body>
      </html>
    `);

      // подтянем стили из основного окна (CSS modules/линки)
      copyStyles(document, win.document);

      // на случай закрытия клиентского окна
      win.addEventListener("beforeunload", () => {
        setClientWindow(null);
      });

      setClientWindow(win);
    }
  }

  // копируем <link rel="stylesheet"> и <style> в новое окно
  function copyStyles(sourceDoc, targetDoc) {
    Array.from(sourceDoc.styleSheets).forEach((styleSheet) => {
      try {
        if (styleSheet.cssRules) {
          const style = sourceDoc.createElement("style");
          Array.from(styleSheet.cssRules).forEach((rule) => {
            style.appendChild(sourceDoc.createTextNode(rule.cssText));
          });
          targetDoc.head.appendChild(style.cloneNode(true));
        } else if (styleSheet.href) {
          const link = sourceDoc.createElement("link");
          link.rel = "stylesheet";
          link.href = styleSheet.href;
          targetDoc.head.appendChild(link);
        }
      } catch (e) {
        // CORS у внешних стилей — просто подключаем по href
        if (styleSheet.href) {
          const link = sourceDoc.createElement("link");
          link.rel = "stylesheet";
          link.href = styleSheet.href;
          targetDoc.head.appendChild(link);
        }
      }
    });
  }


  let sigPadRef = useRef();

  const uniqueOrte = React.useMemo(() => {
    const vals = (places || [])
      .map(p => p?.Ort?.Ort ?? p?.Ort ?? p?.Name ?? p?.Kurzname)
      .filter(Boolean);
    return Array.from(new Set(vals)).sort();
  }, [places]);

  const handleClear = () => sigPadRef.current.clear();

  const handleSave = () => {
    const dataUrl = sigPadRef.current.toDataURL('image/png');
    setSignatureData(dataUrl);
  };

  useEffect(() => {
    setErrors(prev => {
      const next = { ...prev };
      if (firstName && next.firstName) delete next.firstName;
      if (lastName && next.lastName) delete next.lastName;
      if (email && next.email) delete next.email;
      if (telefon && next.telefon) delete next.telefon;
      if (agbChecked && next.agbChecked) delete next.agbChecked;
      return next;
    });
  }, [firstName, lastName, email, telefon, agbChecked]);


  const handleSendAngebot = async () => {
    if (!angebotAnfrageId) {
      console.error("Keine Anfrage ID vorhanden!");
      return;
    }

    try {
      setIsUpdating(true);

      await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotAnfrageId}`,
        {
          efm: true
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      setUpdateMessage2("Angebot erfolgreich an den Kunden gesendet!");
    } catch (error) {
      console.error("Fehler beim Senden des Angebots:", error);
      setUpdateMessage2("Es gab einen Fehler beim Senden.");
    } finally {
      setIsUpdating(false);
    }
  };



  const handleUpdateData = async () => {
    if (!anfrageId) {
      console.error("Keine Anfrage ID vorhanden!");
      return;
    }

    const targetId = anfrageId ?? angebotAnfrageId;
    if (!targetId) {
      console.error("Keine Anfrage ID vorhanden!");
      return;
    }
    const authHeaders = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

    const num = (v) => {
      if (v == null) return null;
      const n = Number(String(v).replace(",", "."));
      return Number.isFinite(n) ? n : null;
    };
    const priceOf = (item) => num(item?.Preis ?? item?.preis);
    const depositOf = (item) => num(item?.Anzahlung ?? item?.anzahlung);
    const eq = (a, b, eps = 0.001) =>
      Number.isFinite(a) && Number.isFinite(b) && Math.abs(a - b) < eps;
    const parseArr = (x) => {
      if (Array.isArray(x)) return x;
      if (typeof x === "string") {
        try { const p = JSON.parse(x); return Array.isArray(p) ? p : []; } catch { return []; }
      }
      return [];
    };

    try {
      setIsUpdating(true);

      // 1) подтягиваем массивы цен ТОЛЬКО из Directus
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
        { params: { fields: "preise,angebot_preise,code_preise" }, headers: authHeaders }
      );
      const rec = data?.data || {};
      const baseArr = parseArr(rec.preise);
      const angebotArr = parseArr(rec.angebot_preise);
      const codeArr = parseArr(rec.code_preise);

      // 2) определяем индекс выбранной карточки по значению selectedPreis
      const selVal = num(selectedPreis);
      let idx = -1;
      if (Number.isFinite(selVal)) {
        idx = codeArr.findIndex((p) => eq(priceOf(p), selVal));
        if (idx < 0) idx = angebotArr.findIndex((p) => eq(priceOf(p), selVal));
        if (idx < 0) idx = baseArr.findIndex((p) => eq(priceOf(p), selVal));
      }
      const maxLen = Math.max(baseArr.length, angebotArr.length, codeArr.length);
      if (idx < 0 && maxLen === 1) idx = 0;
      if (idx < 0) idx = 0; // дефолт

      // 3) берём соответствующие элементы
      const baseItem = baseArr[idx] ?? null; // оригинал
      const angebotItem = angebotArr[idx] ?? null; // акция
      const codeItem = codeArr[idx] ?? null; // промо

      const originalVal = priceOf(baseItem);
      const angebotVal = priceOf(angebotItem);
      const codeVal = priceOf(codeItem);

      // 4) бизнес-логика цен
      const hasAktion = Number.isFinite(angebotVal) && (angebotVal < originalVal - 0.001);
      const aktionsPreis = hasAktion ? angebotVal : null;

      const baseForPromo = hasAktion ? aktionsPreis : originalVal;
      const hasPromo = Number.isFinite(codeVal) && (codeVal < baseForPromo - 0.001);
      const promoPreis = hasPromo ? codeVal : null;

      const endpreis =
        (promoPreis != null) ? promoPreis :
          (aktionsPreis != null) ? aktionsPreis :
            originalVal;

      // 5) anzahlung выбранной цены:
      //    если есть promo → берём из codeItem, иначе если есть Aktion → из angebotItem, иначе из baseItem
      let selectedForDeposit = null;
      if (promoPreis != null) {
        selectedForDeposit = codeItem || angebotItem || baseItem;
      } else if (aktionsPreis != null) {
        selectedForDeposit = angebotItem || baseItem;
      } else {
        selectedForDeposit = baseItem;
      }
      const anzahlungVal = depositOf(selectedForDeposit);

      // 6) патчим запись (rabatt НЕ трогаем)
      await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
        {
          fuehrerscheinNummer,
          ausgewaehlterPreis: (originalVal != null) ? originalVal : null,
          aktionsPreis: (aktionsPreis != null) ? aktionsPreis : null,
          promoPreis: (promoPreis != null) ? promoPreis : null,
          endpreis: (endpreis != null) ? endpreis : null,
          anzahlung: (anzahlungVal != null) ? anzahlungVal : null,
          status: "published",
          strasse, telefon, plz, ort, hausnummer, geburtsort,
          ...(selectedGutscheinId ? { gutschein: selectedGutscheinId } : {}),
        },
        { headers: authHeaders }
      );
      setUpdateMessage("Daten erfolgreich ergänzt!");
      
    } catch (error) {
      console.error("Fehler beim Aktualisieren der Anfrage:", error);
      setUpdateMessage("Es gab einen Fehler beim Speichern.");
    } finally {
      setIsUpdating(false);
    }
  };


  //   const handleSignAndUpdate = async () => {
  //   // сначала дополним данные (цены/адрес/гutschein → запись)
  //   try {
  //     await handleUpdateData();
  //   } catch (e) {
  //     console.error("Update vor Signatur fehlgeschlagen:", e);
  //     // решай сам: продолжать подпись или нет
  //   }
  //   // затем откроем модал подписи
  //   setShowSignatureModal(true);
  // };

  const getCurrentAnfrageId = () =>
    anfrageId
    ?? angebotAnfrageId
    ?? savedSummary2Data?.angebotId
    ?? savedSummaryData?.angebotId
    ?? null;

  // 🔹 общий хелпер: заголовки авторизации (и для axios FormData ничего не ставим вручную)
  const getAuthHeaders = () => (
    accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
  );

  // ✅ единая кнопка: «Подписать и сразу отправить»
  // const handleSignAndUpdate = async () => {
  //   // 0) проверим, что подпись введена
  //   if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
  //     alert("Bitte Unterschrift eingeben.");
  //     return;
  //   }

  //   setIsUpdating(true);
  //   try {
  //     // 1) сначала дополним запись актуальными данными (цены/адрес/гутшайн)
  //     await handleUpdateData();

  //     // 2) определим ID записи
  //     const targetId = getCurrentAnfrageId();
  //     if (!targetId) {
  //       throw new Error("Keine Anfrage-ID vorhanden (weder aus Link noch aus Erstellung).");
  //     }

  //     const headers = getAuthHeaders();

  //     // 3) возьмём подпись с canvas → загрузим в Directus
  //     const dataUrl = sigPadRef.current.toDataURL('image/png');
  //     const blob = await (await fetch(dataUrl)).blob();
  //     const formData = new FormData();
  //     formData.append("file", blob, `unterschrift-${firstName}-${lastName}.png`);

  //     const uploadRes = await axios.post(
  //       process.env.REACT_APP_API_BASE_URL + "/files",
  //       formData,
  //       { headers }
  //     );
  //     const signatureFileId = uploadRes?.data?.data?.id;

  //     // (опционально можно переложить файл в нужную папку; пропускаю, чтобы не усложнять)
  //     // await axios.patch(
  //     //   `${process.env.REACT_APP_API_BASE_URL}/files/${signatureFileId}`,
  //     //   { folder: folderId },
  //     //   { headers }
  //     // );

  //     // 4) привяжем подпись к заявке: поле `unterschrift` + связь в m2m-таблице
  //     await axios.patch(
  //       `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
  //       { unterschrift: signatureFileId, status: "published" },
  //       { headers }
  //     );

  //     await axios.post(
  //       process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage_files_1",
  //       { Angebot_Anfrage_id: targetId, directus_files_id: signatureFileId },
  //       { headers }
  //     );

  //     // 5) отправим клиенту (как в твоём handleSendAngebot)
  //     await axios.patch(
  //       `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
  //       { efm: true },
  //       { headers }
  //     );

  //     setShowSignatureModal(false);
  //     setUpdateMessage("Unterschrift gespeichert und Angebot gesendet!");
  //   } catch (err) {
  //     console.error("Sign+Send error:", err?.response?.data || err.message || err);
  //     setUpdateMessage("Fehler beim Signieren/Senden.");
  //   } finally {
  //     setIsUpdating(false);
  //   }
  // };

  const handleSignAndUpdate = async () => {
    if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
      alert("Bitte Unterschrift eingeben.");
      return;
    }

    setIsUpdating(true);
    try {
      // 1) дополним поля (цены/адрес/гутшайн)
      await handleUpdateData();

      // 2) целевой id
      const targetId = getCurrentAnfrageId();
      if (!targetId) throw new Error("Keine Anfrage-ID gefunden.");

      const headers = getAuthHeaders();

      // 3) загрузим подпись в /files
      const dataUrl = sigPadRef.current.toDataURL('image/png');
      const blob = await (await fetch(dataUrl)).blob();
      const formData = new FormData();
      formData.append("file", blob, `unterschrift-${firstName}-${lastName}.png`);

      const uploadRes = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/files",
        formData,
        { headers }
      );
      const signatureFileId = uploadRes?.data?.data?.id;

      // 4) сохранить file_id в НОВОЕ поле signature
      await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
        { signature: signatureFileId, status: "published" },
        { headers }
      );

      // ⛔️ Больше НЕ добавляем запись в Angebot_Anfrage_files_1 для подписи

      // 5) отправим (как раньше efm: true)
      await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
        { efm: true },
        { headers }
      );

      setShowSignatureModal(false);
      setUpdateMessage("Unterschrift gespeichert und Angebot gesendet!");
    } catch (err) {
      console.error("Sign+Send error:", err?.response?.data || err.message || err);
      setUpdateMessage("Fehler beim Signieren/Senden.");
    } finally {
      setIsUpdating(false);
    }
  };


  useEffect(() => {
    const preis = formMode === "firma" ? Number(selectedFirmaPreis) : Number(selectedPreis);
    const rabattWert = Number(rabatt) || 0;
    const berechneterEndpreis = Math.max(preis - rabattWert, 0);
    setFinalPreis(berechneterEndpreis);
  }, [selectedPreis, selectedFirmaPreis, rabatt, formMode]);


  useEffect(() => {
    if (submissionSuccess) {
      const timer = setTimeout(() => {
        /* setSubmissionSuccess(false);
        if (!isModerator) {
          navigate('/');
        } */
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [submissionSuccess, isModerator, navigate, setSubmissionSuccess]);



  useEffect(() => {
    if (updateMessage) {
      const timer = setTimeout(() => {
        /* setUpdateMessage(null); */
        /* navigate('/'); */
        /* setCurrentStep(7); */
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [updateMessage, navigate, setUpdateMessage]);


  const handleDateChange = (date) => {
    setStartDate(date);
  };

  useEffect(() => {
    if (futureEd && earliestUpcomingStartDate) {
      const parsedDate = new Date(earliestUpcomingStartDate);
      if (!isNaN(parsedDate)) {
        setStartDate(parsedDate);
      }
    }
  }, [futureEd, earliestUpcomingStartDate]);


  const getNearestCourseDateFromInput = (courses, startDate) => {
    const inputDate = new Date(startDate);
    const basePlus10 = new Date(inputDate);
    basePlus10.setDate(basePlus10.getDate() + 1);

    const validDates = courses
      .filter((kurs) => kurs.Kurstyp !== "arzt")
      .map((kurs) => new Date(kurs.Start))
      .filter((startDate) => startDate >= basePlus10);

    if (validDates.length === 0) return null;

    return new Date(Math.min(...validDates));
  };


  const getNearestCourseFromInput = (courses, startDate) => {
    const inputDate = new Date(startDate);
    const basePlus1 = new Date(inputDate);
    basePlus1.setDate(basePlus1.getDate() + 1);
    const validCourses = courses
      .filter((kurs) => kurs.Kurstyp !== "arzt")
      .filter(course => new Date(course.Start) >= basePlus1);
    if (validCourses.length === 0) return null;
    let nearestCourse = validCourses[0];
    let minDate = new Date(nearestCourse.Start);
    validCourses.forEach(course => {
      const courseDate = new Date(course.Start);
      if (courseDate < minDate) {
        minDate = courseDate;
        nearestCourse = course;
      }
    });

    return nearestCourse;
  };


  const getNearestTermineFromInput = (courses, startDate) => {
    const inputDate = new Date(startDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const baseDate = new Date(inputDate);
    baseDate.setHours(0, 0, 0, 0);
    if (baseDate.getTime() === today.getTime()) {
      baseDate.setDate(baseDate.getDate() + 1);
    }

    const filteredCourses = courses.filter(
      (kurs) => kurs.Kurstyp !== "arzt" && kurs.Kurstyp !== "ehk"
    );


    const allTermine = filteredCourses.flatMap(course => {
      if (course.Termine && Array.isArray(course.Termine)) {
        return course.Termine.map(termine => ({
          ...termine,
          modulName: termine.Modul ? termine.Modul.Name : null,
          course: course
        }));
      } else {
        return [];
      }
    });

    const validTermine = allTermine.filter(termine => {
      const termineDate = new Date(termine.Datum);
      return termineDate >= baseDate;
    });

    if (validTermine.length === 0) {
      return null;
    }

    const nearestTermine = validTermine.reduce((nearest, current) => {
      const nearestDate = new Date(nearest.Datum);
      const currentDate = new Date(current.Datum);
      return currentDate < nearestDate ? current : nearest;
    });

    const result = {
      datum: nearestTermine.Datum,
      modulName: nearestTermine.modulName,
      course: nearestTermine.course,
    };
    return result;
  };



  const getClassForAusbildung = (ausbildungId) => {
    for (const klasse of klassen) {
      if (
        Array.isArray(klasse.Ausbildungen) &&
        klasse.Ausbildungen.some((a) => a.id === ausbildungId)
      ) {
        return klasse;
      }
    }
    return null;
  };



  useEffect(() => {
    if (isModerator) {
      axios
        .get(process.env.REACT_APP_API_BASE_URL + "/items/Gutscheincodes", {
          params: {
            sort: "-date_created",
            fields: "id,Code,Rabatt,Startdatum,Enddatum,Klassen,*.*",
          },
        })
        .then((res) => setAvailableGutscheine(res.data.data))
        .catch((err) => console.error("Fehler beim Laden der Gutscheine:", err));
    }
  }, [isModerator]);


  useEffect(() => {
    const fetchAnfrageByUuid = async () => {
      if (!uuid || loadingAusbildungen || loadingKlassen) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage?filter[link][_eq]=${uuid}&fields=*.*`
        );

        const anfrageData = response.data.data?.[0];
        if (!anfrageData) {
          console.error(`Keine Anfrage mit UUID ${uuid} gefunden`);
          return;
        }

        console.log('✅ Anfrage gefunden:', anfrageData);

        setAngebotAnfrageId(anfrageData.id);

        const angebotCreatedFormatted = (() => {
          const d = new Date(anfrageData.date_created);
          return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
        })();
        setAngebotCreatedAt(angebotCreatedFormatted);

        setSelectedAusbildungId(null);
        setSelectedAusbildungCombiId(null);

        setFirstName(anfrageData.vorname || "");
        setLastName(anfrageData.nachname || "");
        setEmail(anfrageData.email || "");
        setTelefon(anfrageData.telefon || "");
        setAnfrageId(anfrageData.id);

        if (anfrageData.geburtsDatum) {
          const gebDate = new Date(anfrageData.geburtsDatum);
          setBirthDay(gebDate.getDate().toString().padStart(2, "0"));
          setBirthMonth((gebDate.getMonth() + 1).toString().padStart(2, "0"));
          setBirthYear(gebDate.getFullYear().toString());
          setBirthDate(gebDate);
        }

        setTitel(anfrageData.titel || "");
        setGeschlecht(anfrageData.geschlecht || "");
        setGeburtsort(anfrageData.geburtsort || "");
        setStaatsbuergerschaft(anfrageData.staatsbuergerschaft || "");

        setStrasse(anfrageData.strasse || "");
        setHausnummer(anfrageData.hausnummer || "");
        setPlz(anfrageData.plz || "");
        setOrt(anfrageData.ort || "");

        setGutscheinCode(anfrageData.gutschein?.Code || "");
        setGutscheinAppliedData(anfrageData.gutschein);

        /* setTimeout(() => {
          handleCheckGutschein()
        }, 5000); */

        setApplyAgeFilter(anfrageData.applyAgeFilter || false);

        if (Array.isArray(anfrageData.fuehrerscheine)) {
          const selectedLic = license.filter((l) =>
            anfrageData.fuehrerscheine.some(
              (item) => String(item.Fuehrerscheine_id) === String(l.id)
            )
          );
          setSelectedLicenses(selectedLic);
        }

        if (anfrageData.anfrage_ausbildung) {
          const ausbildungObj = anfrageData.anfrage_ausbildung;
          console.log("Gefundene Ausbildung im Anfrage:", ausbildungObj);

          setSelectedAusbildungId(ausbildungObj.id);
          setSelectedAusbildungName(ausbildungObj.Name || "");
          setSelectedAusbildungCombiName(ausbildungObj.Name || "");
          setChosenVariant(ausbildungObj);

          setSelectedAusbildungTheorie(anfrageData.ausbildung_theorie);
          setSelectedAusbildungPraxis(anfrageData.ausbildung_praxis);

          if(ausbildungObj.Kombi) {
            const foundKombi = kombinationen.find(ko => String(ko.id) === String(ausbildungObj.Kombi));
            console.log(foundKombi);
            const foundClass = klassen.find(k => String(k.id) === String(foundKombi.Klassen[0].Klassen_id.id));
            console.log(foundClass);
            const firstCat = foundClass?.Kategorien?.[0]?.Kategorien_id;
            const catObj = findCategoryObj(firstCat);
            console.log(catObj);
            if (catObj) setSelectedCategories([catObj]);

            setSelectedAusbildungCombiId(ausbildungObj.id || null);
          }

          // if (ausbildungObj.Klasse) {
          //   const foundClass = klassen.find(k => String(k.id) === String(ausbildungObj.Klasse));
          //   if (foundClass?.Kategorien?.length > 0) {
          //     const firstCategory = foundClass.Kategorien[0].Kategorien_id;
          //     setSelectedCategories([firstCategory]);
          //   }
          // }
          if (ausbildungObj.Klasse) {
            const foundClass = klassen.find(k => String(k.id) === String(ausbildungObj.Klasse));
            const firstCat = foundClass?.Kategorien?.[0]?.Kategorien_id;
            const catObj = findCategoryObj(firstCat);
            if (catObj) setSelectedCategories([catObj]);
          }

          console.log(selectedCategories);

        }

        let parsedNormale = [];

        if (anfrageData.preise) {
          try {
            parsedNormale = JSON.parse(anfrageData.preise);
            console.log("📦 Normale Preise (parsedNormale):", parsedNormale);
            setPreiseOptions(parsedNormale);
          } catch (e) {
            console.warn("❌ Fehler beim Parsen der Anfrage-Preise", e);
          }
        } else {
          console.log("ℹ️ Keine normalen Preise (preise) gefunden");
        }

        if (anfrageData.angebot_preise) {
          try {
            const parsed = JSON.parse(anfrageData.angebot_preise);

            const normalized = parsed.map(p => ({
              ...p,
              Angebotspreis: Number(p.preis),
              Preis: Number(p.Preis) || null
            }));

            console.log("💸 Angebotspreise (normalisiert):", normalized);
            setAngebotPreise(normalized);
          } catch (e) {
            console.warn("❌ Fehler beim Parsen der Angebotspreise", e);
          }
        } else {
          console.log("ℹ️ Keine Angebotspreise gefunden");
        }

        if (anfrageData.angebot_preise_werbung) {
          try {
            const parsedWerbung = JSON.parse(anfrageData.angebot_preise_werbung);

            const normalizedWerbung = parsedWerbung.map(p => ({
              ...p,
              Angebotspreis: Number(p.preis),
              Preis: Number(p.Preis) || null
            }));

            console.log("💸 Angebotspreise von Werbung (normalisiert):", normalizedWerbung);
            setWerbungPreise(normalizedWerbung);
          } catch (e) {
            console.warn("❌ Fehler beim Parsen der Angebotspreise von Werbung", e);
          }
        } else {
          console.log("ℹ️ Keine Angebotspreise von Werbung gefunden");
        }

        if (anfrageData.code_preise) {
          try {
            const parsedCode = JSON.parse(anfrageData.code_preise);
            const normalizedCode = parsedCode.map(p => {
              const orig = parsedNormale.find(o => o.kategorieName === p.kategorieName);
              return {
                ...p,
                Angebotspreis: Number(p.preis),
                Preis: orig ? Number(orig.preis) : null,
              };
            });
            console.log("🎟️ Codepreise (mit Originalpreis):", normalizedCode);
            setCodePreise(normalizedCode);
          } catch (e) {
            console.warn("❌ Fehler beim Parsen der Codepreise", e);
          }
        } else {
          console.log("ℹ️ Keine Codepreise gefunden");
        }


        if (anfrageData.ausgewaehlterPreis) {
          setSelectedPreis(anfrageData.ausgewaehlterPreis.toString());
        }

        if (anfrageData.ausgewaehlterOrt === "egal") {
          setSelectedPlace("egal");
        } else if (anfrageData.ausgewaehlterOrt) {
          setSelectedPlace(anfrageData.ausgewaehlterOrt);
        }

        if (anfrageData.ferien_kurs) {
          setSelectedFerienKurs(anfrageData.ferien_kurs);
        }

        setCurrentStep(6);
      } catch (error) {
        console.error('❌ Fehler beim Laden der Anfrage per UUID', error);
      }
    };

    fetchAnfrageByUuid();
  }, [uuid, kategorien, license, ausbildungen, klassen, kombinationen, loadingAusbildungen, loadingKlassen]);



  const visibleKombis = useMemo(() => {
    if (!selectedAusbildungId) return [];

    const selectedClass = getClassForAusbildung(selectedAusbildungId, klassen);
    if (!selectedClass) return [];

    return (
      selectedClass.Kombis?.filter((kombi) => {
        const ausbildungIds = kombi?.Kombinationen_id?.Ausbildungen;
        if (!ausbildungIds || !Array.isArray(ausbildungIds)) return false;

        // const available = ausbildungIds
        //   .map((id) => ausbildungen.find((a) => String(a?.id) === String(id)))
        //   .filter(Boolean);

        const available = (ausbildungIds || [])
          .map((x) => asId(x))
          .map((aid) => ausbildungen.find((a) => String(a?.id) === String(aid)))
          .filter(Boolean);

        const eligible = available.filter((variant) => {
          if (!variant) return false;
          if (!variant.Vorraussetzungen || variant.Vorraussetzungen.length === 0) return true;

          return variant.Vorraussetzungen.some((prereq) =>
            selectedLicenses.some((l) =>
              Array.isArray(l.Klassen) &&
              l.Klassen.some((kl) =>
                String(typeof kl === "object" ? kl.id : kl) === String(prereq.Klassen_id)
              )
            )
          );
        });

        const chosen = eligible.find((v) => v.Vorraussetzungen?.length) || eligible[0];
        return !!chosen;
      }) || []
    );
  }, [selectedAusbildungId, klassen, ausbildungen, selectedLicenses]);

  const hasRedirected = useRef(false);

  useEffect(() => {
    if (currentStep === 5 && visibleKombis.length === 0 && !hasRedirected.current) {
      hasRedirected.current = true;
      setCurrentStep(6);
    }

    if (currentStep !== 5 && currentStep !== 6) {
      hasRedirected.current = false;
    }
  }, [currentStep, visibleKombis]);


  useEffect(() => {
    if (!allowPostStep6GuardRef.current) return;
    if (currentStep !== 7 || !chosenVariant) return;

    let relatedCourses = [];

    const relatedClass = getClassForAusbildung(chosenVariant.id, klassen);

    if (relatedClass) {
      relatedCourses = getCoursesForClass(relatedClass.id, kurse);
    } else {
      const relatedClassIds = new Set();
      kombinationen.forEach((kombi) => {
        if (kombi.Ausbildungen?.some((a) => a.id === chosenVariant.id)) {
          klassenKombinationen.forEach((mapping) => {
            if (mapping.Kombinationen_id?.id === kombi.id && mapping.Klassen_id?.id) {
              relatedClassIds.add(mapping.Klassen_id.id);
            }
          });
        }
      });

      relatedCourses = Array.from(relatedClassIds).flatMap((cid) =>
        getCoursesForClass(cid, kurse)
      );

      relatedCourses = Array.from(new Map(relatedCourses.map(c => [c.id, c])).values());
    }

    console.log('relatedCourses:', relatedCourses);

    if (relatedCourses.length === 0) {
      console.log("⏭ Keine Kurse gefunden — gehe direkt zu Schritt 7");
      setCurrentStep(6);
    }
  }, [currentStep, chosenVariant, klassen, kurse, kombinationen, klassenKombinationen]);

  //Fetch from ID (Class Details Page)
  // useEffect(() => {
  //   if (id && !loadingAusbildungen && !loadingKlassen) {
  //     const foundAusbildung = ausbildungen.find((a) => String(a.id) === id);
  //     console.log("founded Ausbildung from AusbildungContext:", foundAusbildung);

  //     if (foundAusbildung) {
  //       setChosenVariant(foundAusbildung);

  //       if (Array.isArray(foundAusbildung.Vorraussetzungen)) {
  //         const licenseObjects = foundAusbildung.Vorraussetzungen
  //           .map((item) => {
  //             const klasseId = item.Klassen_id;
  //             const foundLicense = license.find((l) =>
  //               Array.isArray(l.Klassen) &&
  //               l.Klassen.some((k) => {
  //                 const kId = typeof k === "object" ? k.id : k;
  //                 return String(kId) === String(klasseId);
  //               })
  //             );
  //             return foundLicense;
  //           })
  //           .filter(Boolean);

  //         const uniqueLicenseObjects = [];
  //         const seenIds = new Set();
  //         licenseObjects.forEach((lic) => {
  //           if (!seenIds.has(lic.id)) {
  //             uniqueLicenseObjects.push(lic);
  //             seenIds.add(lic.id);
  //           }
  //         });
  //         setSelectedLicenses(uniqueLicenseObjects);
  //       }

  //       if (foundAusbildung.Klasse) {
  //         setSelectedAusbildungId(foundAusbildung.id);
  //         setSelectedAusbildungName(foundAusbildung.Name);

  //         const foundClass = getClassForAusbildung(foundAusbildung.id, klassen);
  //         if (foundClass) {
  //           const fullClass = klassen.find((k) => String(k.id) === String(foundClass.id));

  //           if (Array.isArray(fullClass.Kategorien) && fullClass.Kategorien.length > 0) {
  //             const firstCategory = fullClass.Kategorien[0].Kategorien_id;
  //             setSelectedCategories([firstCategory]);
  //           }

  //           if (fullClass?.Kombis?.length > 0) {
  //             setCurrentStep(5);
  //           } else {
  //             setCurrentStep(6);
  //           }
  //         }
  //       }

  //       else if (foundAusbildung.Kombi) {
  //         setCombiAusbildungUrl(true);
  //         setCurrentStep(6);
  //         setSelectedAusbildungCombiId(foundAusbildung.id);
  //         setSelectedAusbildungId(foundAusbildung.id);
  //         setSelectedAusbildungName(foundAusbildung.Name);

  //         const kombiId = foundAusbildung.Kombi.id;
  //         const foundCombination = kombinationen.find((kombi) => String(kombi.id) === String(kombiId));

  //         if (foundCombination && Array.isArray(foundCombination.Klassen) && foundCombination.Klassen.length > 0) {
  //           const firstClassObj = foundCombination.Klassen[0].Klassen_id;

  //           if (firstClassObj?.Ausbildungen?.length > 0) {
  //             const firstCandidate = firstClassObj.Ausbildungen[0];
  //             const firstAusbildungId = typeof firstCandidate === 'object' ? firstCandidate.id : firstCandidate;
  //             setSelectedAusbildungId(firstAusbildungId);
  //             setSelectedAusbildungName(foundAusbildung.Name);
  //           }

  //           const fullClass = klassen.find((k) => String(k.id) === String(firstClassObj.id));
  //           if (fullClass?.Kategorien?.length > 0) {
  //             const firstCategory = fullClass.Kategorien[0].Kategorien_id;
  //             setSelectedCategories([firstCategory]);
  //           }
  //         }
  //       }

  //       else {
  //         console.log("Neither Klasse nor Kombi found in Ausbildung");
  //       }

  //       setTimeout(() => {
  //         if (foundAusbildung.Klasse) {
  //           const foundClass = getClassForAusbildung(foundAusbildung.id, klassen);
  //           const fullClass = foundClass
  //             ? klassen.find((k) => String(k.id) === String(foundClass.id))
  //             : null;

  //           const hasKombis = fullClass?.Kombis?.length > 0;

  //           if (hasKombis) {
  //             console.log("✅ Klasse hat Kombis → Schritt 5");
  //             setCurrentStep(5);
  //             return;
  //           }

  //           let relatedCourses = [];

  //           if (foundClass) {
  //             relatedCourses = getCoursesForClass(foundClass.id, kurse);
  //           }

  //           if (relatedCourses.length > 0) {
  //             console.log("✅ Kurse vorhanden (ohne Kombis) → Schritt 6");
  //             setCurrentStep(6);
  //           } else {
  //             console.log("⏭ Weder Kombis noch Kurse → Schritt 7");
  //             setCurrentStep(7);
  //           }
  //         }

  //         else if (foundAusbildung.Kombi) {
  //           console.log("ℹ️ Kombi-Ausbildung → Schritt 6");
  //           setCurrentStep(6);
  //         }
  //       }, 0);

  //     } else {
  //       console.log("Ausbildung mit id", id, "nicht gefunden");
  //     }
  //   }
  // }, [id, loadingAusbildungen, ausbildungen, loadingKlassen, klassen, license, kombinationen, kurse]);

  // 👉 2) НОВЫЙ эффект вместо твоего "Fetch from ID"
  React.useEffect(() => {
    if (!criticalReady) return;

    // уже инициализировались для этого id — пропускаем
    if (initedForIdRef.current === String(id)) return;
    initedForIdRef.current = String(id);

    // ищем Ausbildung
    const ausb = (ausbildungen || []).find(a => String(a.id) === String(id));
    setFoundAusbildung(ausb || null);
    console.log("✅ found Ausbildung (criticalReady):", ausb);

    if (!ausb) {
      console.log("Ausbildung mit id", id, "nicht gefunden");
      return;
    }

    // базовое
    setChosenVariant(ausb);

    // лицензии по Vorraussetzungen
    if (Array.isArray(ausb.Vorraussetzungen)) {
      const licenseObjects = ausb.Vorraussetzungen
        .map((item) => {
          const klasseId = item?.Klassen_id;
          if (klasseId == null) return null;
          const foundLicenseObj = (license || []).find((l) =>
            Array.isArray(l.Klassen) &&
            l.Klassen.some((k) => {
              const kId = typeof k === "object" ? k?.id : k;
              return String(kId) === String(klasseId);
            })
          );
          return foundLicenseObj || null;
        })
        .filter(Boolean);

      const unique = [];
      const seen = new Set();
      for (const lic of licenseObjects) {
        if (!seen.has(lic.id)) {
          unique.push(lic);
          seen.add(lic.id);
        }
      }
      setSelectedLicenses(unique);
    }

    // вычисляем следующий шаг за один проход
    let nextStep = 7;

    // ── ВЕТКА КЛАССА ─────────────────────────────────
    if (ausb.Klasse) {
      setSelectedAusbildungId(ausb.id);
      setSelectedAusbildungName(ausb.Name || "");

      // твоя утилита:
      const foundClass =
        typeof getClassForAusbildung === "function"
          ? getClassForAusbildung(ausb.id)
          : (klassen || []).find(kl =>
            Array.isArray(kl.Ausbildungen) &&
            kl.Ausbildungen.some(a => a.id === ausb.id)
          );

      if (foundClass) {
        const fullClass = (klassen || []).find(k => String(k.id) === String(foundClass.id));

        // первая категория
        // const firstCategory = fullClass?.Kategorien?.[0]?.Kategorien_id;
        // if (firstCategory) setSelectedCategories([firstCategory]);

        const firstCat = fullClass?.Kategorien?.[0]?.Kategorien_id;
        const catObj = findCategoryObj(firstCat);
        if (catObj) setSelectedCategories([catObj]);


        // есть комби → шаг 5
        if (Array.isArray(fullClass?.Kombis) && fullClass.Kombis.length > 0) {
          nextStep = 5;
        } else {
          // иначе смотрим курсы
          const relatedCourses =
            typeof getCoursesForClass === "function"
              ? (getCoursesForClass(fullClass.id, kurse) || [])
              : (kurse || []).filter(k =>
                String(k?.Klasse?.id ?? k?.Klasse_id) === String(fullClass.id)
              );

          nextStep = (relatedCourses && relatedCourses.length > 0) ? 6 : 7;
        }
      }
    }

    // ── ВЕТКА КОМБИ ──────────────────────────────────
    else if (ausb.Kombi) {
      setCombiAusbildungUrl(true);
      setSelectedAusbildungCombiId(ausb.id);
      setSelectedAusbildungId(ausb.id);
      setSelectedAusbildungName(ausb.Name || "");

      const kombiId = ausb.Kombi?.id;
      const foundCombination = (kombinationen || []).find(k => String(k.id) === String(kombiId));

      const firstClassObj = foundCombination?.Klassen?.[0]?.Klassen_id;
      if (firstClassObj) {
        // подставим первую Ausbildung из класса (если есть)
        const firstCandidate = firstClassObj.Ausbildungen?.[0];
        const firstAusbildungId = typeof firstCandidate === "object" ? firstCandidate?.id : firstCandidate;
        if (firstAusbildungId) {
          setSelectedAusbildungId(firstAusbildungId);
          setSelectedAusbildungName(ausb.Name || "");
        }

        // первая категория
        const fullClass = (klassen || []).find(k => String(k.id) === String(firstClassObj.id));
        // const firstCategory = fullClass?.Kategorien?.[0]?.Kategorien_id;
        // if (firstCategory) setSelectedCategories([firstCategory]);
        const firstCat = fullClass?.Kategorien?.[0]?.Kategorien_id;
        const catObj = findCategoryObj(firstCat);
        if (catObj) setSelectedCategories([catObj]);

      }

      // для комби переходим сразу на шаг 6
      nextStep = 6;
    }

    // финально
    setCurrentStep(nextStep);
    setTimeout(() => { allowPostStep6GuardRef.current = true; }, 0);
  }, [
    criticalReady,
    id,
    ausbildungen,
    klassen,
    license,
    kombinationen,
    kurse,
    // если getClassForAusbildung / getCoursesForClass — внешние мемо-хелперы,
    // добавь их сюда тоже:
    getClassForAusbildung,
    // getCoursesForClass,
    kategorien,
  ]);

  // при смене id разрешаем повторную инициализацию
  React.useEffect(() => { initedForIdRef.current = null; }, [id]);




  const getCombinationForAusbildung = (ausbildungId, kombinationen) => {
    return kombinationen.find((kombi) =>
      kombi.Ausbildungen && kombi.Ausbildungen.some((a) => String(a.id) === String(ausbildungId))
    );
  };


  const [expandedCategoriesClass, setExpandedCategoriesClass] = useState([]);
  const toggleCategoryClass = (catId) => {
    setExpandedCategoriesClass((prev) =>
      prev.includes(catId)
        ? prev.filter((id) => id !== catId)
        : [...prev, catId]
    );
  };

  const [computedCatCombinations, setComputedCatCombinations] = useState([]);

  useEffect(() => {
    if (!selectedAusbildungId) {
      setComputedCatCombinations([]);
      return;
    }
    const selectedClass = getClassForAusbildung(selectedAusbildungId, klassen);
    if (!selectedClass) {
      setComputedCatCombinations([]);
      return;
    }
    const combinations = kombinationen.filter((kombi) =>
      klassenKombinationen.some(
        (mapping) =>
          mapping.Kombinationen_id?.id === kombi.id &&
          mapping.Klassen_id?.id &&
          mapping.Klassen_id.id === selectedClass.id
      )
    );
    setComputedCatCombinations(combinations);
  }, [selectedAusbildungId, klassen, kombinationen, klassenKombinationen]);


  useEffect(() => {
    if (!birthDay || !birthMonth || !birthYear) {
      return;
    }

    if (birthYear.toString().length !== 4) {
      setUserAge(null);
      setAgeDays(null);
      return;
    }

    if (Number(birthMonth) > 12) {
      setAgeError("month till 12");
      setUserAge(null);
      setAgeDays(null);
      setDirectOffer(false);
      return;
    }

    if (Number(birthDay) > 31) {
      setAgeError("day till 31");
      setUserAge(null);
      setAgeDays(null);
      setDirectOffer(false);
      return;
    }

    const today = new Date();
    const minYear = today.getFullYear() - 12;
    if (Number(birthYear) > minYear) {
      setAgeError(
        `birth year cant be more than ${minYear}, age min. 12`
      );
      setUserAge(null);
      setAgeDays(null);
      setDirectOffer(false);
      return;
    }

    const hundredYearsAgo = new Date();
    hundredYearsAgo.setFullYear(today.getFullYear() - 100);

    const formattedDay = birthDay.toString().padStart(2, "0");
    const formattedMonth = birthMonth.toString().padStart(2, "0");
    const birthDateStr = `${birthYear}-${formattedMonth}-${formattedDay}`;
    const date = new Date(birthDateStr);

    if (date < hundredYearsAgo) {
      setAgeError("date of birth not earlier than 100 years");
      setUserAge(null);
      setAgeDays(null);
      setDirectOffer(false);
      return;
    } else {
      setAgeError("");

      let years = differenceInYears(today, date);
      let birthdayThisYear = addYears(date, years);
      if (today < birthdayThisYear) {
        years -= 1;
        birthdayThisYear = addYears(date, years);
      }

      const daysSinceBirthday = differenceInDays(today, birthdayThisYear);
      const birthdayNextYear = addYears(birthdayThisYear, 1);
      const daysInYear = differenceInDays(birthdayNextYear, birthdayThisYear);
      const fractionalAge = years + daysSinceBirthday / daysInYear;
      const roundedFractionalAge = Math.round(fractionalAge * 100) / 100;

      setVisibleAge(years);
      setUserAge(roundedFractionalAge);
      setAgeDays(daysSinceBirthday);
      setDirectOffer(true);
      setBirthDate(date);
    }
  }, [birthDay, birthMonth, birthYear]);

  const resetFields = () => {
    setDirectOffer(true);
    setBirthDay("");
    setBirthMonth("");
    setBirthYear("");
    setUserAge(null);
    setApplyAgeFilter(false);
  };

  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 100;
  const maxYear = currentYear - 13;

  const minYearAlter = currentYear - 90;
  const maxYearAlter = today.getFullYear() - 13;



  const classBelongsToCategory = (klasse, category) => {
    if (!klasse.Kategorien) return false;
    const cats = Array.isArray(klasse.Kategorien)
      ? klasse.Kategorien
      : [klasse.Kategorien];
    const zusatzCats = Array.isArray(klasse.Zusatzkategorien)
      ? klasse.Zusatzkategorien
      : [klasse.Zusatzkategorien];

    if (cats.some((cat) => cat.Kategorien_id && cat.Kategorien_id.id === category.id)) {
      return true
    } else if (zusatzCats.some((cat) => cat.Kategorien_id && cat.Kategorien_id.id === category.id)) {
      return true;
    } else {
      return false;
    }
  };


  const classesByCategory = {};
  selectedCategories.forEach((cat) => {
    classesByCategory[cat.id] = klassen.filter((klasse) =>
      classBelongsToCategory(klasse, cat)
    );
  });


  useEffect(() => {
    console.log("savedSummaryData updated", savedSummaryData);
  }, [savedSummaryData]);



  useEffect(() => {
    if (!selectedAusbildungCombiId && computedCatCombinations.length > 0) {
      const firstCombi = computedCatCombinations[0];
      const available = filterAusbildungen(
        firstCombi.Kombinationen_id?.Ausbildungen || []
      );
      const defaultVariant = pickAusbildungVariantCombi(available, license);
      if (defaultVariant) {
        setSelectedAusbildungCombiId(defaultVariant.id);
      }
    }
  }, [computedCatCombinations, license, selectedAusbildungCombiId]);

  const shouldIncludeAusbildung = (ausbildung) => {
    if (id) { return true; }

    if (applyAgeFilter && userAge !== null && ausbildung.Ausbildungsbeginn) {
      const minAge = parseFloat(ausbildung.Ausbildungsbeginn);
      if (!isNaN(minAge) && userAge < minAge) return false;
    }

    const requiredLicenses = getRequiredLicenseNames(ausbildung, license);
    if (requiredLicenses.length === 0) return true;
    const selectedLicenseNames = selectedLicenses.map((lic) => lic.Name);
    return requiredLicenses.some((req) => selectedLicenseNames.includes(req));
  };

  const filterAusbildungen = (ausbildungen) => {
    if (!Array.isArray(ausbildungen)) return [];
    return ausbildungen.filter(shouldIncludeAusbildung);
  };

  const getSelectedAusbildungVariant = () => {
    if (selectedAusbildungCombiId) {
      for (const cat of selectedCategories) {
        const catClasses = klassen.filter((klasse) =>
          classBelongsToCategory(klasse, cat)
        );
        const catClassIds = catClasses.map((k) => k.id);

        const catCombinations = kombinationen.filter((kombi) =>
          klassenKombinationen.some(
            (mapping) =>
              mapping.Kombinationen_id?.id === kombi.id &&
              mapping.Klassen_id?.id &&
              catClassIds.includes(mapping.Klassen_id.id)
          )
        );
        for (const kombi of catCombinations) {
          const available = filterAusbildungen(kombi.Ausbildungen);
          for (const variant of available) {
            if (variant.id === selectedAusbildungCombiId) return variant;
          }
        }
      }
    }

    if (selectedAusbildungId) {
      for (const cat of selectedCategories) {
        const catClasses = classesByCategory[cat.id] || [];
        for (const klasse of catClasses) {
          const available = filterAusbildungen(klasse.Ausbildungen);
          for (const variant of available) {
            if (variant.id === selectedAusbildungId) return variant;
          }
        }
      }
    }

    return null;
  };

  const getUpcomingAusbildungen = () => {
    const upcoming = [];

    const maxMonthsUntilStart = 12;
    const maxDaysUntilStart = maxMonthsUntilStart * 30;

    selectedCategories.forEach(cat => {
      const catClasses = classesByCategory[cat.id] || [];

      catClasses.forEach(klasse => {
        if (!klasse?.Angebot) return;

        const ausbildungen = Array.isArray(klasse.Ausbildungen) ? klasse.Ausbildungen : [];

        ausbildungen.forEach(ausbildung => {
          const beginnAge = parseFloat(ausbildung.Ausbildungsbeginn);
          if (isNaN(beginnAge) || userAge === null || beginnAge <= userAge) return;

          if (klasse.Obergrenze && userAge > klasse.Obergrenze) return;

          if (selectedLicenses?.length) {
            const hasGrundwissen = selectedLicenses.some(license => license.Grundwissen);
            if (hasGrundwissen && ausbildung.Grundwissen) return;
            if (!hasGrundwissen && !ausbildung.Grundwissen) return;
          }

          if (!shouldShowVariant(ausbildung, selectedLicenses, klasse.id)) return;

          const ageDiff = beginnAge - userAge;
          const daysUntilStart = Math.ceil(ageDiff * 365);

          if (daysUntilStart > maxDaysUntilStart) return;

          const today = new Date();
          const startDate = new Date(today.getTime() + daysUntilStart * 24 * 60 * 60 * 1000);

          let remaining = daysUntilStart;
          const years = Math.floor(remaining / 365);
          remaining %= 365;

          const months = Math.floor(remaining / 30);
          remaining %= 30;

          const weeks = Math.floor(remaining / 7);
          const days = remaining % 7;

          const parts = [];
          if (years) parts.push(`${years} Jahr${years > 1 ? 'e' : ''}`);
          if (months) parts.push(`${months} Monat${months > 1 ? 'e' : ''}`);
          if (weeks) parts.push(`${weeks} Woche${weeks > 1 ? 'n' : ''}`);
          if (days) parts.push(`${days} Tag${days > 1 ? 'e' : ''}`);
          const durationFormatted = parts.join(' ');

          upcoming.push({
            ausbildung,
            klasse,
            category: cat,
            daysUntilStart,
            durationFormatted,
            startDateFormatted: startDate.toLocaleDateString('de-AT', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            }),
          });
        });
      });
    });

    return upcoming.sort((a, b) => a.daysUntilStart - b.daysUntilStart);
  };


  const upcomingAusbildungen = useMemo(() => getUpcomingAusbildungen(), [
    selectedCategories,
    userAge,
    selectedLicenses,
    klassen,
    selectedAusbildungId
  ]);


  useEffect(() => {
    const selectedUpcoming = upcomingAusbildungen.find(u => u.ausbildung.id === selectedAusbildungId);
    if (selectedUpcoming) {
      setEarliestUpcomingStartDate(selectedUpcoming.startDateFormatted);
      console.log('changed to ', earliestUpcomingStartDate);

    } else {
      setEarliestUpcomingStartDate(null);
    }
  }, [selectedAusbildungId, upcomingAusbildungen]);


  const getPricesForAusbildung = (ausbildungId) => {

    const mappings = ausbildungenPreise.filter((m, index) => {
      const raw = m.Ausbildungen_id;

      if (!raw) {
        return false;
      }

      const aid = typeof raw === "object" ? raw.id : raw;

      const match = Number(aid) === Number(ausbildungId);

      /* if (match) {
        console.log(`✅ Verbindung für Ausbildung ${ausbildungId}:`, m);
      } */

      return match;
    });

    if (mappings.length === 0) {
      // console.table(ausbildungenPreise);
    }

    const results = mappings
      .map((m, i) => {
        const pid = typeof m.Preise_id === "object" ? m.Preise_id.id : m.Preise_id;
        const price = preise.find((p) => p.id === pid);

        // if (!price) {
        //   console.warn(`❌ Цена с id=${pid} не найдена в preise (index ${i})`);
        // } else {
        //   console.log(`💰 Найдена цена для Preis_id ${pid}:`, price);
        // }

        return price;
      })
      .filter(Boolean);

    return results;
  };



  const getPriceCategoryById = (id) => {
    return priceCategories.find((cat) => cat.id === id);
  };

  const getCoursesForClass = (classId, kurse) => {
    const classIdInt = parseInt(classId, 10);

    const result = kurse.filter((kurs) => {

      const hasMatchingTermin = kurs.Termine?.some((termin) => {

        const hasMatchingKlasse = termin.Modul?.Klassen?.some((k) => {
          return k.Klassen_id === classIdInt;
        });

        return hasMatchingKlasse;
      });

      return hasMatchingTermin;
    });

    return result;
  };



  const [expandedCourses, setExpandedCourses] = useState(new Set());
  const toggleCourse = (courseId) => {
    setExpandedCourses((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(courseId)) {
        newSet.delete(courseId);
      } else {
        newSet.add(courseId);
      }
      return newSet;
    });
  };



  const extractAusbildungDetails = async function (data) {
    const blocks = data?.Blocks || [];
    const preise = data?.Preise || [];

    let theorieContent = null;
    let praxisContent = null;
    let formattedPrices = null;

    if (Array.isArray(blocks)) {
      const ausbildungsverlaufBlock = blocks.find(
        (block) => block.collection === "Ausbildungsverlauf"
      );

      if (ausbildungsverlaufBlock && ausbildungsverlaufBlock.item?.Ablauf) {
        const ablaufArray = ausbildungsverlaufBlock.item.Ablauf;

        const theorieAblauf = ablaufArray.find(
          (step) => step.collection === "Theorie"
        );
        theorieContent = theorieAblauf?.item?.Content || null;

        const praxisAblauf = ablaufArray.find(
          (step) => step.collection === "Praxis"
        );
        praxisContent = praxisAblauf?.item?.Content || null;
      }
    }

    if (Array.isArray(preise)) {
      formattedPrices = preise
        .map((p) => {
          const zusatzText = p.Zusatz ? ` – <strong>${p.Zusatz}</strong>` : "";
          return `• ${p.kategorieName}: ${p.preis} €<br>(${p.kategorieBeschreibung})${zusatzText}`;
        })
        .join("<br><br>");
    }

    return {
      theorieContent,
      praxisContent,
      formattedPrices,
    };
  };

  const validateStep6 = () => {
    const newErrors = {};
    if (!firstName.trim()) newErrors.firstName = true;
    if (!lastName.trim()) newErrors.lastName = "Nachname ist Pflicht";
    if (!isAngebotForAgree) {
      if (!email.trim()) newErrors.email = "Email ist Pflicht";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
        newErrors.email = "Ungültige E-Mail";
      else if (email.trim() !== email2.trim()) newErrors.email = "Die E-Mail Adressen stimmen nicht überein";
    }
    if (!telefon.trim()) newErrors.telefon = "Telefonnummer ist Pflicht";
    if (!agbChecked) newErrors.agbChecked = "Bitte AGBs akzeptieren";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep7 = () => {
    const newErrors = {};
    if (!selectedPreis) newErrors.price = "Wähle eine Option"
    if (!firstName.trim()) newErrors.firstName = "Vorname ist Pflicht";
    if (!lastName.trim()) newErrors.lastName = "Nachname ist Pflicht";
    if (!birthDate) newErrors.birthDate = "Geburtsdatum ist Pflicht";
    if (!geburtsort.trim()) newErrors.geburtsort = "Geburtsort ist Pflicht";
    if (!staatsbuergerschaft.trim()) newErrors.staatsbuergerschaft = "Staatsbürgerschaft ist Pflicht";
    if (!strasse.trim()) newErrors.strasse = "Straße ist Pflicht";
    if (!hausnummer.trim()) newErrors.hausnummer = "Hausnummer ist Pflicht";
    if (!plz.trim()) newErrors.plz = "PLZ ist Pflicht";
    if (!ort.trim()) newErrors.ort = "Ort ist Pflicht";
    if (!email.trim()) newErrors.email = "Email ist Pflicht";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      newErrors.email = "Ungültige E-Mail Adresse";
    if (!telefon.trim()) newErrors.telefon = "Telefonnummer ist Pflicht";
    if (!agbChecked) newErrors.agbChecked = "Bitte AGBs akzeptieren";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const variantPrices = useMemo(() => {
    if (!chosenVariant) return [];
    return getPricesForAusbildung(chosenVariant.id);
  }, [chosenVariant, ausbildungenPreise, preise]);


  // const handleSubmit = async (e) => {

  //   if (!validateStep7()) {
  //     return;
  //   }

  //   e.preventDefault();
  //   setSubmitting(true);
  //   setSubmissionError(null);
  //   setSubmissionSuccess(false);

  //   let uploadedFiles = [];
  //   let signatureFileId = null;

  //   const selectedCategoriesIds = selectedCategories.map((cat) => cat.id);
  //   let foundAusbildung = null;

  //   if (selectedAusbildungCombiId) {
  //     foundAusbildung = getVariantById(selectedAusbildungCombiId);
  //   } else {
  //     foundAusbildung = getSelectedAusbildungVariant();
  //   }

  //   if (!foundAusbildung && futureEd) {
  //     const upcomingItem = upcomingAusbildungen.find(
  //       (u) => String(u.ausbildung.id) === String(selectedAusbildungId)
  //     );
  //     if (upcomingItem) {
  //       foundAusbildung = upcomingItem.ausbildung;
  //       setStartDate(new Date(upcomingItem.startDateFormatted));
  //     }
  //   }

  //   let placeName = null;
  //   let foundPlace = null;

  //   if (selectedPlace === "egal") {
  //     placeName = "egal";
  //   } else {
  //     foundPlace = places.find((p) => String(p.id) === String(selectedPlace));
  //     placeName = foundPlace?.Kurzname ?? null;
  //   }

  //   const relatedClass = foundAusbildung
  //     ? getClassForAusbildung(foundAusbildung.id)
  //     : null;

  //   let relatedCourses = [];
  //   if (!relatedClass && foundAusbildung) {
  //     const relatedClassIds = new Set();
  //     kombinationen.forEach((kombi) => {
  //       if (kombi.Ausbildungen?.some((a) => a.id === foundAusbildung.id)) {
  //         klassenKombinationen.forEach((mapping) => {
  //           if (
  //             mapping.Kombinationen_id?.id === kombi.id &&
  //             mapping.Klassen_id?.id
  //           ) {
  //             relatedClassIds.add(mapping.Klassen_id.id);
  //           }
  //         });
  //       }
  //     });
  //     relatedCourses = Array.from(relatedClassIds).flatMap((cid) =>
  //       getCoursesForClass(cid, kurse)
  //     );
  //   } else if (relatedClass) {
  //     relatedCourses = getCoursesForClass(relatedClass.id, kurse);
  //   }

  //   const foundFerienKurs = relatedCourses.find(
  //     (kurs) => kurs.id === selectedFerienKurs
  //   );
  //   const foundSelectedCourse = relatedCourses.find(
  //     (kurs) => kurs.id === selectedCourse
  //   );

  //   let selectedPrices = [];
  //   let angebotPrices = [];
  //   let codePrices = [];
  //   let gutscheinId = null;
  //   let rabatt = null;

  //   if (foundAusbildung) {



  //     const variantPrices = getPricesForAusbildung(foundAusbildung.id);
  //     const today = new Date();
  //     console.log(foundAusbildung.Klasse?.id);


  //     // полезная функция, аккуратно проверяем активность акции
  //     const isAngebotActive = (price) => {
  //       if (!price.Angebot_start || !price.Angebot_end || price.Angebotspreis == null) {
  //         return false;
  //       }
  //       const start = new Date(price.Angebot_start);
  //       const end = new Date(price.Angebot_end);

  //       // включительно: от 00:00 в start до 23:59:59 в end
  //       start.setHours(0, 0, 0, 0);
  //       end.setHours(23, 59, 59, 999);

  //       return today >= start && today <= end;
  //     };


  //     selectedPrices = variantPrices.map((price) => {
  //       const priceCat = getPriceCategoryById(price.Preiskategorie);
  //       return {
  //         preis: Number(price.Preis).toFixed(2),
  //         kategorieName: priceCat?.Name ?? null,
  //         kategorieBeschreibung: priceCat?.Beschreibung ?? null,
  //         zusatz: priceCat?.Zusatz ?? null,
  //       };
  //     });



  //     // angebotPrices = variantPrices
  //     //   .filter((price) => {
  //     //     if (!price.Angebot_start || !price.Angebot_end || price.Angebotspreis == null) {
  //     //       return false;
  //     //     }
  //     //     const start = new Date(price.Angebot_start);
  //     //     const end = new Date(price.Angebot_end);
  //     //     return today >= start && today <= end;
  //     //   })
  //     //   .map((price) => {
  //     //     const priceCat = getPriceCategoryById(price.Preiskategorie);
  //     //     return {
  //     //       preis: Number(price.Angebotspreis).toFixed(2),
  //     //       kategorieName: priceCat?.Name ?? null,
  //     //       kategorieBeschreibung: priceCat?.Beschreibung ?? null,
  //     //       zusatz: priceCat?.Zusatz ?? null,
  //     //     };
  //     //   });

  //     angebotPrices = variantPrices.map((price) => {
  //       const priceCat = getPriceCategoryById(price.Preiskategorie);
  //       const useAngebot = isAngebotActive(price);
  //       const preis = useAngebot ? price.Angebotspreis : price.Preis;

  //       return {
  //         preis: Number(preis).toFixed(2),
  //         kategorieName: priceCat?.Name ?? null,
  //         kategorieBeschreibung: priceCat?.Beschreibung ?? null,
  //         zusatz: priceCat?.Zusatz ?? null,

  //         // Дополнительно (опционально, если пригодится где-то в UI/PDF):
  //         // originalPreis: Number(price.Preis).toFixed(2),
  //         // istAngebot: useAngebot,
  //         // angebot_von: price.Angebot_start ?? null,
  //         // angebot_bis: price.Angebot_end ?? null,
  //       };
  //     });


  //     if (isModerator && selectedGutscheinId && foundAusbildung?.Klasse?.id) {
  //       try {
  //         const res = await axios.get(
  //           `${process.env.REACT_APP_API_BASE_URL}/items/Gutscheincodes/${selectedGutscheinId}`,
  //           { params: { fields: '*.*' } }
  //         );
  //         const matchingCode = res.data.data;

  //         if (
  //           matchingCode &&
  //           matchingCode.Rabatt != null &&
  //           Array.isArray(matchingCode.Klassen)
  //         ) {
  //           const rabattValue = Number(matchingCode.Rabatt);
  //           const klasseId = String(foundAusbildung.Klasse.id);

  //           const isAllowedClass = matchingCode.Klassen.some(
  //             k => String(k.Klassen_id) === klasseId
  //           );

  //           if (isAllowedClass) {
  //             gutscheinId = matchingCode.id;
  //             rabatt = rabattValue;

  //             const basePrices = angebotPrices.length > 0
  //               ? angebotPrices
  //               : selectedPrices;

  //             codePrices = basePrices.map(priceObj => ({
  //               ...priceObj,
  //               preis: Math.max(0, Number(priceObj.preis) - rabattValue)
  //                 .toFixed(2),
  //             }));

  //             console.log(
  //               "✅ Gutschein vom Moderator akzeptiert:",
  //               matchingCode.Code,
  //               "für Klasse",
  //               klasseId,
  //               "- berechnet von",
  //               angebotPrices.length > 0 ? "Angebotspreisen" : "Normalpreisen"
  //             );
  //           } else {
  //             console.warn(
  //               "⚠️ Gutschein vom Moderator gültig, aber nicht für Klasse:",
  //               klasseId
  //             );
  //           }
  //         } else {
  //           console.warn("⚠️ Gutschein-ID ist ungültig oder ohne Rabatt/Klassen");
  //         }
  //       } catch (err) {
  //         console.error("Fehler beim Laden des Gutscheins für Moderator:", err);
  //       }
  //     }


  //     if (gutscheinCode.trim()) {
  //       try {
  //         const res = await axios.get(
  //           process.env.REACT_APP_API_BASE_URL + "/items/Gutscheincodes",
  //           {
  //             params: {
  //               filter: { Code: { _eq: gutscheinCode.trim() } },
  //               fields: "*.*",
  //             },
  //           }
  //         );

  //         const matchingCode = res.data.data?.[0];
  //         if (
  //           matchingCode &&
  //           matchingCode.Rabatt != null &&
  //           Array.isArray(matchingCode.Klassen)
  //         ) {
  //           const rabattValue = Number(matchingCode.Rabatt);
  //           const klasseId = foundAusbildung?.Klasse?.id;

  //           const isAllowedClass = matchingCode.Klassen.some(
  //             (k) => String(k.Klassen_id) === String(klasseId)
  //           );

  //           if (isAllowedClass) {
  //             gutscheinId = matchingCode.id;
  //             rabatt = rabattValue;

  //             const basePrices =
  //               angebotPrices.length > 0 ? angebotPrices : selectedPrices;

  //             codePrices = basePrices.map((priceObj) => ({
  //               ...priceObj,
  //               preis: Math.max(0, Number(priceObj.preis) - rabattValue).toFixed(2),
  //             }));

  //             console.log(
  //               "✅ Gutschein akzeptiert:",
  //               gutscheinCode,
  //               "für Klasse",
  //               klasseId,
  //               "- berechnet von",
  //               angebotPrices.length > 0 ? "Angebotspreisen" : "Normalpreisen"
  //             );
  //           } else {
  //             console.warn("⚠️ Gutschein gültig, aber nicht für Klasse:", klasseId);
  //           }
  //         } else {
  //           console.warn("⚠️ Kein gültiger Gutschein gefunden:", gutscheinCode);
  //         }
  //       } catch (err) {
  //         console.error("Fehler beim Prüfen des Gutscheincodes:", err);
  //       }
  //     }
  //   }



  //   let ausbildungDetailData = null;
  //   let ausbildungExtracted = null;
  //   if (foundAusbildung) {
  //     try {
  //       const res = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/items/Ausbildungen/${foundAusbildung.id}?fields=*,Blocks.*,Blocks.item.*,Blocks.item.Ablauf.*,Blocks.item.Ablauf.item.*,Preise.*,Fragen.*,Fragen.Fragen_id.*`
  //       );
  //       ausbildungDetailData = res.data.data;
  //       ausbildungExtracted = await extractAusbildungDetails(ausbildungDetailData);
  //     } catch (err) {
  //       console.error("Fehler beim Laden der Ausbildung-Details", err);
  //     }
  //   }

  //   const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

  //   const payload = {
  //     vorname: firstName,
  //     nachname: lastName,
  //     email,
  //     telefon,
  //     strasse,
  //     hausnummer,
  //     plz,
  //     ort,
  //     geburtsort,
  //     geburtsDatum: birthDate ?? null,
  //     alter: userAge,
  //     applyAgeFilter,
  //     kategorien: selectedCategoriesIds,
  //     anfrage_ausbildung: foundAusbildung?.id ?? null,
  //     ausgewaehlterOrt:
  //       selectedPlace === "egal" ? "egal" : foundPlace?.id ?? null,
  //     ferien_kurs: foundFerienKurs?.id ?? null,
  //     fuehrerscheine: selectedLicenses.map((license) => ({
  //       Fuehrerscheine_id: license.id,
  //     })),
  //     // preise: selectedPrices,
  //     // angebot_preise: angebotPrices,
  //     // code_preise: codePrices.length > 0 ? codePrices : null,
  //     gutschein: gutscheinId,
  //     kurs_reservierung: null,
  //     ausbildung_blocks: ausbildungDetailData?.Blocks || [],
  //     ausbildung_fragen: ausbildungDetailData?.Fragen || [],
  //     ausbildung_theorie: ausbildungExtracted?.theorieContent || null,
  //     ausbildung_praxis: ausbildungExtracted?.praxisContent || null,
  //     unterschrift: null,
  //     anhaenge: [],
  //     moderator: false
  //   };

  //   if (user) {
  //     payload.fuehrerscheinNummer = fuehrerscheinNummer;
  //     payload.ausgewaehlterPreis = selectedPreis;
  //     payload.status = "published";
  //     payload.moderator = true;
  //     payload.rabatt = rabatt;
  //     payload.endpreis = finalPreis;
  //   }



  //   try {
  //     let angebotId = angebotAnfrageId;
  //     let angebotCreatedFormatted = angebotCreatedAt;
  //     const isFirstSubmit = !angebotAnfrageId;
  //     const isAuftragPhase = !isFirstSubmit && isModerator;


  //     if (!angebotAnfrageId) {
  //       const response = await axios.post(
  //         process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage",
  //         payload,
  //         { headers }
  //       );
  //       angebotId = response.data.data.id;
  //       setAngebotAnfrageId(angebotId);
  //       angebotCreatedFormatted = (() => {
  //         const d = new Date(response.data.data.date_created);
  //         return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
  //       })();
  //       setAngebotCreatedAt(angebotCreatedFormatted);

  //     } else {
  //       console.log("➡️ PATCH payload", {
  //         ...payload,
  //         ...(isAuftragPhase ? { auftrag: true } : {}),
  //       });
  //       console.log("isAuftragPhase =", isAuftragPhase);

  //       await axios.patch(
  //         `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotAnfrageId}`,
  //         {
  //           ...payload,
  //           ...(isAuftragPhase ? { auftrag: true } : {}),
  //         },
  //         { headers }
  //       );
  //     }


  //     let folderId = null;

  //     if (!isAuftragPhase) {
  //       const folderParentRes = await axios.get(
  //         process.env.REACT_APP_API_BASE_URL + "/folders",
  //         { params: { filter: { name: { _eq: "Angebot" } } } }
  //       );
  //       const parentFolderId = folderParentRes.data.data?.[0]?.id;

  //       const today = new Date();
  //       const formattedToday = `${String(today.getDate()).padStart(2, "0")}.${String(today.getMonth() + 1).padStart(2, "0")}.${today.getFullYear()}`;

  //       const folderCheck = await axios.get(
  //         process.env.REACT_APP_API_BASE_URL + "/folders",
  //         {
  //           params: {
  //             filter: {
  //               name: { _eq: `${formattedToday} - Anfrage ${angebotId}` },
  //               parent: { _eq: parentFolderId },
  //             },
  //           },
  //           headers,
  //         }
  //       );

  //       if (folderCheck.data.data.length > 0) {
  //         folderId = folderCheck.data.data[0].id;
  //       } else {
  //         const folderRes = await axios.post(
  //           process.env.REACT_APP_API_BASE_URL + "/folders",
  //           {
  //             name: `${formattedToday} - Anfrage ${angebotId}`,
  //             parent: parentFolderId || null,
  //           },
  //           { headers }
  //         );
  //         folderId = folderRes.data.data.id;
  //       }
  //     }

  //     if (isAuftragPhase && !folderId) {
  //       const auftragParentRes = await axios.get(
  //         process.env.REACT_APP_API_BASE_URL + "/folders",
  //         { params: { filter: { name: { _eq: "Auftrag" } } }, headers }
  //       );
  //       const auftragParentId = auftragParentRes.data.data?.[0]?.id;

  //       const folderName = `${angebotCreatedFormatted} - Anfrage ${angebotId}`;
  //       const folderCheck = await axios.get(
  //         process.env.REACT_APP_API_BASE_URL + "/folders",
  //         {
  //           params: {
  //             filter: {
  //               name: { _eq: folderName },
  //               parent: { _eq: auftragParentId },
  //             },
  //           },
  //           headers,
  //         }
  //       );

  //       if (folderCheck.data.data.length > 0) {
  //         folderId = folderCheck.data.data[0].id;
  //       } else {
  //         // console.warn("⚠️");
  //       }
  //     }

  //     if (signatureData) {
  //       const blob = await (await fetch(signatureData)).blob();
  //       const formData = new FormData();
  //       formData.append("file", blob, `unterschrift-${firstName}-${lastName}.png`);

  //       const res = await axios.post(
  //         process.env.REACT_APP_API_BASE_URL + "/files",
  //         formData,
  //         { headers }
  //       );
  //       signatureFileId = res.data.data.id;

  //       await axios.patch(
  //         `${process.env.REACT_APP_API_BASE_URL}/files/${signatureFileId}`,
  //         { folder: folderId },
  //         { headers }
  //       );

  //       await axios.patch(
  //         `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
  //         { unterschrift: signatureFileId },
  //         { headers }
  //       );
  //     }

  //     if (attachments.length > 0) {
  //       const uploads = await Promise.all(
  //         attachments.map(async (file) => {
  //           const formData = new FormData();
  //           formData.append("file", file);

  //           const res = await axios.post(
  //             process.env.REACT_APP_API_BASE_URL + "/files",
  //             formData,
  //             { headers }
  //           );

  //           const fileId = res.data.data.id;

  //           await axios.patch(
  //             `${process.env.REACT_APP_API_BASE_URL}/files/${fileId}`,
  //             { folder: folderId },
  //             { headers }
  //           );

  //           return { id: fileId };
  //         })
  //       );
  //       uploadedFiles = uploads;
  //     }

  //     const allFileIds = [...uploadedFiles];
  //     if (signatureFileId) {
  //       allFileIds.push({ id: signatureFileId });
  //     }

  //     await Promise.all(
  //       allFileIds.map((fileObj) =>
  //         axios.post(
  //           process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage_files_1",
  //           {
  //             Angebot_Anfrage_id: angebotId,
  //             directus_files_id: fileObj.id,
  //           },
  //           { headers }
  //         )
  //       )
  //     );

  //     if (foundSelectedCourse) {
  //       const response2 = await axios.post(
  //         process.env.REACT_APP_API_BASE_URL + "/items/Kursreservierungen",
  //         {
  //           Name: firstName,
  //           Email: email,
  //           Kurs: foundSelectedCourse.id,
  //           Absende_Seite: "Angebot",
  //         },
  //         { headers }
  //       );
  //       const kursReservierungId = response2.data.data.id;

  //       await axios.patch(
  //         `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
  //         { kurs_reservierung: { id: kursReservierungId } },
  //         { headers }
  //       );
  //     }

  //     const finalPayload = {
  //       titel,
  //       geschlecht,
  //       firstName,
  //       lastName,
  //       birthDate,
  //       geburtsort,
  //       staatsbuergerschaft,
  //       strasse,
  //       hausnummer,
  //       plz,
  //       ort,
  //       email,
  //       telefon,
  //       fuehrerscheinNummer,
  //       anfrage_ausbildung: payload.anfrage_ausbildung,
  //       ausgewaehlterOrt: payload.ausgewaehlterOrt,
  //       ferien_kurs: payload.ferien_kurs,
  //       fuehrerscheine: payload.fuehrerscheine,
  //       preise: payload.preise,
  //       angebot_preise: payload.angebot_preise,
  //       code_preise: payload.code_preise,
  //       ausbildung_theorie: payload.ausbildung_theorie,
  //       ausbildung_praxis: payload.ausbildung_praxis,
  //       ausbildung_blocks: payload.ausbildung_blocks,
  //       ausgewaehlterPreis: selectedPreis,
  //       angebotId,
  //       angebotCreatedAt: angebotCreatedFormatted,
  //       klass: foundAusbildung?.Klasse?.Name ?? '-',
  //       variant: foundAusbildung?.Name ?? '-',
  //       variantName: foundAusbildung?.Name ?? '-',
  //       rabatt,
  //       endpreis: finalPreis,
  //     };


  //     if (isAuftragPhase) {
  //       setSavedSummary2Data({
  //         ...finalPayload,
  //         timestamp: Date.now(),
  //       });
  //     } else {
  //       setSavedSummaryData({
  //         ...finalPayload,
  //         timestamp: Date.now(),
  //       });
  //       setSaved(true);
  //     }

  //     setIsEditing(false);

  //     try {
  //       const angebotRes = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
  //         { headers }
  //       );

  //       const linkPdf = angebotRes.data.data?.linkPdf;

  //       if (linkPdf) {
  //         setSavedSummaryData((prev) => ({
  //           ...prev,
  //           linkPdf,
  //           timestamp: Date.now(),
  //         }));
  //       } else {
  //         console.warn("PDF wurde noch nicht generiert.");
  //       }
  //     } catch (err) {
  //       console.error("Fehler beim Abrufen des PDF-Links:", err);
  //     }


  //     setSubmissionSuccess(true);
  //     onSubmissionSuccess?.(true);
  //   } catch (error) {
  //     console.error("Submission error:", error);
  //     setSubmissionError(error.message || "Fehler beim Senden der Anfrage");
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const handleSignatureSubmit = () => {
    if (!validateStep7()) {
      window.scrollTo(0, 0);
      return;
    }

    setShowSignatureModal(true);
  }

  const handleSubmit = async (e) => {
    if(isAngebotForAgree) {
      if (!validateStep7()) {
        window.scrollTo(0, 0);
        return;
      }
    } else {
      if (!validateStep6()) {
        window.scrollTo(0, 0);
        return;
      }
    }

    e.preventDefault();
    setSubmitting(true);
    setSubmissionError(null);
    setSubmissionSuccess(false);

    const parseMaybe = (v) =>
      typeof v === "string" ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v;

    let uploadedFiles = [];
    let signatureFileId = null;

    const selectedCategoriesIds = selectedCategories.map((cat) => cat.id);
    let foundAusbildung = null;

    console.log(selectedAusbildungCombiId);
    // 1) Ausbildung
    if (selectedAusbildungCombiId) {
      foundAusbildung = getVariantById(selectedAusbildungCombiId);
    } else {
      foundAusbildung = getSelectedAusbildungVariant();
    }

    // foundAusbildung = getSelectedAusbildungVariant();

    console.log(foundAusbildung);

    if (!foundAusbildung && futureEd) {
      const upcomingItem = upcomingAusbildungen.find(
        (u) => String(u.ausbildung.id) === String(selectedAusbildungId)
      );
      if (upcomingItem) {
        foundAusbildung = upcomingItem.ausbildung;
        setStartDate(new Date(upcomingItem.startDateFormatted));
      }
    }

    // 2) Место
    let placeName = null;
    let foundPlace = null;
    if (selectedPlace === "egal") {
      placeName = "egal";
    } else {
      foundPlace = places.find((p) => String(p.id) === String(selectedPlace));
      placeName = foundPlace?.Kurzname ?? null;
    }

    // 3) Курсы по классу
    const relatedClass = foundAusbildung ? getClassForAusbildung(foundAusbildung.id) : null;
    let relatedCourses = [];
    if (!relatedClass && foundAusbildung) {
      const relatedClassIds = new Set();
      kombinationen.forEach((kombi) => {
        if (kombi.Ausbildungen?.some((a) => a.id === foundAusbildung.id)) {
          klassenKombinationen.forEach((mapping) => {
            if (mapping.Kombinationen_id?.id === kombi.id && mapping.Klassen_id?.id) {
              relatedClassIds.add(mapping.Klassen_id.id);
            }
          });
        }
      });
      relatedCourses = Array.from(relatedClassIds).flatMap((cid) => getCoursesForClass(cid, kurse));
    } else if (relatedClass) {
      relatedCourses = getCoursesForClass(relatedClass.id, kurse);
    }

    const foundFerienKurs = relatedCourses.find((kurs) => kurs.id === selectedFerienKurs);
    const foundSelectedCourse = relatedCourses.find((kurs) => kurs.id === selectedCourse);

    // 4) Детали Ausbildung (для PDF/UI)
    let ausbildungDetailData = null;
    let ausbildungExtracted = null;
    if (foundAusbildung) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/items/Ausbildungen/${foundAusbildung.id}?fields=*,Blocks.*,Blocks.item.*,Blocks.item.Ablauf.*,Blocks.item.Ablauf.item.*,Preise.*,Fragen.*,Fragen.Fragen_id.*`
        );
        ausbildungDetailData = res.data.data;
        ausbildungExtracted = await extractAusbildungDetails(ausbildungDetailData);
      } catch (err) {
        console.error("Fehler beim Laden der Ausbildung-Details", err);
      }
    }

    // 5) Заголовки
    const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

    // --- helper: резолвим gutschein ID для любого юзера ---
    const resolveGutscheinId = async () => {
      // 1) приоритет — явный выбор (у модератора / или если ты где-то в UI уже сохранил ID)
      if (selectedGutscheinId) return selectedGutscheinId;

      // 2) иначе — ищем по введённому коду (гость)
      const code = (gutscheinCode ?? "").trim();
      if (!code) return null;

      try {
        const { data } = await axios.get(
          process.env.REACT_APP_API_BASE_URL + "/items/Gutscheincodes",
          { params: { filter: { Code: { _eq: code } }, fields: "id" }, headers }
        );
        return data?.data?.[0]?.id ?? null;
      } catch (err) {
        console.error("Fehler beim Lookup Gutscheincode:", err);
        return null;
      }
    };

    const normalizedBirthDate =
      typeof birthDate === "string" && birthDate.trim() === ""
        ? null
        : birthDate ?? null;


    // 6) Payload БЕЗ ЦЕН + gutschein (ID)
    const gutscheinIdToSend = await resolveGutscheinId();

    const payload = {
      vorname: firstName,
      nachname: lastName,
      email,
      telefon,
      strasse,
      hausnummer,
      plz,
      ort,
      geburtsort,
      // geburtsDatum: birthDate ?? null,
      geburtsDatum: normalizedBirthDate,

      alter: userAge,
      // applyAgeFilter,
      // kategorien: selectedCategoriesIds,
      anfrage_ausbildung: foundAusbildung?.id || selectedAusbildungId || null,
      // ausgewaehlterOrt: selectedPlace === "egal" ? "egal" : foundPlace?.id ?? null,
      ferien_kurs: foundFerienKurs?.id ?? null,
      fuehrerscheine: selectedLicenses.map((license) => ({ Fuehrerscheine_id: license.id })),
      // ЦЕНЫ НЕ ОТПРАВЛЯЕМ
      gutschein: gutscheinIdToSend, // <-- теперь будет ID и для гостя, и для модера
      kurs_reservierung: null,
      // ausbildung_blocks: ausbildungDetailData?.Blocks || [],
      // ausbildung_fragen: ausbildungDetailData?.Fragen || [],
      ausbildung_theorie: selectedAusbildungTheorie || null,
      ausbildung_praxis: selectedAusbildungPraxis || null,
      ausbildung_preisinfo: foundAusbildung?.Preisinformationen || null,
      // unterschrift: null,
      signature: null,
      // anhaenge: [],
      // moderator: !!isModerator,
    };

    if (isModerator) {
      payload.fuehrerscheinNummer = fuehrerscheinNummer; // проверь именование поля
      payload.ausgewaehlterPreis = selectedPreis;
      payload.status = "published";
      // rabatt/endpreis посчитает flow
    }

    try {
      // 7) Создать/обновить запись
      let angebotId = angebotAnfrageId;
      let angebotCreatedFormatted = angebotCreatedAt;
      const isFirstSubmit = !angebotAnfrageId;
      const isAuftragPhase = !isFirstSubmit;

      if (!angebotAnfrageId) {
        const response = await axios.post(
          process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage",
          payload,
          { headers }
        );
        angebotId = response.data.data.id;
        setAngebotAnfrageId(angebotId);
        angebotCreatedFormatted = (() => {
          const d = new Date(response.data.data.date_created);
          return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
        })();
        setAngebotCreatedAt(angebotCreatedFormatted);
      } else {
        await axios.patch(
          `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotAnfrageId}`,
          { ...payload/* , ...(isAuftragPhase ? { auftrag: true } : {}) */ },
          { headers }
        );
        angebotId = angebotAnfrageId;
      }

      // 8) Папка и файлы
      let folderId = null;

      if (!isAuftragPhase) {
        const folderParentRes = await axios.get(
          process.env.REACT_APP_API_BASE_URL + "/folders",
          { params: { filter: { name: { _eq: "Angebot" } } } }
        );
        const parentFolderId = folderParentRes.data.data?.[0]?.id;

        const today = new Date();
        const formattedToday = `${String(today.getDate()).padStart(2, "0")}.${String(today.getMonth() + 1).padStart(2, "0")}.${today.getFullYear()}`;

        const folderCheck = await axios.get(
          process.env.REACT_APP_API_BASE_URL + "/folders",
          {
            params: {
              filter: {
                name: { _eq: `${formattedToday} - Anfrage ${angebotId}` },
                parent: { _eq: parentFolderId },
              },
            },
            headers,
          }
        );

        if (folderCheck.data.data.length > 0) {
          folderId = folderCheck.data.data[0].id;
        } else {
          const folderRes = await axios.post(
            process.env.REACT_APP_API_BASE_URL + "/folders",
            { name: `${formattedToday} - Anfrage ${angebotId}`, parent: parentFolderId || null },
            { headers }
          );
          folderId = folderRes.data.data.id;
        }
      }

      if (isAuftragPhase && !folderId) {
        const auftragParentRes = await axios.get(
          process.env.REACT_APP_API_BASE_URL + "/folders",
          { params: { filter: { name: { _eq: "Auftrag" } } }, headers }
        );
        const auftragParentId = auftragParentRes.data.data?.[0]?.id;

        const folderName = `${angebotCreatedFormatted} - Anfrage ${angebotId}`;
        const folderCheck = await axios.get(
          process.env.REACT_APP_API_BASE_URL + "/folders",
          {
            params: { filter: { name: { _eq: folderName }, parent: { _eq: auftragParentId } } },
            headers,
          }
        );

        if (folderCheck.data.data.length > 0) {
          folderId = folderCheck.data.data[0].id;
        }
      }

      // подпись
      if (signatureData) {
        const blob = await (await fetch(signatureData)).blob();
        const formData = new FormData();
        formData.append("file", blob, `unterschrift-${firstName}-${lastName}.png`);

        const res = await axios.post(
          process.env.REACT_APP_API_BASE_URL + "/files",
          formData,
          { headers }
        );
        signatureFileId = res.data.data.id;

        await axios.patch(
          `${process.env.REACT_APP_API_BASE_URL}/files/${signatureFileId}`,
          { folder: folderId },
          { headers }
        );

        await axios.patch(
          `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
          { unterschrift: signatureFileId },
          { headers }
        );
      }

      // вложения
      if (attachments.length > 0) {
        const uploads = await Promise.all(
          attachments.map(async (file) => {
            const formData = new FormData();
            formData.append("file", file);

            const res = await axios.post(
              process.env.REACT_APP_API_BASE_URL + "/files",
              formData,
              { headers }
            );

            const fileId = res.data.data.id;

            await axios.patch(
              `${process.env.REACT_APP_API_BASE_URL}/files/${fileId}`,
              { folder: folderId },
              { headers }
            );

            return { id: fileId };
          })
        );
        uploadedFiles = uploads;
      }

      const allFileIds = [...uploadedFiles];
      if (signatureFileId) allFileIds.push({ id: signatureFileId });

      await Promise.all(
        allFileIds.map((fileObj) =>
          axios.post(
            process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage_files_1",
            { Angebot_Anfrage_id: angebotId, directus_files_id: fileObj.id },
            { headers }
          )
        )
      );

      // курс-резервирование
      if (foundSelectedCourse) {
        const response2 = await axios.post(
          process.env.REACT_APP_API_BASE_URL + "/items/Kursreservierungen",
          { Name: firstName, Email: email, Kurs: foundSelectedCourse.id, Absende_Seite: "Angebot" },
          { headers }
        );
        const kursReservierungId = response2.data.data.id;

        await axios.patch(
          `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
          { kurs_reservierung: { id: kursReservierungId } },
          { headers }
        );
      }

      // // 9) Читаем запись обратно
      // const PUBLIC_FIELDS = [
      //   "id","status","date_created","date_updated",
      //   "linkPdf",
      //   "ausbildung_theorie","ausbildung_praxis",
      //   "anfrage_ausbildung","ausgewaehlterPreis"
      // ];
      // const MOD_ONLY_FIELDS = [
      //   "preise","angebot_preise","code_preise","rabatt","endpreis",
      //   "ausbildung_blocks"
      // ];

      // let fields = (isModerator ? PUBLIC_FIELDS.concat(MOD_ONLY_FIELDS) : PUBLIC_FIELDS).join(",");

      // let rec;
      // try {
      //   const angebotRes = await axios.get(
      //     `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
      //     { params: { fields }, headers }
      //   );
      //   rec = angebotRes.data.data;
      // } catch (err) {
      //   if (err?.response?.status === 403) {
      //     const fallbackFields = PUBLIC_FIELDS.join(",");
      //     const angebotRes2 = await axios.get(
      //       `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
      //       { params: { fields: fallbackFields }, headers }
      //     );
      //     rec = angebotRes2.data.data;
      //   } else {
      //     throw err;
      //   }
      // }

      // // 10) Собираем финальный payload
      // const finalPayload = {
      //   titel,
      //   geschlecht,
      //   firstName,
      //   lastName,
      //   birthDate,
      //   geburtsort,
      //   staatsbuergerschaft,
      //   strasse,
      //   hausnummer,
      //   plz,
      //   ort,
      //   email,
      //   telefon,
      //   fuehrerscheinNummer,
      //   anfrage_ausbildung: foundAusbildung?.id ?? null,
      //   ausgewaehlterOrt: payload.ausgewaehlterOrt,
      //   ferien_kurs: payload.ferien_kurs,
      //   fuehrerscheine: payload.fuehrerscheine,
      //   // блоки/теория/практика — из отправленного payload
      //   ausbildung_theorie: payload.ausbildung_theorie,
      //   ausbildung_praxis:  payload.ausbildung_praxis,
      //   ausbildung_blocks:  payload.ausbildung_blocks,
      //   ausgewaehlterPreis: selectedPreis,
      //   angebotId,
      //   angebotCreatedAt: (() => {
      //     const d = new Date(rec.date_created);
      //     return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
      //   })(),
      //   klass: foundAusbildung?.Klasse?.Name ?? "-",
      //   variant: foundAusbildung?.Name ?? "-",
      //   variantName: foundAusbildung?.Name ?? "-",
      //   ...(isModerator ? {
      //     preise:         parseMaybe(rec?.preise) ?? null,
      //     angebot_preise: parseMaybe(rec?.angebot_preise) ?? null,
      //     code_preise:    parseMaybe(rec?.code_preise) ?? null,
      //     rabatt:         rec?.rabatt ?? null,
      //     endpreis:       rec?.endpreis ?? null,
      //   } : {}),
      // };

      // 9) Читаем запись обратно — многошагово и безопасно
      const PUBLIC_FIELDS = [
        "id", "status", "date_created", "date_updated",
        "linkPdf",
        "ausbildung_theorie", "ausbildung_praxis",
        "anfrage_ausbildung", "ausgewaehlterPreis"
      ];

      const MOD_PRICE_FIELDS = [
        "id", // всегда добавляем id, чтобы смержить
        "preise", "angebot_preise", "code_preise", "rabatt", "endpreis"
      ];

      const MOD_BLOCKS_FIELDS = [
        "id",
        "ausbildung_blocks"
      ];

      // удобный хелпер: безопасно получить подмножество полей
      const safeFetchFields = async (id, fieldsArr) => {
        try {
          const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${id}`,
            { params: { fields: fieldsArr.join(",") }, headers }
          );
          return data?.data || {};
        } catch (err) {
          if (err?.response?.status !== 403) {
            // если это не 403 — пусть всплывает (реальная ошибка сети/сервера)
            throw err;
          }
          // 403 — просто возвращаем пусто, значит роль не видит эти поля
          return {};
        }
      };

      // 1) всегда берём публичные поля
      let rec = await safeFetchFields(angebotId, PUBLIC_FIELDS);

      // check when prices are public
      const recPrices = await safeFetchFields(angebotId, MOD_PRICE_FIELDS);
        rec = { ...rec, ...recPrices };

      // 2) если модератор — пробуем отдельно подтянуть ценовые поля
      if (isModerator) {

        // 3) и отдельно — блоки (если у роли есть доступ)
        const recBlocks = await safeFetchFields(angebotId, MOD_BLOCKS_FIELDS);
        rec = { ...rec, ...recBlocks };
      }

      // --- дальше как у тебя было: сбор финального payload ---
      const parseMaybe = (v) =>
        typeof v === "string" ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v;

      const finalPayload = {
        titel,
        geschlecht,
        firstName,
        lastName,
        birthDate,
        geburtsort,
        staatsbuergerschaft,
        strasse,
        hausnummer,
        plz,
        ort,
        email,
        telefon,
        fuehrerscheinNummer,
        anfrage_ausbildung: foundAusbildung?.id ?? null,
        ausgewaehlterOrt: payload.ausgewaehlterOrt,
        ferien_kurs: payload.ferien_kurs,
        fuehrerscheine: payload.fuehrerscheine,
        // блоки/теория/практика — из отправленного payload
        ausbildung_theorie: payload.ausbildung_theorie,
        ausbildung_praxis: payload.ausbildung_praxis,
        ausbildung_preisinfo: payload.ausbildung_preisinfo,
        ausbildung_blocks: payload.ausbildung_blocks,
        ausgewaehlterPreis: selectedPreis,
        angebotId,
        angebotCreatedAt: (() => {
          const d = new Date(rec.date_created);
          return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
        })(),
        kombi: foundAusbildung?.Kombi?.Name ?? "-",
        klass: foundAusbildung?.Klasse?.Name ?? "-",
        variant: foundAusbildung?.Name ?? "-",
        variantName: foundAusbildung?.Name ?? "-",
        preise: parseMaybe(rec?.preise) ?? null,
        ...(isModerator ? {  
          angebot_preise: parseMaybe(rec?.angebot_preise) ?? null,
          code_preise: parseMaybe(rec?.code_preise) ?? null,
          rabatt: rec?.rabatt ?? null,
          endpreis: rec?.endpreis ?? null,
          // если и blocks удалось прочитать — payload.ausbildung_blocks у тебя и так уже есть из POST
        } : {}),
      };

      console.log(finalPayload);


      if (isAuftragPhase) {
        setSavedSummary2Data({ ...finalPayload, timestamp: Date.now() });
      } else {
        setSavedSummaryData({ ...finalPayload, timestamp: Date.now() });
        setSaved(true);
      }

      setIsEditing(false);

      // 11) Лейзиполл PDF-ссылки (опционально)
      try {
        const angebotRes2 = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
          { params: { fields: "id,linkPdf" }, headers }
        );
        const linkPdf = angebotRes2.data.data?.linkPdf;
        if (linkPdf) {
          setSavedSummaryData((prev) => ({ ...prev, linkPdf, timestamp: Date.now() }));
        } else {
          console.warn("PDF wurde noch nicht generiert.");
        }
      } catch (err) {
        console.error("Fehler beim Abrufen des PDF-Links:", err);
      }


      !isAuftragPhase && setSubmissionSuccess(true);
      onSubmissionSuccess?.(true);
    } catch (error) {
      console.error("Submission error:", error);
      setSubmissionError(error.message || "Fehler beim Senden der Anfrage");
    } finally {
      setSubmitting(false);
    }
  };





  const handleCheckGutschein = async () => {
    setGutscheinChecked(true);
    setGutscheinValid(false);
    setGutscheinError("");
    setGutscheinAppliedData(null);

    const trimmed = gutscheinCode.trim();

    if (!trimmed) {
      setGutscheinError("Bitte geben Sie einen Gutscheincode ein.");
      setGutscheinCode("");
      return;
    }

    try {
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/items/Gutscheincodes", {
        params: {
          filter: {
            Code: { _eq: trimmed },
          },
          fields: "*.*",
        },
      });

      const matching = res.data.data?.[0];

      if (!matching || matching.status !== "published") {
        setGutscheinError("Bitte geben Sie einen gültigen Gutscheincode ein.");
        setGutscheinCode("");
        return;
      }

      const heute = new Date();
      const start = matching.Startdatum ? new Date(matching.Startdatum) : null;
      const end = matching.Enddatum ? new Date(matching.Enddatum) : null;

      if (!start || !end || heute < start || heute > end) {
        setGutscheinError("Bitte geben Sie einen gültigen Gutscheincode ein.");
        setGutscheinCode("");
        return;
      }

      let foundAusbildung = null;
      let erlaubt = null;
      if (selectedAusbildungCombiId) {
        foundAusbildung = getVariantById(selectedAusbildungCombiId);

        console.log(matching.Klassen);
        console.log(foundAusbildung?.Kombi?.Klassen);

        erlaubt = matching.Klassen?.some(
          (k) => foundAusbildung?.Kombi?.Klassen?.some(
            (ak) => String(ak.Klassen_id) === String(k.Klassen_id)
          )
        );
      } else {
        foundAusbildung = getSelectedAusbildungVariant();
        const klasseId = foundAusbildung?.Klasse?.id;

        erlaubt = matching.Klassen?.some(
          (k) => String(k.Klassen_id) === String(klasseId)
        );
      }

      console.log(foundAusbildung);

      if (!erlaubt) {
        setGutscheinError("Bitte geben Sie einen gültigen Gutscheincode ein.");
        setGutscheinCode("");
        return;
      }


      setGutscheinValid(true);
      setGutscheinAppliedData({
        id: matching.id,
        code: matching.Code,
        rabatt: Number(matching.Rabatt),
      });
    } catch (err) {
      console.error("Fehler bei der Gutscheinprüfung:", err);
      setGutscheinError("Bitte geben Sie einen gültigen Gutscheincode ein.");
      setGutscheinCode("");
    }
  };


  //   const handleSaveSignatureAndClose = async () => {
  //     if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
  //       alert("Bitte Unterschrift eingeben.");
  //       return;
  //     }

  //     try {
  //       const dataUrl = sigPadRef.current.toDataURL('image/png');
  //       console.log("Signature dataUrl:", dataUrl.substring(0, 100));

  //       const blob = await (await fetch(dataUrl)).blob();
  //       console.log("Signature blob:", blob);

  //       const formData = new FormData();
  //       formData.append("file", blob, `unterschrift-${firstName}-${lastName}.png`);

  //       console.log("Uploading signature to Directus...");

  //       const res = await axios.post(
  //         process.env.REACT_APP_API_BASE_URL + "/files",
  //         formData,
  //         accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : {}
  //       );

  //       console.log("Upload success, fileId:", res.data.data.id);

  //       const signatureFileId = res.data.data.id;

  //       console.log("Patching Angebot_Anfrage with unterschrift...");

  //       const targetId = anfrageId ?? angebotAnfrageId;
  // if (!targetId) {
  //   alert("Keine Anfrage-ID vorhanden (weder aus Link noch aus Erstellung).");
  //   return;
  // }

  // const authHeaders = accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : {};

  // await axios.patch(
  //   `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
  //   { unterschrift: signatureFileId },
  //   authHeaders
  // );

  // await axios.post(
  //   process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage_files_1",
  //   {
  //     Angebot_Anfrage_id: targetId,
  //     directus_files_id: signatureFileId,
  //   },
  //   authHeaders
  // );


  //       console.log("Anhang linked, redirecting...");

  //       setShowSignatureModal(false);
  //       window.location.href = "/";

  //     } catch (err) {
  //       console.error("Fehler beim Speichern der Unterschrift:", err.response?.data || err.message || err);
  //       alert("Fehler beim Speichern der Unterschrift. Bitte nochmal versuchen.");
  //     }
  //   };






  // const handleSaveSignatureStep = async () => {
  //   if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
  //     alert("Bitte Unterschrift eingeben.");
  //     return;
  //   }

  //   const targetId = anfrageId ?? angebotAnfrageId;
  //   if (!targetId) {
  //     alert("Keine Anfrage-ID vorhanden (weder aus Link noch aus Erstellung).");
  //     return;
  //   }

  //   const authHeaders = accessToken
  //     ? { headers: { Authorization: `Bearer ${accessToken}` } }
  //     : {};

  //   try {
  //     const dataUrl = sigPadRef.current.toDataURL("image/png");

  //     const fileId = await uploadSignaturePng(
  //       dataUrl,
  //       `unterschrift-${sigStep === 0 ? "schueler" : "erziehungsberechtigter"}-${firstName}-${lastName}.png`
  //     );

  //     // сохраняем локально
  //     if (sigStep === 0) setSigFileStudent(fileId);
  //     if (sigStep === 1) setSigFileGuardian(fileId);

  //     // очистить canvas для следующего шага
  //     sigPadRef.current.clear();

  //     // если нужна 2-я подпись и мы только что сделали 1-ю — переключаем шаг и НЕ закрываем модалку
  //     if (needsGuardianSignature && sigStep === 0) {
  //       setSigStep(1);
  //       return;
  //     }

  //     // финальный PATCH: проставляем оба поля (или одно, если вдруг needsGuardianSignature = false)
  //     const studentId = sigStep === 0 ? fileId : sigFileStudent;
  //     const guardianId = sigStep === 1 ? fileId : sigFileGuardian;

  //     const patchPayload = {
  //       unterschrift_schueler: studentId,
  //       ...(needsGuardianSignature ? { unterschrift_erziehungsberechtigter: guardianId } : {}),
  //     };

  //     await axios.patch(
  //       `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
  //       patchPayload,
  //       authHeaders
  //     );

  //     // если ты хочешь продолжать линковать файлы через junction (как раньше) — оставь.
  //     // если не нужно — можно удалить эти POST'ы.
  //     const linkFile = (fid) =>
  //       axios.post(
  //         process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage_files_1",
  //         { Angebot_Anfrage_id: targetId, directus_files_id: fid },
  //         authHeaders
  //       );

  //     if (studentId) await linkFile(studentId);
  //     if (needsGuardianSignature && guardianId) await linkFile(guardianId);

  //     // закрыть и сбросить
  //     setShowSignatureModal(false);
  //     setSigStep(0);
  //     setSigFileStudent(null);
  //     setSigFileGuardian(null);

  //     window.location.href = "/";
  //   } catch (err) {
  //     console.error("Fehler beim Speichern der Unterschrift:", err.response?.data || err.message || err);
  //     alert("Fehler beim Speichern der Unterschrift. Bitte nochmal versuchen.");
  //   }
  // };


//   const handleSaveSignatureStep = async () => {
//   if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
//     alert("Bitte Unterschrift eingeben.");
//     return;
//   }

//   const targetId = anfrageId ?? angebotAnfrageId;
//   if (!targetId) {
//     alert("Keine Anfrage-ID vorhanden (weder aus Link noch aus Erstellung).");
//     return;
//   }

//   const authHeaders = accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : {};

//   try {
//     const dataUrl = sigPadRef.current.toDataURL("image/png");

//     // 1) upload file
//     const fileId = await uploadSignaturePng(
//       dataUrl,
//       `unterschrift-${sigStep === 0 ? "schueler" : "erziehungsberechtigter"}-${firstName}-${lastName}.png`,
//       accessToken
//     );

//     // 2) сохранить локально
//     if (sigStep === 0) setSigFileStudent(fileId);
//     if (sigStep === 1) setSigFileGuardian(fileId);

//     // 3) очистить canvas
//     sigPadRef.current.clear();

//     // 4) если нужна 2-я подпись и мы на первой — перейти к следующей
//     if (needsGuardianSignature && sigStep === 0) {
//       setSigStep(1);
//       return;
//     }

//     // 5) финальный PATCH: проставляем поля
//     let studentId = sigFileStudent;
//     let guardianId = sigFileGuardian;

//     if (sigStep === 0) studentId = fileId;
//     if (sigStep === 1) guardianId = fileId;

//     const patchPayload = {
//       unterschrift_schueler: studentId,
//       ...(needsGuardianSignature ? { unterschrift_erziehungsberechtigter: guardianId } : {}),
//     };

//     await axios.patch(
//       `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
//       patchPayload,
//       authHeaders
//     );

//     // 6) закрыть модалку и сбросить состояние
//     setShowSignatureModal(false);
//     setSigStep(0);
//     setSigFileStudent(null);
//     setSigFileGuardian(null);

//     // window.location.href = "/";
//     setUpdateMessage("✅ Danke! Unterschrift(en) erfolgreich gespeichert. Wir melden uns in Kürze per E-Mail.");

//   } catch (err) {
//     console.error("Fehler beim Speichern der Unterschrift:", err.response?.data || err.message || err);
//     alert("Fehler beim Speichern der Unterschrift. Bitte nochmal versuchen.");
//   }
// };

const API_BASE = process.env.REACT_APP_API_BASE_URL + "";

const buildAuftragDataPatch = async ({ targetId, authHeaders }) => {
  const num = (v) => {
    if (v == null) return null;
    const n = Number(String(v).replace(",", "."));
    return Number.isFinite(n) ? n : null;
  };

  const priceOf = (item) => num(item?.Preis ?? item?.preis);
  const depositOf = (item) => num(item?.Anzahlung ?? item?.anzahlung);

  const eq = (a, b, eps = 0.001) =>
    Number.isFinite(a) && Number.isFinite(b) && Math.abs(a - b) < eps;

  const parseArr = (x) => {
    if (Array.isArray(x)) return x;
    if (typeof x === "string") {
      try {
        const p = JSON.parse(x);
        return Array.isArray(p) ? p : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  // 1) тянем массивы цен ИЗ Directus (истина = в базе)
  const { data } = await axios.get(
    `${API_BASE}/items/Angebot_Anfrage/${targetId}`,
    { params: { fields: "preise,angebot_preise,code_preise" }, headers: authHeaders }
  );

  const rec = data?.data || {};
  const baseArr = parseArr(rec.preise);
  const angebotArr = parseArr(rec.angebot_preise);
  const codeArr = parseArr(rec.code_preise);

  // 2) определяем индекс выбранной карточки по значению selectedPreis
  const selVal = num(selectedPreis);
  let idx = -1;

  if (Number.isFinite(selVal)) {
    idx = codeArr.findIndex((p) => eq(priceOf(p), selVal));
    if (idx < 0) idx = angebotArr.findIndex((p) => eq(priceOf(p), selVal));
    if (idx < 0) idx = baseArr.findIndex((p) => eq(priceOf(p), selVal));
  }

  const maxLen = Math.max(baseArr.length, angebotArr.length, codeArr.length);
  if (idx < 0 && maxLen === 1) idx = 0;
  if (idx < 0) idx = 0;

  // 3) берем соответствующие элементы
  const baseItem = baseArr[idx] ?? null;
  const angebotItem = angebotArr[idx] ?? null;
  const codeItem = codeArr[idx] ?? null;

  const originalVal = priceOf(baseItem);
  const angebotVal = priceOf(angebotItem);
  const codeVal = priceOf(codeItem);

  // 4) бизнес-логика цен
  const hasAktion = Number.isFinite(angebotVal) && (angebotVal < (originalVal ?? 0) - 0.001);
  const aktionsPreis = hasAktion ? angebotVal : null;

  const baseForPromo = hasAktion ? aktionsPreis : originalVal;
  const hasPromo = Number.isFinite(codeVal) && (codeVal < (baseForPromo ?? 0) - 0.001);
  const promoPreis = hasPromo ? codeVal : null;

  const endpreis =
    (promoPreis != null) ? promoPreis :
    (aktionsPreis != null) ? aktionsPreis :
    originalVal;

  // 5) anzahlung: promo -> codeItem, иначе aktion -> angebotItem, иначе baseItem
  let selectedForDeposit = null;
  if (promoPreis != null) selectedForDeposit = codeItem || angebotItem || baseItem;
  else if (aktionsPreis != null) selectedForDeposit = angebotItem || baseItem;
  else selectedForDeposit = baseItem;

  const anzahlungVal = depositOf(selectedForDeposit);

  const geburtsDatumValue =
  birthDate instanceof Date
    ? birthDate.toISOString().slice(0, 10) // YYYY-MM-DD (для поля типа "date")
    : null;


  // 6) возвращаем payload для PATCH
  return {
    fuehrerscheinNummer,
    ausgewaehlterPreis: (originalVal != null) ? originalVal : null,
    aktionsPreis: (aktionsPreis != null) ? aktionsPreis : null,
    promoPreis: (promoPreis != null) ? promoPreis : null,
    endpreis: (endpreis != null) ? endpreis : null,
    anzahlung: (anzahlungVal != null) ? anzahlungVal : null,

    status: "delivered",

    strasse,
    telefon,
    plz,
    ort,
    hausnummer,
    geburtsort,
    geburtsDatum: geburtsDatumValue,


    ...(selectedGutscheinId ? { gutschein: selectedGutscheinId } : {}),
  };
};

// const handleSaveSignatureStep = async () => {
//   if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
//     alert("Bitte Unterschrift eingeben.");
//     return;
//   }

//   const targetId = anfrageId ?? angebotAnfrageId;
//   if (!targetId) {
//     alert("Keine Anfrage-ID vorhanden (weder aus Link noch aus Erstellung).");
//     return;
//   }

//   const authHeaders = accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : {};

//   try {
//     const dataUrl = sigPadRef.current.toDataURL("image/png");

//     // 1) upload file
//     const fileId = await uploadSignaturePng(
//       dataUrl,
//       `unterschrift-${sigStep === 0 ? "schueler" : "erziehungsberechtigter"}-${firstName}-${lastName}.png`,
//       accessToken
//     );

//     // 2) сохранить локально
//     if (sigStep === 0) setSigFileStudent(fileId);
//     if (sigStep === 1) setSigFileGuardian(fileId);

//     // 3) очистить canvas
//     sigPadRef.current.clear();

//     // 4) если нужна 2-я подпись и мы на первой — перейти к следующей
//     if (needsGuardianSignature && sigStep === 0) {
//       setSigStep(1);
//       return;
//     }

//     // 5) финальный PATCH: проставляем поля
//     let studentId = sigFileStudent;
//     let guardianId = sigFileGuardian;

//     if (sigStep === 0) studentId = fileId;
//     if (sigStep === 1) guardianId = fileId;

//     const patchPayload = {
//       unterschrift_schueler: studentId,
//       ...(needsGuardianSignature ? { unterschrift_erziehungsberechtigter: guardianId } : {}),
//     };

//     await axios.patch(
//       `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${targetId}`,
//       patchPayload,
//       authHeaders
//     );

//     // 6) ВАЖНО: после финальной подписи — сохранить ВСЕ данные (цены/поля)
//     if (typeof handleUpdateData === "function") {
//       await handleUpdateData();
//     }

//     // 7) закрыть модалку и сбросить состояние
//     setShowSignatureModal(false);
//     setSigStep(0);
//     setSigFileStudent(null);
//     setSigFileGuardian(null);

//     setUpdateMessage("✅ Danke! Unterschrift(en) + Daten erfolgreich gespeichert. Wir melden uns in Kürze per E-Mail.");
//   } catch (err) {
//     console.error("Fehler beim Speichern der Unterschrift:", err.response?.data || err.message || err);
//     alert("Fehler beim Speichern der Unterschrift. Bitte nochmal versuchen.");
//   }
// };
const handleSaveSignatureStep = async () => {
  if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
    alert("Bitte Unterschrift eingeben.");
    return;
  }

  const targetId = anfrageId ?? angebotAnfrageId;
  if (!targetId) {
    alert("Keine Anfrage-ID vorhanden (weder aus Link noch aus Erstellung).");
    return;
  }

  const authHeaders = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

  try {
    const dataUrl = sigPadRef.current.toDataURL("image/png");

    // 1) upload signature image -> fileId
    const fileId = await uploadSignaturePng(
      dataUrl,
      `unterschrift-${sigStep === 0 ? "schueler" : "erziehungsberechtigter"}-${firstName}-${lastName}.png`,
      accessToken
    );

    // 2) сохранить id подписи в ref (чтобы не зависеть от async state)
    if (sigStep === 0) {
      sigStudentIdRef.current = fileId;
      setSigFileStudent(fileId);
    } else {
      sigGuardianIdRef.current = fileId;
      setSigFileGuardian(fileId);
    }

    // 3) очистить canvas
    sigPadRef.current.clear();

    // 4) если нужна 2-я подпись и мы на первой — перейти к следующей
    if (needsGuardianSignature && sigStep === 0) {
      setSigStep(1);
      return;
    }

    // 5) финальный PATCH: ВСЕ данные + подписи за один раз
    const studentId = sigStudentIdRef.current;
    const guardianId = needsGuardianSignature ? (sigGuardianIdRef.current ?? fileId) : null;

    if (!studentId) {
      alert("Schüler-Unterschrift fehlt (interner Fehler). Bitte erneut versuchen.");
      return;
    }
    if (needsGuardianSignature && !guardianId) {
      alert("Erziehungsberechtigten-Unterschrift fehlt. Bitte erneut versuchen.");
      return;
    }

    // собрать цены/адрес/статус и т.п.
    const dataPatch = await buildAuftragDataPatch({ targetId, authHeaders });

    const patchPayload = {
      ...dataPatch,
      unterschrift_schueler: studentId,
      ...(needsGuardianSignature ? { unterschrift_erziehungsberechtigter: guardianId } : {}),
    };

    await axios.patch(
      `${API_BASE}/items/Angebot_Anfrage/${targetId}`,
      patchPayload,
      { headers: authHeaders }
    );

    // 6) закрыть модалку и сбросить состояние
    setShowSignatureModal(false);
    setSigStep(0);
    setSigFileStudent(null);
    setSigFileGuardian(null);
    sigStudentIdRef.current = null;
    sigGuardianIdRef.current = null;

    setUpdateMessage("Danke! Unterschrift(en) & Daten erfolgreich gespeichert. Du erhältst deinen Auftrag in Kürze per E-Mail.");
  } catch (err) {
    console.error("Fehler beim Speichern der Unterschrift:", err.response?.data || err.message || err);
    alert("Fehler beim Speichern der Unterschrift. Bitte nochmal versuchen.");
  }
};


  const renderHeader = () => (
    currentStep !== 0 && (
      <div className={styles['angebot-header']}>
        <div className={`${styles['steps-container']} ${currentStep === 1 && (styles['steps-category'])}`}>
          <div className={`${styles.step} ${currentStep === 1 ? styles.active : ''} ${currentStep > 1 ? styles.done : ''}`}>
            <span className={styles['step-count']}>1</span>
            <span className={styles['step-title']}>Start</span>
            <img className={styles['step-done']} src={doneIcon} alt="Erledigt!" />
          </div>
          <div className={`${styles.step} ${currentStep === 2 ? styles.active : ''} ${currentStep > 2 ? styles.done : ''}`}>
            <span className={styles['step-count']}>2</span>
            <span className={styles['step-title']}>Alter</span>
            <img className={styles['step-done']} src={doneIcon} alt="Erledigt!" />
          </div>
          <div className={`${styles.step} ${currentStep === 3 ? styles.active : ''} ${currentStep > 3 ? styles.done : ''}`}>
            <span className={styles['step-count']}>3</span>
            <span className={styles['step-title']}>Führerschein</span>
            <img className={styles['step-done']} src={doneIcon} alt="Erledigt!" />
          </div>
          <div className={`${styles.step} ${currentStep === 4 ? styles.active : ''} ${currentStep > 4 ? styles.done : ''}`}>
            <span className={styles['step-count']}>4</span>
            <span className={styles['step-title']}>Auswahl</span>
            <img className={styles['step-done']} src={doneIcon} alt="Erledigt!" />
          </div>
          <div className={`${styles.step} ${styles.optional} ${currentStep === 5 ? styles.active : ''} ${currentStep > 5 ? styles.done : ''}`}>
            <span className={styles['step-count']}>5</span>
            <span className={styles['step-title']}>Kombi</span>
            <img className={styles['step-done']} src={doneIcon} alt="Erledigt!" />
          </div>
          <div className={`${styles.step} ${currentStep === 6 ? styles.active : ''} ${currentStep > 6 ? styles.done : ''}`}>
            <span className={styles['step-count']}>6</span>
            <span className={styles['step-title']}>Daten</span>
            <img className={styles['step-done']} src={doneIcon} alt="Erledigt!" />
          </div>
          {uuid && (
            <div className={`${styles.step} ${styles.optional} ${currentStep === 7 ? styles.active : ''} ${currentStep > 7 ? styles.done : ''}`}>
              <span className={styles['step-count']}>7</span>
              <span className={styles['step-title']}>Kurs</span>
              <img className={styles['step-done']} src={doneIcon} alt="Erledigt!" />
            </div>
          )}
        </div>
      </div>
    )
  );

  const openPdfByAngebotId = async (angebotId, accessToken) => {
    const headers = accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : {};

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/items/Angebot_Anfrage/${angebotId}`,
        { headers }
      );

      const link = res.data.data?.linkPdf;

      if (link) {
        console.log("✅ Öffne PDF:", link);
        window.open(link, "_blank");
      } else {
        alert("📄 PDF wurde noch nicht generiert.");
      }
    } catch (err) {
      console.error("Fehler beim Abrufen des PDF-Links:", err);
      alert("❌ Fehler beim Laden des PDFs.");
    }
  };


  const renderSummary = () => (
    <div className={styles["angebot-summary"]}>
      <div className={styles["summary-container"]}>
        <div className={styles["step-message"]}>
          {currentStep === 1 && "Deine Route wird berechnet..."}
          {currentStep === 2 && "Nächste Kreuzung rechts abbiegen"}
          {currentStep === 3 && "Bei der Ampel links"}
          {currentStep === 4 && "Folge der Straße für 2 km"}
          {currentStep === 5 && "Alternative Route wird berechnet..."}
          {currentStep === 6 && "Fast geschafft!"}
          {currentStep === 7 && "Du bist am Ziel"}
        </div>

        <div className={styles["summary-mobile"]}>Zusammenfassung</div>

        {visibleAge && (
          <>
            <div className={`${styles["summary-angaben"]} ${currentStep !== 1 ? styles.active : ''}`}>
              <h2>Deine Angaben</h2>
              <div className={`${styles["summary-step"]} ${firstName && lastName ? styles.active : ''}`}>
                <div className={styles["summary-label"]}>Auszubildende/r</div>
                {firstName && lastName && (
                  <div className={styles["summary-value"]}>
                    {titel} {firstName} {lastName}<br />
                    <span>{email}</span>
                  </div>
                )}
              </div>
              {/* <div className={`${styles["summary-step"]} ${email ? styles.active : ''}`}>
                <div className={styles["summary-label"]}>Deine E-Mail Adresse</div>
                <div className={styles["summary-value"]}>
                  {email}
                </div>
              </div>
              <div className={`${styles["summary-step"]} ${telefon ? styles.active : ''}`}>
                <div className={styles["summary-label"]}>Deine Telefonnr.</div>
                <div className={styles["summary-value"]}>
                  {telefon}
                </div>
              </div> */}
              <div className={`${styles["summary-step"]} ${applyAgeFilter || userAge !== null ? styles.active : ''}`}>
                <div className={styles["summary-label"]}>Dein Alter</div>
                {ageDays === 0 ? (
                  <div className={styles["summary-value"]}>
                    {visibleAge} <span>Jahre</span>
                  </div>
                ) : (
                  <div className={styles["summary-value"]}>
                    {visibleAge} <span>Jahre</span> {ageDays} <span>Tage</span> ({userAge})
                  </div>
                )}
              </div>
              <div className={`${styles["summary-step"]} ${hasLicense !== null ? styles.active : ''}`}>
                <div className={styles["summary-label"]}>{selectedLicenses.length > 1 ? "Deine Lenkberechtigungen" : "Deine Lenkberechtigung"}</div>
                <div className={styles["summary-value"]}>
                  {selectedLicenses.length > 0 ? (
                    <>
                      {selectedLicenses.map((lic) => lic.Name).join(", ")}
                    </>
                  ) : (
                    'kein Führerschein'
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {/* {isAngebotForAgree && (
          <div className={`${styles["summary-angebot"]} ${isAngebotForAgree ? styles.active : ''}`}>
            <h2>Dein Angebot</h2>
            <div className={`${styles["summary-step"]} ${angebotAnfrageId ? styles.active : ''}`}>
              <div className={styles["summary-label"]}>Angebot Nr.</div>
              <div className={styles["summary-value"]}>
                {angebotAnfrageId}
              </div>
            </div>
          </div>
        )} */}
        <div className={`${styles["summary-auswahl"]} ${currentStep !== 1 && selectedCategories.length > 0 || selectedAusbildungCombiName || selectedAusbildungName ? styles.active : ''}`}>
          <h2>
            {isAngebotForAgree ? ( "Dein Angebot" ) : ( "Deine Auswahl" )}
          </h2>
          {isAngebotForAgree && (
            <div className={styles["summary-step2col"]}>
              <div className={`${styles["summary-step"]} ${angebotAnfrageId ? styles.active : ''}`}>
                <div className={styles["summary-label"]}>Angebotsnr.</div>
                <div className={styles["summary-value"]}>
                  {angebotAnfrageId}
                </div>
              </div>
              <div className={`${styles["summary-step"]} ${angebotCreatedAt ? styles.active : ''}`}>
                <div className={styles["summary-label"]}>vom</div>
                <div className={styles["summary-value"]}>
                  {angebotCreatedAt}
                </div>
              </div>
            </div>
          )}
          {selectedCategories.map((category, index) => (
            <div key={category.id} className={`${styles["summary-step"]} ${selectedCategories.length > 0 ? styles.active : ''}`}>
              <div className={styles["summary-label"]}>Kategorie</div>
              <div className={styles["summary-value"]}>
                {category.Name}
                {index < selectedCategories.length - 1 && <span>,&nbsp;</span>}
              </div>
            </div>
          ))}
          <div className={`${styles["summary-step"]} ${selectedAusbildungCombiId && selectedAusbildungCombiName ? styles.active : ''}`}>
            <div className={styles["summary-label"]}>Kombi</div>
            <div className={styles["summary-value"]}>
              {selectedAusbildungCombiName}
            </div>
          </div>
          <div className={`${styles["summary-step"]} ${!selectedAusbildungCombiId && selectedAusbildungId && selectedAusbildungName ? styles.active : ''}`}>
            <div className={styles["summary-label"]}>Ausbildung</div>
            <div className={styles["summary-value"]}>
              {selectedAusbildungName}
            </div>
          </div>
        </div>
        {isModerator && (
          <button onClick={openClientWindow} className={styles["summary-submit"]}>
            Client View öffnen
          </button>
        )}
        {currentStep === 7 ? (

          <>

            {!isModerator && !isAngebotForAgree && (


              <button
                className={styles["summary-submit"]}
                type="button"
                onClick={handleSubmit}
                disabled={submitting}
              >
                Anfrage senden
              </button>

            )}



            {isModerator && !isEditing && angebotAnfrageId && (

              <>
                {savedSummary2Data && (
                  <button
                    className={styles["summary-submit"]}
                    onClick={() => generateLocalPdf2(savedSummary2Data)}
                    disabled={!savedSummary2Data}
                  >
                    Auftrag ausdrucken
                  </button>
                )}

                {savedSummaryData && !savedSummary2Data && (
                  <>
                    <button
                      className={styles["summary-submit"]}
                      onClick={() => openPdfByAngebotId(savedSummaryData.angebotId, accessToken)}
                    >
                      Angebot ausdrucken
                    </button>
                  </>
                )}
                {savedSummaryData && !savedSummary2Data && (

                  <button
                    className={styles["summary-submit"]}
                    onClick={handleSendAngebot}
                    disabled={isUpdating}
                  >
                    {isUpdating ? "Senden..." : "Angebot an Kunde senden"}
                  </button>

                )}
                {savedSummary2Data && (

                  <button
                    className={styles["summary-submit"]}
                  >
                    an MMM übergeben
                  </button>
                )}
                <div className={styles["summary-actions"]}>
                  {angebotAnfrageId && (
                    <button
                      className={styles["summary-submit"]}
                      onClick={() => {
                        setIsEditing(true);
                        setSaved(false);
                      }}
                    >


                      {savedSummary2Data ? "Auftrag korrigieren" : "Auftrag erstellen"}
                    </button>
                  )}

                </div>
                {savedSummary2Data && (
                  <button
                    className={styles["summary-submit"]}
                    onClick={() => handleSignatureSubmit()}
                  >
                    Unterschreiben
                  </button>
                )}

              </>
            )}
          </>
        ) : ''}
      </div>
    </div>
  );




  const renderStep1 = () => (
    <div className={styles['category-container']}>
      <div className={styles['head-text-angebot']}>
        <h1 className={styles['title']}>In wenigen Klicks <br /><span className={styles['titleSpan']} >zu deinem Führerschein</span></h1>
        <p className={styles['subtitle']}>
          Wir haben ein einfaches System entwickelt, das dich so schnell wie möglich zu deinem maßgeschneiderten Angebot führt. Beantworte ein paar kurze Fragen – und schon bist du am Ziel!
        </p>
        <p className={styles['text-angebot']}>
          Als Erstes wähle deine gewünschte Führerschein-Kategorie.
        </p>
      </div>

      {categoryError && (
        <div style={{ color: "red", marginBottom: "10px" }}>
          {categoryError}
        </div>
      )}

      {kategorien.length ? (
        <>
          <div className={styles['hauptkategorien-section']}>
            <div className={styles['cards2']}>
              {kategorien
                .filter((category) => category.Hauptkategorie === true && category.Angebote === true)
                .map((category) => {
                  const isSelected = selectedCategories[0]?.id === category.id;
                  const iconUrl = getIconUrl(category.Icon);

                  return (
                    <div key={category.id} className={styles['card-wrapper2']}>
                      <label
                        className={`${styles.card2} ${isSelected ? styles.selected : ''}`}
                      >
                        <div className={styles['card2-content']}>
                          <h3 dangerouslySetInnerHTML={{ __html: category.Name }} />
                          <p>{category.Beschreibung}</p>
                        </div>
                        <input
                          className={styles['angebot-radio']}
                          type="radio"
                          name="selectedCategory"
                          checked={isSelected}
                          onChange={() => {
                            setSelectedCategories([category]);
                            handleNextStep();
                          }}
                        />
                        <div>
                          {iconUrl ? (
                            <InlineSvg
                              src={iconUrl}
                              alt={category.Name}
                              className={styles['category-icon']}
                              fallback="/images/placeholder.png"
                            />
                          ) : (
                            <div className="category-icon-placeholder" />
                          )}
                        </div>
                      </label>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className={styles['zusatzkategorien-section']}>
            <h3>Zusatzausbildungen</h3>
            <div className={styles['cards2']}>
              {kategorien
                .filter((category) => category.Hauptkategorie === false && category.Angebote === true)
                .map((category) => {
                  const isSelected = selectedCategories[0]?.id === category.id;
                  const iconUrl = getIconUrl(category.Icon);

                  return (
                    <div key={category.id} className={styles['card-wrapper2']}>
                      <label
                        className={`${styles.card2} ${isSelected ? styles.selected : ''}`}
                      >
                        <div className={styles['card2-content']}>
                          <h3 dangerouslySetInnerHTML={{ __html: category.Name }} />
                          <p>{category.Beschreibung}</p>
                        </div>
                        <input
                          className={styles['angebot-radio']}
                          type="radio"
                          name="selectedCategory"
                          checked={isSelected}
                          onChange={() => {
                            setSelectedCategories([category]);
                            handleNextStep();
                          }}
                        />
                        <div>
                          {iconUrl ? (
                            <InlineSvg
                              src={iconUrl}
                              alt={category.Name}
                              className={styles['category-icon']}
                              fallback="/images/placeholder.png"
                            />
                          ) : (
                            <div className="category-icon-placeholder" />
                          )}
                        </div>
                      </label>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      ) : (
        <p>No Data...</p>
      )}
    </div>
  );




  const padNumber = (num, length) => num.toString().padStart(length, "0");

  const renderStep2 = () => (
    <div className={styles['next-step-section']}>
      <div className={styles.cardWrap}>
        <h2 className={styles.title}>
          Wie alt bist du?
        </h2>
        {alterError && (
          <div style={{ color: "red", marginBottom: "10px" }}>
            {alterError}
          </div>
        )}


        <div>
          <p className={styles.step2p}>
            Mit unserem Führerschein Konfigurator findest du ruckzuck heraus, welche Ausbildung zu deinem
            Alter passt.
            <br />
            <br />
            Einfach dein Geburtsdatum angeben und auf „Weiter“ klicken – den Rest übernehmen
            wir!
          </p>

          <div className={styles.wrapper}>
            <div
              className={`${styles.groups} ${activeSelector === "groups" ? styles.active : ''}`}
              onClick={() => setActiveSelector("groups")}
            >

              <div className={styles['age-input']}>
                <div className={`${styles['input-group']} ${styles.first}`}>
                  <label htmlFor="birth-day">Tag</label>
                  <input
                    id="birth-day"
                    type="text"
                    inputMode="numeric"
                    pattern="\d{1,2}"
                    maxLength={2}
                    placeholder="01"
                    value={birthDay}
                    onClick={() => !applyAgeFilter && setApplyAgeFilter(true)}
                    onChange={(e) => {
                      let val = e.target.value.replace(/\D/g, "").slice(0, 2);
                      if (val !== "" && (parseInt(val) < 1 || parseInt(val) > 31)) return;
                      setBirthDay(val);
                      setSelectedLicenses([]);
                    }}
                    onBlur={() => {
                      if (birthDay && birthDay.length === 1) setBirthDay(padNumber(birthDay, 2));
                    }}
                    readOnly={!applyAgeFilter}
                    aria-label="Geburtstag - Tag"
                  />
                </div>

                <div className={styles['input-group']}>
                  <label htmlFor="birth-month">Monat</label>
                  <input
                    id="birth-month"
                    type="text"
                    inputMode="numeric"
                    pattern="\d{1,2}"
                    maxLength={2}
                    placeholder="01"
                    value={birthMonth}
                    onClick={() => !applyAgeFilter && setApplyAgeFilter(true)}
                    onChange={(e) => {
                      let val = e.target.value.replace(/\D/g, "").slice(0, 2);
                      if (val !== "" && (parseInt(val) < 1 || parseInt(val) > 12)) return;
                      setBirthMonth(val);
                      setSelectedLicenses([]);
                    }}
                    onBlur={() => {
                      if (birthMonth && birthMonth.length === 1) setBirthMonth(padNumber(birthMonth, 2));
                    }}
                    readOnly={!applyAgeFilter}
                    aria-label="Geburtstag - Monat"
                  />
                </div>

                <div className={`${styles['input-group']} ${styles.last}`}>
                  <label htmlFor="birth-year">Jahr</label>
                  <input
                    id="birth-year"
                    type="text"
                    inputMode="numeric"
                    maxLength={4}
                    placeholder="2008"
                    value={birthYear}
                    onClick={() => !applyAgeFilter && setApplyAgeFilter(true)}
                    onChange={(e) => {
                      let val = e.target.value.replace(/\D/g, "").slice(0, 4);
                      if (val.length === 4) {
                        const year = parseInt(val, 10);
                        if (year < minYearAlter || year > maxYearAlter) return;
                      }
                      setBirthYear(val);
                      setSelectedLicenses([]);
                    }}

                    readOnly={!applyAgeFilter}
                    aria-label="Geburtstag - Jahr"
                  />
                </div>
              </div>

              {applyAgeFilter &&
                birthDay &&
                birthMonth &&
                birthYear &&
                userAge !== null &&
                ageDays !== null && (
                  <>
                    {ageDays === 0 ? (
                      <div className={styles["age-display"]}>
                        Du bist <strong>{visibleAge}</strong> Jahre alt! <strong>Alles Gute zum Geburtstag!</strong> 🥳
                      </div>
                    ) : (
                      <div className={styles["age-display"]}>
                        Du bist <strong>{visibleAge}</strong> Jahre <strong>{ageDays}</strong> Tage alt!
                      </div>
                    )}

                    <button
                      className="large primary button pagelink"
                      onClick={() => {
                        const year = parseInt(birthYear, 10);
                        if (
                          birthYear.length !== 4 ||
                          isNaN(year) ||
                          year < minYearAlter ||
                          year > maxYearAlter
                        ) {
                          setAlterError("Bitte gib ein gültiges Geburtsdatum ein");
                          return;
                        }
                        setAlterError(null);
                        handleNextStep();
                      }
                      }>
                      Weiter
                    </button>
                  </>
                )}
            </div>

            {ageError && <p style={{ color: "red" }}>{ageError}</p>}

          </div>
        </div>
      </div>
    </div>
  );

  const renderStep3 = () => {
    return (
      <>
        {visibleAge <= 13 ? (

          <div className={styles["next-step-section"]}>
            <h2 className={styles.title}>
              Dein Alter entspricht leider nicht dem Mindestalter, um mit der Ausbildung zu beginnen.
            </h2>
            <p>
              Über den folgenden{' '}
              <a href="/klassen">Link</a>{' '}
              kannst du alle Details zur Ausbildung ansehen.
            </p>
          </div>
        ) : (

          <div className={styles['next-step-section']}>
            {license &&
              license.length > 0 &&
              (directOffer ||
                (applyAgeFilter &&
                  birthDate &&
                  birthDate.length === 10 &&
                  userAge !== null)) && (
                <div className={styles['license-section']}>
                  {licenseError && (
                    <div style={{ color: "red", marginBottom: "10px" }}>
                      {licenseError}
                    </div>
                  )}
                  <h2 className={styles.title}>Hast du schon einen Führerschein?</h2>
                  <p>Dann hast du das allgemeine Theorie-Modul (das so genannte„Grundwissen“) bereits absolviert – und brauchst es bei deiner nächsten Ausbildung nicht noch einmal zu wiederholen.</p>
                  <p>Sag uns kurz, ob du schon einen Schein hast, und wir zeigen dir, was für dich am besten passt.</p>
                  <div className={styles['radio-group']}>
                    <label className={styles['custom-radio']}>
                      <input
                        type="radio"
                        name="hasLicense"
                        value="ja"
                        checked={hasLicense === true}
                        onChange={() => setHasLicense(true)}
                      />{" "}
                      <span>Ja</span>
                    </label>
                    <label className={styles['custom-radio']}>
                      <input
                        type="radio"
                        name="hasLicense"
                        value="nein"
                        onChange={() => {
                          setHasLicense(false);
                          setSelectedLicenses([]);
                          handleNextStep();
                        }}
                      />{" "}
                      <span>Nein</span>
                    </label>
                  </div>

                  {hasLicense === true && (
                    <>
                      <div className={styles['checkbox-group-license']}>
                        <div>
                          <h3>Welchen Führerschein hast du bereits?</h3>
                          <p className={styles.step3p}>
                            Wähle die Führerscheinklasse aus, die du bereits besitzt. So können wir dir deine Ausbildungswege
                            anzeigen – perfekt auf deine Vorkenntnisse abgestimmt.
                          </p>
                        </div>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          {(applyAgeFilter
                            ? license.filter((l) => l.Kategorien.some((cat) => cat.Kategorien_id === selectedCategories[0].id))
                              .filter((l) => {
                                if (!l.Klassen || !Array.isArray(l.Klassen))
                                  return false;
                                return l.Klassen.some((klasseObj) => {
                                  const classObj = klassen.find((k) => String(k.id) === String(klasseObj.id));
                                  return (
                                    classObj &&
                                    classObj.Pruefungsantritt &&
                                    userAge >= classObj.Pruefungsantritt
                                  );
                                });
                              })
                            : license
                          ).map((l) => (
                            <li key={l.id}>
                              <label className={styles['license-checkbox']}>
                                <input
                                  type="checkbox"
                                  checked={selectedLicenses.some(
                                    (selected) => selected.id === l.id
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedLicenses([...selectedLicenses, l]);
                                    } else {
                                      setSelectedLicenses(
                                        selectedLicenses.filter(
                                          (selected) => selected.id !== l.id
                                        )
                                      );
                                    }
                                  }}
                                />
                                <span className={styles['checkbox-label']}>{l.Name}</span>
                              </label>
                            </li>
                          ))}
                        </ul>
                        {/* {selectedLicenses.length > 0 && ( */}
                        <button
                          className="large primary button pagelink"
                          onClick={() => handleNextStep()}
                          disabled={selectedLicenses.length <= 0}
                        >
                          Weiter
                        </button>
                        {/* )} */}
                      </div>
                    </>
                  )}

                </div>
              )}
          </div>

        )}
      </>
    )
  }


  const shownAusbildungIds = useMemo(() => {
    const ids = new Set();
    selectedCategories.forEach(cat => {
      const catClasses = classesByCategory[cat.id] || [];
      catClasses.forEach(klasse => {
        const filtered = filterAusbildungen(klasse.Ausbildungen);
        filtered.forEach(a => ids.add(a.id));
      });
    });
    return ids;
  }, [selectedCategories, classesByCategory, filterAusbildungen]);


  const renderStep4 = () => {
    Object.entries(classesByCategory).forEach(([catId, klassen]) => {
      console.log(`📂 Kategorie ${catId} hat ${klassen.length} Klassen:`, klassen.map(k => k.Name));

      klassen.forEach(k => {
        const ausbildungen = k.Ausbildungen || [];
        console.log(`📘 Klasse "${k.Name}" hat ${ausbildungen.length} Ausbildungen`);
        if (ausbildungen.length === 0) {
          console.warn(`⚠️ Klasse "${k.Name}" hat KEINE Ausbildungen!`);
        } else {
          console.log("🔍 Ausbildungen:", ausbildungen.map(a => a?.Name || "⛔️ No Name"));
        }
      });
    });

    console.log("🧪 selectedCategories:", selectedCategories);
    console.log("🧪 shownAusbildungIds:", shownAusbildungIds);

    return (

      <>
        <div className={styles["next-step-section"]}>
          <div>
            <h2 className={styles.title}>Das sind deine Möglichkeiten!</h2>
            {ausbildungError && (
              <div style={{ color: "red", marginBottom: "10px" }}>{ausbildungError}</div>
            )}
            <p>
              Basierend auf deinen Angaben haben wir die passenden Ausbildungsmöglichkeiten für dich zusammengestellt.
            </p>
            <p>Wähle die Option, die am besten zu dir passt.</p>
          </div>


          <h3 className={styles.title2}>
            Mit diesen Ausbildungen kannst du <strong>sofort starten:</strong>
          </h3>

          {selectedCategories.map((cat) => {
            const catClasses = (classesByCategory[cat.id] || []).map(klasse => {
              console.log(`🔸 Klasse "${klasse.Name}" (id=${klasse.id}) — Prüfung Angebot:`, klasse.Angebot);

              const original = klasse.Ausbildungen || [];

              console.log("🟢 Ursprüngliche Ausbildungen:", original.map(a => a?.Name));

              const afterFilter1 = filterAusbildungen(original);
              console.log("🔹 Nach filterAusbildungen:", afterFilter1.map(a => a?.Name));

              const afterFilter2 = afterFilter1.filter(ausbildung => {
                if (userAge && klasse.Obergrenze && userAge > klasse.Obergrenze) {
                  console.warn(`⛔️ Alter zu hoch für ${ausbildung.Name}`);
                  return false;
                }

                if (selectedLicenses.length) {
                  const hasGrundwissen = selectedLicenses.some(l => l.Grundwissen);
                  const allowed = hasGrundwissen ? !ausbildung.Grundwissen : ausbildung.Grundwissen;
                  if (!allowed) {
                    console.warn(`⛔️ Grundwissen-Filter blockiert ${ausbildung.Name}`);
                  }
                  return allowed;
                }

                return true;
              });
              console.log("🔸 Nach Alter & Grundwissen:", afterFilter2.map(a => a?.Name));

              const final = afterFilter2.filter(a =>
                shouldShowVariant(a, selectedLicenses, klasse.id)
              );
              console.log("✅ Übrig nach shouldShowVariant:", final.map(a => a?.Name));

              if (final.length === 0) {
                console.warn(`❌ Keine gültigen Ausbildungen für Klasse "${klasse.Name}"`);
              }

              return {
                ...klasse,
                filteredAusbildungen: final
              };
            }).filter(klasse => klasse.filteredAusbildungen.length > 0 && klasse.Angebot);

            return (
              <div className={styles['cards3-angebot-wrapper']} key={cat.id}>
                <div className={styles['cards3-angebot']}>
                  {catClasses.map(klasse => {
                    const classIconUrl = getIconUrl(klasse?.Icon);
                    return (
                      <div className={styles.step4CardWrap} key={klasse.id}>
                        {klasse.filteredAusbildungen.map((variant) => {
                          return (
                            <div key={variant.id}>
                              <div
                                className={`${styles['card2-angebot']} ${selectedAusbildungId === variant.id ? styles.selected : ""}`}
                                onClick={() => {
                                  setSelectedAusbildungId(variant.id);
                                  setSelectedAusbildungName(variant.Name);
                                  setSelectedAusbildungCombiId(null);
                                  setChosenVariant(variant);
                                  setFutureEd(false);
                                  setEarliestUpcomingStartDate(null);
                                  setStartDate(new Date());
                                  handleNextStep();
                                }}
                              >
                                <input
                                  type="radio"
                                  name="selectedAusbildung"
                                  value={variant.id}
                                  checked={selectedAusbildungId === variant.id}
                                  onChange={() => {
                                    setSelectedAusbildungId(variant.id);
                                  }}
                                  style={{ marginRight: "10px" }}
                                />
                                <div style={{
                                  width: '90%',
                                  paddingTop: '1rem',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'space-between'
                                }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    {klasse.Klassenkuerzel && (
                                      <h3>{klasse.Klassenkuerzel}</h3>
                                    )}
                                    {classIconUrl && (
                                      <InlineSvg
                                        src={classIconUrl}
                                        alt={klasse?.Name || "Klassenicon"}
                                        className={`${styles['category-icon']} ${selectedAusbildungId === variant.id ? styles.selected : ""}`}
                                      />
                                    )}
                                  </div>
                                  <div className={styles['angebot_class']} >
                                    <h4>{klasse.Untertitel}</h4>
                                    <p>{variant.Kurzname}</p>
                                    <p style={{ fontSize: '0.9rem', marginTop: '0.125rem' }}>
                                      Ausbildungsbeginn: {variant.Ausbildungsbeginn} Jahre
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}

          <div>
            {upcomingAusbildungen.some(({ ausbildung }) => !shownAusbildungIds.has(ausbildung.id)) && (
              <h3 className={styles.title2}>
                Mit diesen Ausbildungen kannst du schon <strong>demnächst starten:</strong>
              </h3>
            )}

            <div className={styles['cards3-angebot']}>
              {upcomingAusbildungen
                .filter(({ ausbildung }) => !shownAusbildungIds.has(ausbildung.id))
                .filter(({ klasse }) => !!klasse?.Angebot)
                .map(({ ausbildung, klasse, durationFormatted, startDateFormatted }) => {
                  const isSelected = selectedAusbildungId === ausbildung.id;
                  const classIconUrl = getIconUrl(klasse?.Icon);

                  const ausbildungCourses = kurse.filter(kurs =>
                    kurs.Ausbildung && String(kurs.Ausbildung.id) === String(ausbildung.id)
                  );

                  const nearestCourse = getNearestCourseFromInput(ausbildungCourses, new Date());
                  const nearestDateFormatted = nearestCourse
                    ? new Date(nearestCourse.Start).toLocaleDateString()
                    : "Noch kein Kurs";

                  return (
                    <div key={ausbildung.id}>
                      <div
                        className={`${styles['card2-angebot']} ${isSelected ? styles.selected : ''}`}
                        style={{ marginBottom: '1rem', cursor: 'pointer', opacity: 0.7 }}
                        onClick={() => {
                          setSelectedAusbildungId(ausbildung.id);
                          setSelectedAusbildungName(ausbildung.Name);
                          setSelectedAusbildungCombiId(null);
                          setChosenVariant(ausbildung);
                          setFutureEd(true);
                          handleNextStep();

                          const selectedUpcoming = upcomingAusbildungen.find(u => u.ausbildung.id === ausbildung.id);
                          if (selectedUpcoming) {
                            setEarliestUpcomingStartDate(selectedUpcoming.startDateFormatted);
                          }
                        }}
                      >
                        <input
                          type="radio"
                          name="selectedAusbildung"
                          value={ausbildung.id}
                          checked={isSelected}
                          onChange={() => {
                            setSelectedAusbildungId(ausbildung.id);
                            const selectedUpcoming = upcomingAusbildungen.find(u => u.ausbildung.id === ausbildung.id);
                            if (selectedUpcoming) {
                              setEarliestUpcomingStartDate(selectedUpcoming.startDateFormatted);
                            }
                          }}
                          style={{ marginRight: "10px" }}
                        />
                        <div style={{
                          width: '90%',
                          paddingTop: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            {klasse.Klassenkuerzel && (
                              <h3>{klasse.Klassenkuerzel}</h3>
                            )}
                            {classIconUrl && (
                              <InlineSvg
                                src={classIconUrl}
                                alt={klasse?.Name || 'Klassenicon'}
                                className={`${styles['category-icon']} ${isSelected ? styles.selected : ''}`}
                              />
                            )}
                          </div>
                          <div className={styles['angebot_class']}>
                            <h4>{klasse.Untertitel}</h4>
                            <p>{ausbildung.Kurzname}</p>
                            <p style={{ fontSize: '0.9rem', marginTop: '0.125rem' }}>
                              Ausbildungsbeginn: {ausbildung.Ausbildungsbeginn} Jahre
                            </p>
                          </div>
                        </div>
                      </div>
                      <p>Verfügbar in {durationFormatted} <span style={{ fontSize: '0.9rem' }}>(Ab dem {startDateFormatted})</span></p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </>
    );
  };


  // const renderStep5 = () => {
  //   if (!selectedAusbildungId) {
  //     return (
  //       <div>
  //         <h2>Einzelklasse oder clever kombinieren?</h2>
  //         <p>Bitte wählen Sie zuerst einen Kurs aus (Schritt 3), um die Kombinationen anzuzeigen.</p>
  //       </div>
  //     );
  //   }

  //   const selectedClass = getClassForAusbildung(selectedAusbildungId, klassen);
  //   if (!selectedClass) {
  //     return (
  //       <div>
  //         <h2>Fehler</h2>
  //         <p>Der ausgewählte Kurs wurde nicht gefunden.</p>
  //       </div>
  //     );
  //   }

  //   const licenseClassIds = selectedLicenses.flatMap((lic) =>
  //     Array.isArray(lic.Berechtigung)
  //       ? lic.Berechtigung.map((b) => (typeof b.Klassen_id === "object" ? b.Klassen_id.id : b.Klassen_id))
  //       : []
  //   ); 

  //   return (
  //     <div>
  //       {combiAusbildungUrl && <h2>Bitte Weiter klicken.</h2>}
  //       {!combiAusbildungUrl && (
  //         <>
  //           <div className={styles["next-step-section"]}>
  //             <h2 className={styles.title}>Einzelklasse oder clever kombinieren?</h2>
  //             <p>Möchtest du nur deine gewählte Klasse machen oder gleich mehrere Führerscheinklassen kombinieren?</p>
  //             <button
  //               className="large primary button pagelink"
  //               onClick={handleNextStep}
  //               type="button"
  //             >
  //               Weiter ohne Kombi
  //             </button>
  //           </div>

  //           <div className={styles["cards4-angebot-wrapper"]}>
  //             <span className={styles["optional-label"]}>Optional</span>
  //             <div className={styles.cards4}>
  //               {(showAllKombis ? visibleKombis : visibleKombis.slice(0, 4))
  //                 .filter((kombi) => {
  //                   const info = kombinationen.find(
  //                     (item) => String(item.id) === String(kombi.Kombinationen_id?.id)
  //                   );
  //                   const combiClassIds = info?.Klassen?.map((k) =>
  //                     typeof k.Klassen_id === 'object' ? k.Klassen_id.id : k.Klassen_id
  //                   ) || [];
  //                   return !combiClassIds.some((cid) => licenseClassIds.includes(cid));
  //                 })
  //                 .map((kombi) => {
  //                   const info = kombinationen.find(
  //                     (item) => String(item.id) === String(kombi.Kombinationen_id?.id)
  //                   );

  //                   const allVariants = (kombi.Kombinationen_id?.Ausbildungen || [])
  //                     .map((id) => ausbildungen.find((a) => String(a.id) === String(id)))
  //                     .filter(Boolean);

  //                   console.log(allVariants);

  //                   // Filter Ausbildungen by Age aswell
  //                   const ageVariants = allVariants.filter((v) => userAge ? parseFloat(v.Ausbildungsbeginn) < userAge : []);
  //                   console.log(ageVariants);

  //                   const gwVariants = ageVariants?.filter((v) => {
  //                     if (selectedLicenses.length) {
  //                       const hasGrundwissen = selectedLicenses.some(l => l.Grundwissen);
  //                       const allowed = hasGrundwissen ? !v.Grundwissen : v.Grundwissen;
  //                       if (!allowed) {
  //                         console.warn(`⛔️ Grundwissen-Filter blockiert ${v.Name}`);
  //                       }
  //                       return allowed;
  //                     }
  //                   });

  //                   const matching = gwVariants?.filter((v) => {
  //                       const prereqClassIds = Array.isArray(v.Vorraussetzungen)
  //                         ? v.Vorraussetzungen.map((pr) => pr.Klassen_id)
  //                         : [];
  //                       return prereqClassIds.some((cid) => licenseClassIds.includes(cid));
  //                     });
  //                   const noPrereq = allVariants.filter(
  //                     (v) => !Array.isArray(v.Vorraussetzungen) || v.Vorraussetzungen.length === 0
  //                   );
  //                   const variantsToShow = matching.length > 0 ? matching : noPrereq;

  //                   console.log(matching);

  //                   return (
  //                     <React.Fragment key={kombi.id}>
  //                       {variantsToShow.map((variant) => {
  //                         const seenIcons = new Set();
  //                         const orderedUniqueIcons = (info?.Klassen || [])
  //                           .filter((k) => k.Klassen_id && k.Klassen_id.Icon)
  //                           .sort((a, b) => {
  //                             const sortA = a.sort ?? 0;
  //                             const sortB = b.sort ?? 0;
  //                             return sortA - sortB;
  //                           })
  //                           .map((k) => k.Klassen_id.Icon)
  //                           .filter((icon, index, self) => self.indexOf(icon) === index);

  //                         return (
  //                           <div
  //                             key={variant.id}
  //                             className={`${styles["card4-angebot"]} ${selectedAusbildungCombiId === variant.id ? styles.selected : ""
  //                               }`}
  //                             onClick={() => {
  //                               setSelectedAusbildungCombiId(variant.id);
  //                               setSelectedAusbildungCombiName(variant.Name);
  //                               handleNextStep();
  //                             }}
  //                           >
  //                             <input
  //                               type="radio"
  //                               name="selectedAusbildungCombi"
  //                               value={variant.id}
  //                               checked={selectedAusbildungCombiId === variant.id}
  //                               onChange={() => setSelectedAusbildungCombiId(variant.id)}
  //                               style={{ marginRight: "10px" }}
  //                             />
  //                             <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '90%' }}>
  //                               <div style={{ display: 'flex', gap: '0.5rem' }}>
  //                                 {orderedUniqueIcons.map((icon, idx) => (
  //                                   <InlineSvg
  //                                     key={idx}
  //                                     src={`${process.env.REACT_APP_API_BASE_URL}/assets/${icon}.svg`}
  //                                     alt="Icon"
  //                                     className={styles['category-icon']}
  //                                   />
  //                                 ))}

  //                               </div>
  //                               <div>
  //                                 <p>{variant.Name}</p>
  //                                 <p style={{ fontSize: "0.9rem", marginTop: "0.25rem" }}>{variant.Kurzname}</p>
  //                               </div>
  //                             </div>
  //                           </div>
  //                         );
  //                       })}
  //                     </React.Fragment>
  //                   );
  //                 })}
  //             </div>

  //             {visibleKombis.length > 4 && (
  //               <button
  //                 className={styles.moreBtn}
  //                 style={{ marginTop: "2rem" }}
  //                 onClick={() => setShowAllKombis(!showAllKombis)}
  //               >
  //                 {showAllKombis ? "Weniger anzeigen" : "Mehr anzeigen"}
  //               </button>
  //             )}
  //           </div>
  //         </>
  //       )}
  //     </div>
  //   );
  // };

  const renderStep5 = () => {
    if (!selectedAusbildungId) {
      return (
        <div>
          <h2>Einzelklasse oder clever kombinieren?</h2>
          <p>Bitte wählen Sie zuerst einen Kurs aus (Schritt 3), um die Kombinationen anzuzeigen.</p>
        </div>
      );
    }

    const selectedClass = getClassForAusbildung(selectedAusbildungId, klassen);
    if (!selectedClass) {
      return (
        <div>
          <h2>Fehler</h2>
          <p>Der ausgewählte Kurs wurde nicht gefunden.</p>
        </div>
      );
    }

    // const licenseClassIds = selectedLicenses.flatMap((lic) =>
    //   Array.isArray(lic.Berechtigung)
    //     ? lic.Berechtigung.map((b) => (typeof b.Klassen_id === "object" ? b.Klassen_id.id : b.Klassen_id))
    //     : []
    // );

    /* const licenseClassIds = selectedLicenses.flatMap((lic) =>
      Array.isArray(lic.Berechtigung)
        ? lic.Berechtigung
          .map((b) =>
            typeof b?.Klassen_id === "object" ? b?.Klassen_id?.id : b?.Klassen_id
          )
          .filter((id) => id != null)
        : []
    ); */

    console.log(selectedLicenses);

    const licenseClassIds = selectedLicenses.flatMap((lic) =>
      Array.isArray(lic.Berechtigung)
        ? lic.Berechtigung
          .map((b) =>
            typeof b?.Klassen_id === "object" ? b?.Klassen_id?.id : b?.Klassen_id
          )
          .filter((id) => id != null)
        : []
    );
    console.log(licenseClassIds);

    const websiteAktionen = aktionen.filter((ak) => ak.channels?.includes("website"))


    /* const ausbildungAktionen = () => {
      if (!selectedAusbildungId) return [];
      return (websiteAktionen || []). filter((ak) => ak.zuordnung_display?.some((akz) => {
        return ((akz.collection === "Ausbildungen") && String(akz.item) === String(selectedAusbildungId))
      }))
    }

    const klasseAktionen = () => {
      if (!selectedClass) return [];
      return (websiteAktionen || []).filter((ak) => ak.zuordnung_display?.some((akz) => {
        return ((akz.collection === "Klassen") && String(akz.item) === String(selectedClass))
      }))
    } */

    // const ausbildungAktionen =  (websiteAktionen || []). filter((ak) => ak.zuordnung_display?.some((akz) => {
    //     return ((akz.collection === "Ausbildungen") && String(akz.item) === String(selectedAusbildungId))
    //   }));

    // const klasseAktionen = (websiteAktionen || []).filter((ak) => ak.zuordnung_display?.some((akz) => {
    //     return ((akz.collection === "Klassen") && String(akz.item) === String(selectedClass))
    //   }));

    const ausbildungAktionen = (websiteAktionen || []).filter((ak) =>
      ak.zuordnung_display?.some(
        (akz) =>
          akz?.collection === "Ausbildungen" &&
          String(akz?.item) === String(selectedAusbildungId)
      )
    );

    const klasseAktionen = (websiteAktionen || []).filter((ak) =>
      ak.zuordnung_display?.some(
        (akz) =>
          akz?.collection === "Klassen" &&
          String(akz?.item) === String(selectedClass)
      )
    );


    return (
      <div>
        {combiAusbildungUrl && <h2>Bitte Weiter klicken.</h2>}
        {!combiAusbildungUrl && (
          <>
            <div className={styles["next-step-section"]}>
              <h2 className={styles.title}>Einzelklasse oder clever kombinieren?</h2>
              <p>Möchtest du nur deine gewählte Klasse machen oder gleich mehrere Führerscheinklassen kombinieren?</p>
              <button
                className="large primary button pagelink"
                onClick={handleNextStep}
                type="button"
              >
                Weiter ohne Kombi
              </button>
            </div>

            {(ausbildungAktionen.length > 0) && (
              <div className="aktion-container">
                <div className="aktion">
                  <div className="aktion-content">
                    <h2>{ausbildungAktionen[0].title}</h2>
                    <p>{ausbildungAktionen[0].text}</p>
                  </div>
                  {ausbildungAktionen[0].rabatt && (
                    <div className="aktion-rabatt">
                      <span>Jetzt</span>
                      {ausbildungAktionen[0].rabatt % 1 === 0 ? (
                        <span className="aktion-rabatt-price">
                          € <strong>{Math.trunc(ausbildungAktionen[0].rabatt)}</strong>,–
                        </span>
                      ) : (
                        <span className="aktion-rabatt-price">
                          € <strong>{Math.trunc(ausbildungAktionen[0].rabatt)}</strong>,{ausbildungAktionen[0].rabatt.toString().split('.')[1]}
                        </span>
                      )}
                      <span>sparen!</span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {(ausbildungAktionen.length <= 0) && (klasseAktionen.length > 0) && (
              <div className="aktion-container">
                <div className="aktion">
                  <div className="aktion-content">
                    <h2>{klasseAktionen[0].title}</h2>
                    <p>{klasseAktionen[0].text}</p>
                  </div>
                  {klasseAktionen[0].rabatt && (
                    <div className="aktion-rabatt">
                      <span>Jetzt</span>
                      {klasseAktionen[0].rabatt % 1 === 0 ? (
                        <span className="aktion-rabatt-price">
                          € <strong>{Math.trunc(klasseAktionen[0].rabatt)}</strong>,–
                        </span>
                      ) : (
                        <span className="aktion-rabatt-price">
                          € <strong>{Math.trunc(klasseAktionen[0].rabatt)}</strong>,{klasseAktionen[0].rabatt.toString().split('.')[1]}
                        </span>
                      )}
                      <span>sparen!</span>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className={styles["cards4-angebot-wrapper"]}>
              <span className={styles["optional-label"]}>Optional</span>

              <div className={styles.cards4}>
                {(showAllKombis ? visibleKombis : visibleKombis.slice(0, 4))
                  // 1) убираем Kombis, которые содержат классы, уже имеющиеся в лицензиях
                  .filter((kombi) => {
                    const info = kombinationen.find(
                      (item) => String(item.id) === String(kombi.Kombinationen_id?.id)
                    );

                    // const combiClassIds =
                    //   info?.Klassen?.map((k) =>
                    //     typeof k.Klassen_id === "object" ? k.Klassen_id.id : k.Klassen_id
                    //   ) || [];

                    const combiClassIds =
                      info?.Klassen?.map((k) =>
                        typeof k.Klassen_id === "object" ? k.Klassen_id?.id : k.Klassen_id
                      ) || [];

                    return !combiClassIds.some((cid) => licenseClassIds.includes(cid));
                  })
                  .map((kombi) => {
                    const info = kombinationen.find(
                      (item) => String(item.id) === String(kombi.Kombinationen_id?.id)
                    );
                    if (!info) return null;

                    // Все Ausbildung-варианты для этой Kombi
                    const allVariants = (kombi.Kombinationen_id?.Ausbildungen || [])
                      .map((id) => ausbildungen.find((a) => String(a.id) === String(id)))
                      .filter(Boolean);

                    // Возраст: если userAge нет — не фильтруем
                    const ageVariants = allVariants.filter((v) =>
                      userAge ? parseFloat(v.Ausbildungsbeginn) <= userAge : true
                    );

                    // Grundwissen: если лицензий нет — не фильтруем (ВАЖНО!)
                    const gwVariants = ageVariants.filter((v) => {
                      if (!selectedLicenses?.length) return true;

                      const hasGrundwissen = selectedLicenses.some((l) => l.Grundwissen);
                      // Если уже есть GW, показываем НЕ-GW, иначе показываем GW
                      return hasGrundwissen ? !v.Grundwissen : v.Grundwissen;
                    });

                    // --- ВАШЕ ПРАВИЛО ---
                    // Если есть license -> варианты Kombi БЕЗ Vorraussetzungen НЕ показываем.
                    const prereqVariants = gwVariants.filter(
                      (v) => Array.isArray(v.Vorraussetzungen) && v.Vorraussetzungen.length > 0
                    );

                    const noPrereqVariants = gwVariants.filter(
                      (v) => !Array.isArray(v.Vorraussetzungen) || v.Vorraussetzungen.length === 0
                    );

                    const variantsToShow = selectedLicenses?.length > 0 ? prereqVariants : noPrereqVariants;
                    /* const variantsToShow = prereqVariants; */

                    // Если после фильтров нечего показывать — эту Kombi пропускаем
                    if (!variantsToShow.length) return null;

                    // Иконки классов в Kombi (уникальные + сортировка)
                    const orderedUniqueIcons = (info?.Klassen || [])
                      .filter((k) => k?.Klassen_id?.Icon)
                      .sort((a, b) => (a.sort_klassen ?? 0) - (b.sort_klassen ?? 0))
                      .map((k) => k.Klassen_id.Icon)
                      .filter((icon, idx, arr) => arr.indexOf(icon) === idx);

                    return (
                      <React.Fragment key={kombi.id}>
                        {variantsToShow.map((variant) => (
                          <div
                            key={variant.id}
                            className={`${styles["card4-angebot"]} ${selectedAusbildungCombiId === variant.id ? styles.selected : ""
                              }`}
                            onClick={() => {
                              setSelectedAusbildungCombiId(variant.id);
                              setSelectedAusbildungCombiName(variant.Name);
                              handleNextStep();
                            }}
                          >
                            <input
                              type="radio"
                              name="selectedAusbildungCombi"
                              value={variant.id}
                              checked={selectedAusbildungCombiId === variant.id}
                              onChange={() => setSelectedAusbildungCombiId(variant.id)}
                              style={{ marginRight: "10px" }}
                            />

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "1rem",
                                width: "90%",
                              }}
                            >
                              <div style={{ display: "flex", gap: "0.5rem" }}>
                                {orderedUniqueIcons.map((icon, idx) => (
                                  <InlineSvg
                                    key={idx}
                                    src={`${process.env.REACT_APP_API_BASE_URL}/assets/${icon}.svg`}
                                    alt="Icon"
                                    className={styles["category-icon"]}
                                  />
                                ))}
                              </div>

                              <div>
                                <p>{variant.Name}</p>
                                {/* <p style={{ fontSize: "0.9rem", marginTop: "0.25rem" }}>
                                {variant.Kurzname}
                              </p> */}
                              </div>
                            </div>
                          </div>
                        ))}
                      </React.Fragment>
                    );
                  })}
              </div>

              {visibleKombis.length > 4 && (
                <button
                  className={styles.moreBtn}
                  style={{ marginTop: "2rem" }}
                  onClick={() => setShowAllKombis(!showAllKombis)}
                >
                  {showAllKombis ? "Weniger anzeigen" : "Mehr anzeigen"}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    );
  };

  const renderStep6 = () => {
    const renderKursItem = (kurs) => {
      const kursStart = new Date(kurs.Start).toLocaleString("de-AT", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
      const kursEnde = new Date(kurs.Ende).toLocaleString("de-AT", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      return (

        <div key={kurs.id} className="kurs-item">
          <div
            className={`kurs-header ${expandedCourses.has(kurs.id) ? "open" : ""}`}
            onClick={() => toggleCourse(kurs.id)}
          >
            <div style={{ display: "flex", gap: '1rem' }}>
              <div className={styles.tooltipWrapper}>
                <input
                  type="radio"
                  name="selectedCourse"
                  value={kurs.id}
                  checked={selectedCourse === kurs.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (selectedCourse === kurs.id) {
                      setSelectedCourse(null);
                    } else {
                      setSelectedCourse(kurs.id);
                    }
                  }}
                  className="custom-checkbox2"
                />

                <div className={styles.tooltip}>Reservieren!</div>
              </div>

              <h3>
                {kurs.Name} <span>{kurs.Untertitel}</span>
              </h3>

            </div>
            <div className="kurs-date">
              {kursEnde === kursStart ? kursStart : `${kursStart} - ${kursEnde}`}
            </div>
            <div className={`checkmark ${expandedCourses.has(kurs.id) ? "open" : ""}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                width="20"
                height="20"
                fill="currentColor"
              >
                <path d="m480-453-95-95q-11-11-27.5-11T329-548q-12 12-12 28.5t12 28.5l123 123q12 12 28 12t28-12l124-124q12-12 11.5-28T631-548q-12-11-28-11.5T575-548l-95 95Z" />
              </svg>
            </div>
          </div>

          {expandedCourses.has(kurs.id) && (
            <div className="course-details">
              <table className="course-table">
                <tbody>
                  {/* {kurs.Termine.map((termin) => { */}
                  {(kurs.Termine || []).map((termin) => {
                    if (selectedLicenses.length > 0 && termin.Modul?.Typ === "theorie_gw") {
                      return null;
                    }

                    return (
                      <tr key={termin.id}>
                        <td className="termin-modul">{termin.Modul?.Name || "—"}</td>
                        <td className="termin-date">
                          {new Date(termin.Datum).toLocaleDateString("de-AT", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </td>
                        <td className="termin-time">
                          {new Date(termin.Start_cal).toLocaleTimeString("de-AT", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                          <span className="timeline"></span>
                          {new Date(termin.Ende_cal).toLocaleTimeString("de-AT", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </td>
                        <td className="termin-ort">{termin.Ort.Ort || "—"}</td>
                        <td className="termin-lektion">
                          <span className={`label ${termin.Modul?.Typ}`}>
                            {ClassLabels[termin.Modul?.Typ]}
                          </span>
                          {termin.Modul?.Typ === "theorie_gw" && (
                            <span className="label label_gw">Grundwissen</span>
                          )}
                          {termin.Modul?.Thema?.length > 0 &&
                            termin.Modul?.Thema.map((thm) =>
                              termin.Modul.Typ === "theorie_klasse" || termin.Modul.Typ === "praxis" ? (
                                <span
                                  key={thm.id}
                                  className={`label ${termin.Modul.Typ} label_klasse`}
                                >
                                  {thm.Fuehrerscheine_id.Name}
                                </span>
                              ) : null
                            )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      );
    };


    let variantPrices = [];
    if (chosenVariant) {
      const mappings = ausbildungenPreise.filter(
        (m) => m.Ausbildungen_id === chosenVariant.id
      );
      variantPrices = mappings
        .map((m) => preise.find((p) => p.id === m.Preise_id))
        .filter(Boolean);
    }

    let relatedClass = chosenVariant
      ? getClassForAusbildung(chosenVariant.id, klassen)
      : null;

    let relatedCourses = [];

    if (relatedClass) {
      relatedCourses = getCoursesForClass(relatedClass.id, kurse);
    } else if (chosenVariant) {
      const relatedClassIds = new Set();
      kombinationen.forEach((kombi) => {
        if (
          kombi.Ausbildungen?.some((a) => a.id === chosenVariant.id)
        ) {
          klassenKombinationen.forEach((mapping) => {
            if (mapping.Kombinationen_id?.id === kombi.id && mapping.Klassen_id?.id) {
              relatedClassIds.add(mapping.Klassen_id.id);
            }
          });
        }
      });

      relatedCourses = Array.from(relatedClassIds).flatMap((cid) =>
        getCoursesForClass(cid, kurse)
      );

      relatedCourses = Array.from(new Map(relatedCourses.map(c => [c.id, c])).values());


      const uniqueCourseIds = new Set();
      relatedCourses = relatedCourses.filter((kurs) => {
        if (uniqueCourseIds.has(kurs.id)) return false;
        uniqueCourseIds.add(kurs.id);
        return true;
      });
    } else if (relatedClass) {
      relatedCourses = getCoursesForClass(relatedClass.id, kurse);
    }

    const displayedCourses = relatedCourses.filter(
      (kurs) => kurs.Kurstyp === "kurz"
    );
    const displayedCourses2 = relatedCourses.filter(
      (kurs) => kurs.Kurstyp === "abend"
    );

    const displayedCourses3 = relatedCourses.filter(
      (kurs) => kurs.Kurstyp === "klasse"
    );

    const nearestCourseDate = getNearestCourseDate(relatedCourses);
    const nearestCourseDateFromInput = getNearestCourseDateFromInput(
      relatedCourses,
      startDate
    );

    const nearestCourseFromInput = getNearestCourseFromInput(relatedCourses, startDate);
    const nearestCourse = getNearestCourse(relatedCourses);

    const ferienToShow = showAllFerien ? displayedCourses : displayedCourses.slice(0, 3);
    const abendToShow = showAllAbend ? displayedCourses2 : displayedCourses2.slice(0, 3);
    const weitereToShow = showAllWeitere ? displayedCourses3 : displayedCourses3.slice(0, 3);

    const nearestTermine = getNearestTermine(relatedCourses);
    const nearestTermineFromInput = getNearestTermineFromInput(relatedCourses, startDate);
    console.log("TERMIN", nearestTermineFromInput);

    const ClassLabels = {
      "theorie_gw": "Theorie",
      "theorie_klasse": "Theorie",
      "praxis": "Praxis",
      "arzt": "Ärztliche Untersuchung",
      "ehk": "EHK"
    }

    const nearestKursId = nearestTermineFromInput?.course?.id;
    const nearestKursart = nearestTermineFromInput?.course?.Kurstyp;

    const courseBlocks = [
      {
        type: "kurz",
        content: ferienToShow.length > 0 && (
          <div className="courses-list" key="ferien">
            <h3>Unsere Ferien Kurz-Kurse</h3>
            <p>Einstieg jederzeit möglich</p>
            {ferienToShow.map(renderKursItem)}
            {displayedCourses.length > 3 && (
              <button onClick={() => setShowAllFerien(!showAllFerien)}>
                {showAllFerien ? "Weniger anzeigen" : "Mehr anzeigen"}
              </button>
            )}
          </div>
        ),
      },
      {
        type: "abend",
        content: abendToShow.length > 0 && (
          <div className="courses-list" key="abend">
            <h3>Unsere Abendkurse</h3>
            <p>Einstieg jederzeit möglich</p>
            {abendToShow.map(renderKursItem)}
            {displayedCourses2.length > 3 && (
              <button onClick={() => setShowAllAbend(!showAllAbend)}>
                {showAllAbend ? "Weniger anzeigen" : "Mehr anzeigen"}
              </button>
            )}
          </div>
        ),
      },
      {
        type: "klasse",
        content: weitereToShow.length > 0 && (
          <div className="courses-list" key="klasse">
            <h3>Klassen­spezifische Kurse</h3>
            {weitereToShow.map(renderKursItem)}
            {displayedCourses3.length > 3 && (
              <button onClick={() => setShowAllWeitere(!showAllWeitere)}>
                {showAllWeitere ? "Weniger anzeigen" : "Mehr anzeigen"}
              </button>
            )}
          </div>
        ),
      },
    ];

    const sortedBlocks = courseBlocks.sort((a, b) => {
      if (a.type === nearestKursart) return -1;
      if (b.type === nearestKursart) return 1;
      return 0;
    });


    const filteredCourses = relatedCourses.filter((kurs) => {
      const hatGueltigenTermin =
        !startDate ||
        kurs.Termine?.some((termin) => new Date(termin.Datum) >= startDate);

      return (
        kurs.Kurstyp !== "arzt" &&
        (!onlyKurz || kurs.Kurstyp === "kurz") &&
        kurs.Kurstyp !== 'ehk' &&
        hatGueltigenTermin
      );
    });

    const sortedAllCourses = [...filteredCourses].sort(
      (a, b) => new Date(a.Start) - new Date(b.Start)
    );

    const coursesToShow = showAllCourses ? sortedAllCourses : sortedAllCourses.slice(0, 3);

    return (
      <form
        onSubmit={handleSubmit}
      >
        <div className={styles["next-step-section"]}>
          <h2 className={styles.title}>Weißt du schon, wann du loslegen willst?</h2>
          <p>Dein persönliches Angebot ist bereit – jetzt fehlt nur noch dein Starttermin.Wenn du dich noch nicht festlegen möchtest:</p>
          <button
            className="large primary button pagelink"
            onClick={handleNextStep}
            type="button"
          >
            Weiter und Kurs später reservieren
          </button>
        </div>
        <div className={styles.termine}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span className={styles["optional-label"]}>Optional</span>
            <div className="info-container" onClick={({ target }) => target.classList.toggle('active')}>
              <svg className="info-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
              <div className="info-popup">
                <p><strong>Bei Orange Drivers ist dein Stundenplan so flexibel wie du selbst.</strong></p>
                <p>Unsere Ausbildung basiert auf einem modularen System. Das bedeutet: <br />Du kannst jederzeit einsteigen und die Module so absolvieren, wie es für dich am besten passt.</p>
                <p>Du möchtest zum Beispiel im Osterkurs starten, bist aber ein paar Tage nicht verfügbar? Kein Problem: Du kannst fehlende Module einfach später im Abendkurs oder im nächsten Ferienkurs nachholen.</p>
                <p>So bleibst du flexibel – und kommst trotzdem schnell ans Ziel.</p>
              </div>
            </div>
          </div>
          {showModalInfo && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}
              onClick={() => setShowModalInfo(false)}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: '#fff',
                  padding: '2rem',
                  borderRadius: '10px',
                  maxWidth: '600px',
                  width: '90%',
                  maxHeight: '90vh',
                  overflowY: 'auto',
                  position: 'relative',
                }}
              >
                <button
                  onClick={() => setShowModalInfo(false)}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    background: 'none',
                    border: 'none',
                    fontSize: '1.5rem',
                    cursor: 'pointer',
                  }}
                  aria-label="Schließen"
                >
                  ×
                </button>
                <h3>Unser einzigartiges flexibles Kurssystem – so wie’s für dich passt!</h3>
                <p>
                  Bei Orange Drivers bestimmst du, wann’s losgeht!
                  Täglicher Kurseinstieg, freie Zeiteinteilung und ein modulares System, das sich deinem Alltag
                  anpasst.
                </p>
                <p>
                  Du willst z.B. im Osterkurs starten, bist aber ein paar Tage verhindert? Kein Stress:
                  Verpasste Module holst du einfach im Abendkurs oder beim nächsten Ferien Kurz-Kurs nach.
                  So bleibst du flexibel – und kommst trotzdem schnell ans Ziel.
                </p>
              </div>
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {chosenVariant ? (
              <div style={{ width: '100%' }}>
                <div className="courses-container">
                  <div className="date-picker-container">
                    <label>Wann möchtest du starten: </label>
                    <DatePicker
                      locale="de"
                      selected={startDate}
                      onChange={handleDateChange}
                      dateFormat="dd.MM.yyyy"
                      todayButton="Auf Heute zurücksetzen"
                      minDate={new Date()}
                      withPortal
                      onBeforeInput={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </div>

                  {nearestTermineFromInput && (
                    <div>
                      <p>
                        Der nächstmögliche Kurseinstieg ist am <strong> {new Date(nearestTermineFromInput.datum).toLocaleDateString("de-AT", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })} </strong> mit dem  <strong> {nearestTermineFromInput.modulName} </strong>  möglich.
                        <br />
                        Du findest das im Kurs
                        {" "}
                        <strong>
                          {nearestTermineFromInput.course.Name}
                        </strong>
                        {" "}
                        vom
                        {" "}
                        <strong>
                          {new Date(nearestTermineFromInput.course.Start).toLocaleDateString("de-AT", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })}
                        </strong>
                        {" "}
                        bis
                        {" "}
                        <strong>
                          {new Date(nearestTermineFromInput.course.Ende).toLocaleDateString("de-AT", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })}
                        </strong>
                      </p>
                    </div>
                  )}

                  <div className="courses-list">
                    <h3>Unsere Kurse</h3>
                    <p>Einstieg jederzeit möglich</p>

                    <label
                      className={styles.checkFerien}
                      style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
                    >
                      <input
                        type="checkbox"
                        className="custom-checkbox"
                        checked={onlyKurz}
                        onChange={(e) => {
                          setOnlyKurz(e.target.checked);
                          setShowAllCourses(false);
                        }}
                      />
                      Nur Ferien-Kurzkurse anzeigen
                    </label>

                    {coursesToShow.map(renderKursItem)}

                    {sortedAllCourses.length > 3 && (
                      <button
                        className={styles.moreBtn}
                        type="button"
                        onClick={() => setShowAllCourses(!showAllCourses)}>
                        {showAllCourses ? "Weniger anzeigen" : "Mehr anzeigen"}
                      </button>
                    )}
                  </div>


                </div>
              </div>
            ) : (
              <p>Keine Ausbildung ausgewählt</p>
            )}

          </div>
        </div>
      </form>
    );
  };

  const getVariantById = (id) => {
    for (const cat of selectedCategories) {
      const catClasses = klassen.filter(
        (klasse) => klasse && classBelongsToCategory(klasse, cat)
      );

      for (const klasse of catClasses) {
        if (Array.isArray(klasse.Kombis)) {
          for (const kombi of klasse.Kombis) {
            const kombiData = kombi.Kombinationen_id;
            if (!kombiData) {
              continue;
            }

            const ausbildungIds = kombiData.Ausbildungen;
            if (!Array.isArray(ausbildungIds)) {
              continue;
            }

            for (const ausId of ausbildungIds) {
              // if (String(ausId) === String(id)) {
              if (String(asId(ausId)) === String(id)) {
                const matchingVariant = ausbildungen.find(
                  (a) => String(a.id) === String(ausId)
                );
                if (matchingVariant) {
                  return matchingVariant;
                }
              }
            }
          }
        } else {
          console.warn("Klass hat kein Kombis Array:", klasse);
        }
      }
    }

    for (const cat of selectedCategories) {
      const catClasses = classesByCategory[cat.id] || [];
      for (const klasse of catClasses) {
        if (!klasse.Ausbildungen) {
          continue;
        }

        const available = filterAusbildungen(klasse.Ausbildungen);
        for (const variant of available) {
          if (String(variant.id) === String(id)) {
            return variant;
          }
        }
      }
    }
    return null;
  };



  const SavedSummary = ({ data, onEditClick }) => {
    const { ausbildungen } = useContext(AusbildungContext);
    const ausbildung = data.ausbildung || ausbildungen.find((a) => a.id === data.anfrage_ausbildung);
    const {
      titel,
      geschlecht,
      firstName,
      lastName,
      birthDate,
      geburtsort,
      staatsbuergerschaft,
      strasse,
      hausnummer,
      plz,
      ort,
      email,
      telefon,
      fuehrerscheinNummer,
      anfrage_ausbildung,
      ausgewaehlterOrt,
      ferien_kurs,
      fuehrerscheine,
      preise,
      angebot_preise,
      code_preise,
      ausbildung_theorie,
      ausbildung_praxis,
      ausbildung_preisinfo,
      ausbildung_blocks,
    } = data;

    return (
      <div className={styles.savedSummary}>
        <p><b style={{ color: "var(--primary)" }}>Angebot Nr. </b> {data.angebotId} | {data.angebotCreatedAt}</p>

        <p>
          {firstName} {lastName}
          <br />
          {email}
          <br />
          {telefon}
          {strasse || ""} {hausnummer || ""}
          <br />
          {plz || ""} {ort || ""}
        </p>



        {ausbildung ? (
          <div className={styles.overwievBlock}>
            <h3 style={{ color: "var(--primary)" }}>Deine Anfrage</h3>
            <p>
              Führerschein: Klasse{" "}
              {ausbildung.Klasse?.Name || ausbildung.klasse?.name || "unbekannt"}
            </p>
            <p>
              Ausbildungsvariante: {ausbildung.Name || ausbildung.name || "nicht angegeben"}
            </p>
          </div>
        ) : (
          <p>Keine Ausbildungsinformationen gefunden.</p>
        )}


        <p>
          Lieber {firstName},
          <br />
          vielen Dank für deine Anfrage! Gerne übermitteln wir dir dein persönliches Angebot.
        </p>

        <div style={{ marginLeft: '1rem' }}>

          <h2 style={{ color: "var(--primary)" }}>Dein Angebot</h2>
        </div>

        <p style={{ marginBottom: '0', color: "var(--accent)" }}><strong>Theoretischer Teil:</strong></p>
        <div
          className={styles.blockContent}
          dangerouslySetInnerHTML={{ __html: ausbildung_theorie || "<em>-</em>" }}
        />

        <p style={{ marginBottom: '0', color: "var(--accent)" }}><strong>Praktischer Teil:</strong></p>
        <div
          className={styles.blockContent}
          dangerouslySetInnerHTML={{ __html: ausbildung_praxis || "<em>-</em>" }}
        />



        <strong style={{ color: "var(--primary)" }}>Dein Preis</strong>


        <div className={styles.priceContainer}>
          {Array.isArray(preise) && preise.length > 0 ? (
            preise.map((p, index) => {
              const oldPrice = Number(p.preis).toLocaleString("de-DE", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }) + " €";

              const promoArray = Array.isArray(data.code_preise) && data.code_preise.length
                ? data.code_preise
                : data.angebot_preise || [];

              const promo = promoArray[index];
              const newPrice = promo
                ? Number(promo.preis).toLocaleString("de-DE", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }) + " €"
                : null;

              return (
                <div key={index} className={styles.priceItem}>
                  <div>
                    <strong>{p.kategorieName || "Allgemein"}</strong>
                    {p.kategorieBeschreibung && (
                      <div style={{ fontSize: "0.9em", opacity: 0.8 }}>
                        {p.kategorieBeschreibung}
                      </div>
                    )}
                  </div>

                  <div style={{ marginTop: "0.2em" }}>
                    {newPrice ? (
                      <>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#888",
                            fontSize: "0.9em",
                          }}
                        >
                          {oldPrice}
                        </span>{" "}
                        <strong style={{ fontSize: "1.1em" }}>{newPrice}</strong>
                      </>
                    ) : (
                      <strong>{oldPrice}</strong>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className={styles.noPrice}>–</div>
          )}
        </div>


        <p style={{ marginBottom: '0' }}>
          <strong>
            Wir garantieren Prüfungstermine!
          </strong>
        </p>
        <p style={{ marginTop: '0' }}>
          jeden Montag theoretische Prüfung in Baden
          <br />
          jeden Dienstag theoretische Prüfung in Traiskirchen
          <br />
          <b>
            jeden Freitag praktische Prüfung in Baden
          </b>
        </p>

      </div>
    );
  };


  const SavedSummary2 = ({ data, onEditClick, sigPadRef, handleClear, handleSave }) => {
    const { ausbildungen } = useContext(AusbildungContext);
    const ausbildung = data.ausbildung || ausbildungen.find((a) => a.id === data.anfrage_ausbildung);
    const {
      titel,
      geschlecht,
      firstName,
      lastName,
      birthDate,
      geburtsort,
      staatsbuergerschaft,
      strasse,
      hausnummer,
      plz,
      ort,
      email,
      telefon,
      fuehrerscheinNummer,
      ausgewaehlterPreis,
      anfrage_ausbildung,
      ausgewaehlterOrt,
      ferien_kurs,
      fuehrerscheine,
      preise,
      ausbildung_theorie,
      ausbildung_praxis,
      ausbildung_preisinfo,
      ausbildung_blocks,
    } = data;

    return (
      <div className={styles.savedSummary}>
        <p><b style={{ color: "var(--accent)" }}>Ausbildungsauftrag Nr. </b> {data.angebotId} | {data.angebotCreatedAt}</p>

        <p>
          {firstName} {lastName}
          <br />
          {email}
          <br />
          {telefon}
          {strasse || ""} {hausnummer || ""}
          <br />
          {plz || ""} {ort || ""}
        </p>



        {ausbildung ? (
          <div className={styles.overwievBlock}>
            <h3 style={{ color: "var(--primary)" }}>Deine Anfrage</h3>
            <p>
              Führerschein: Klasse{" "}
              {ausbildung.Klasse?.Name || ausbildung.klasse?.name || "unbekannt"}
            </p>
            <p>
              Ausbildungsvariante: {ausbildung.Name || ausbildung.name || "nicht angegeben"}
            </p>
          </div>
        ) : (
          <p>Keine Ausbildungsinformationen gefunden.</p>
        )}


        <h2 style={{ color: "var(--primary)" }}>Leistungsverzeichnis</h2>

        <p style={{ marginBottom: '0', color: "var(--accent)" }}><strong>Theoretischer Teil:</strong></p>
        <div
          className={styles.blockContent}
          dangerouslySetInnerHTML={{ __html: ausbildung_theorie || "<em>-</em>" }}
        />

        <p style={{ marginBottom: '0', color: "var(--accent)" }}><strong>Praktischer Teil:</strong></p>
        <div
          className={styles.blockContent}
          dangerouslySetInnerHTML={{ __html: ausbildung_praxis || "<em>-</em>" }}
        />

        <div style={{ lineHeight: '0' }}>
          <strong style={{ color: "var(--primary)" }}>Dein Preis</strong>
          <p>(inkl. Bearbeitungsgebühr, exkl. behördliche Gebühren)</p>
        </div>

        <div className={styles.priceContainer}>
          {(() => {
            const selectedPrice = preise?.find(
              (p) => Number(p.preis || p.Preis) === Number(ausgewaehlterPreis)
            );

            if (selectedPrice) {
              const preisNumber = Number(selectedPrice.preis || selectedPrice.Preis);
              const catId = selectedPrice.Preiskategorie || selectedPrice.kategorie_id;
              const cat =
                priceCategories.find((p) => p.id === catId) ||
                priceCategories.find((p) => p.Name === selectedPrice.kategorieName);

              return (
                <div className={styles.priceItem}>
                  {cat?.Name || selectedPrice.kategorieName || "Allgemein"} –{" "}
                  {preisNumber.toLocaleString("de-DE", { minimumFractionDigits: 0 })} €{" "}
                  {cat?.Beschreibung ? `(${cat.Beschreibung})` : ""}
                </div>
              );
            } else if (ausgewaehlterPreis) {
              return (
                <div className={styles.priceItem}>
                  {ausgewaehlterPreis.toLocaleString("de-DE", { minimumFractionDigits: 0 })} €
                </div>
              );
            } else {
              return <div className={styles.noPrice}>–</div>;
            }
          })()}
        </div>

        {showSignatureModal && (
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
              <h3>Unterschrift</h3>

              <SignaturePad
                ref={sigPadRef}
                canvasProps={{ className: styles.signatureCanvas }}
              />

              <div style={{ marginTop: '1rem' }}>
                <button
                  className={styles.resetBtn}
                  onClick={handleClear}
                  type="button"
                >
                  <img src={DeleteIcon} alt="Unterschrift zurücksetzen" />
                  Unterschrift zurücksetzen
                </button>

              </div>

              <div style={{ marginTop: '1rem' }}>
                {/* <button
                  className={styles.signatureBtn}
                  onClick={handleSaveSignatureAndClose}
                  type="button"
                >
                  Unterschreiben!
                </button> */}

                <button
                  className={styles["summary-submit"]}
                  onClick={handleSignAndUpdate}
                >
                  Unterschreiben und Daten ergänzen
                </button>


              </div>
              <div style={{ marginTop: '1rem' }}>
                {/* <button
                  className={styles["summary-submit"]}
                  onClick={() => setShowSignatureModal(false)}
                >
                  Schließen
                </button> */}
                <button
                  className={styles.cancelBtn}
                  onClick={() => {
                    setShowSignatureModal(false);
                    setSigStep(0);
                    setSigFileStudent(null);
                    setSigFileGuardian(null);
                    if (sigPadRef.current) sigPadRef.current.clear();
                  }}
                  type="button"
                >
                  Abbrechen
                </button>

              </div>
            </div>
          </div>
        )}

      </div>
    );
  };


  // const renderStep7 = () => {

  //   const isReadOnly = isAngebotForAgree && !isModerator;

  //   let chosenVariant = null;
  //   let variantType = "";
  //   if (selectedAusbildungCombiId) {
  //     chosenVariant = getVariantById(selectedAusbildungCombiId);
  //     variantType = "Ausbildung aus Kombination";
  //   } else if (selectedAusbildungId) {
  //     chosenVariant = getVariantById(selectedAusbildungId);
  //     variantType = "Ausbildung aus Klasse";
  //   }

  //   let variantPrices = [];
  //   if (chosenVariant) {
  //     const mappings = ausbildungenPreise.filter(
  //       (m) => m.Ausbildungen_id === chosenVariant.id
  //     );
  //     variantPrices = mappings
  //       .map((m) => preise.find((p) => p.id === m.Preise_id))
  //       .filter(Boolean);
  //   }


  //   const getFinalPrices = () => {
  //     if (codePreise?.length) return codePreise;
  //     if (angebotPreise?.length) return angebotPreise;
  //     return preiseOptions;
  //   };


  //   const firmaPrices = getPricesForAusbildung(chosenVariant.id);

  //   return (
  //     <div >
  //       {isEditing ? (
  //         <div className={styles["next-step-section"]}>
  //           <h2 className={styles.title}>Fast geschafft!</h2>
  //           <p>
  //             Damit wir dir dein persönliches Angebot direkt per E-Mail schicken können, brauchen wir jetzt nur
  //             noch deine Kontaktdaten. Versprochen: Wir verwenden deine Angaben nur für dieses Angebot – sonst für nichts.
  //           </p>

  //           <div style={{ position: "relative" }}>

  //             <form
  //               className={styles.form}
  //               style={!isAngebotForAgree ? { paddingBottom: "2.5rem", marginTop: '2.5rem' } : {}}
  //             >

  //               <h3>Persönliche Daten</h3>
  //               {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
  //                 <>
  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>
  //                       Titel

  //                     </label>
  //                     <input
  //                       type="text"
  //                       value={titel}
  //                       onChange={(e) => setTitel(e.target.value)}
  //                       required
  //                       className={styles.input}
  //                     />
  //                   </div>

  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>
  //                       Geschlecht

  //                     </label>
  //                     <select
  //                       value={geschlecht}
  //                       onChange={(e) => setGeschlecht(e.target.value)}
  //                       className={styles.input}
  //                     >
  //                       <option value="">Bitte wählen</option>
  //                       <option value="w">Weiblich</option>
  //                       <option value="m">Männlich</option>
  //                       <option value="d">Divers</option>
  //                     </select>
  //                   </div>
  //                 </>
  //               )}
  //               {submissionSuccess && !isModerator && (
  //                 <div className={styles.successMSG}>
  //                   ✅ Deine Anfrage wurde erfolgreich versendet! Wir melden uns in Kürze per E-Mail.
  //                 </div>
  //               )}
  //               <div className={styles.formGroup}>
  //                 <label className={styles.label}>
  //                   Vorname

  //                 </label>
  //                 <input
  //                   type="text"
  //                   value={firstName}
  //                   onChange={(e) => setFirstName(e.target.value)}
  //                   required
  //                   className={`${styles.input} ${styles.anfrage_input_name}`}
  //                 />
  //               </div>
  //               <div className={styles.formGroup}>
  //                 <label className={styles.label}>
  //                   Nachname

  //                 </label>
  //                 <input
  //                   type="text"
  //                   value={lastName}
  //                   onChange={(e) => setLastName(e.target.value)}
  //                   required
  //                   className={`${styles.input} ${styles.anfrage_input_name}`}
  //                 />
  //               </div>

  //               {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
  //                 <>
  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>
  //                       Geburtsdatum
  //                     </label>
  //                     <div style={{ width: "60%" }}>
  //                       <DatePicker
  //                         locale="de"
  //                         selected={birthDate}
  //                         onChange={(date) => setBirthDate(date)}
  //                         dateFormat="dd.MM.yyyy"
  //                         maxDate={subYears(new Date(), 14)}
  //                         minDate={subYears(new Date(), 100)}
  //                         showYearDropdown
  //                         showMonthDropdown
  //                         scrollableYearDropdown
  //                         yearDropdownItemNumber={100}
  //                         className={styles.input}
  //                         withPortal
  //                       />
  //                     </div>
  //                   </div>

  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>Geburtsort</label>
  //                     <input
  //                       type="text"
  //                       value={geburtsort}
  //                       onChange={(e) => setGeburtsort(e.target.value)}
  //                       className={styles.input}
  //                     />
  //                   </div>

  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>Staatsbürgerschaft</label>
  //                     <select
  //                       value={staatsbuergerschaft}
  //                       onChange={(e) => setStaatsbuergerschaft(e.target.value)}
  //                       className={styles.input}
  //                     >
  //                       <option value="">Bitte wählen</option>
  //                       <optgroup label="EU-Länder">
  //                         {euCountryNames.map((country, index) => (
  //                           <option key={`eu-${index}`} value={country}>
  //                             {country}
  //                           </option>
  //                         ))}
  //                       </optgroup>
  //                       <optgroup label="Nicht-EU-Länder">
  //                         {nonEuCountryNames.map((country, index) => (
  //                           <option key={`non-eu-${index}`} value={country}>
  //                             {country}
  //                           </option>
  //                         ))}
  //                       </optgroup>
  //                     </select>
  //                   </div>

  //                 </>
  //               )}

  //               {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
  //                 <>
  //                   <h3>Adresse Daten</h3>
  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>
  //                       Straße

  //                     </label>
  //                     <input
  //                       type="text"
  //                       value={strasse}
  //                       onChange={(e) => setStrasse(e.target.value)}
  //                       className={styles.input}
  //                     />
  //                   </div>
  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>
  //                       Hausnummer

  //                     </label>
  //                     <input
  //                       type="text"
  //                       value={hausnummer}
  //                       onChange={(e) => setHausnummer(e.target.value)}
  //                       className={styles.input}
  //                     />
  //                   </div>
  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>
  //                       PLZ

  //                     </label>
  //                     <input
  //                       type="text"
  //                       value={plz}
  //                       onChange={(e) => setPlz(e.target.value)}
  //                       className={styles.input}
  //                     />
  //                   </div>
  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>
  //                       Ort

  //                     </label>
  //                     <input
  //                       type="text"
  //                       value={ort}
  //                       onChange={(e) => setOrt(e.target.value)}
  //                       className={styles.input}
  //                     />
  //                   </div>
  //                 </>
  //               )}

  //               <h3>Kontakt Daten</h3>
  //               <div className={styles.formGroup}>
  //                 <label className={styles.label}>
  //                   Email

  //                 </label>
  //                 <input
  //                   type="email"
  //                   value={email}
  //                   onChange={(e) => setEmail(e.target.value)}
  //                   required
  //                   className={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                   disabled={isReadOnly}
  //                 />
  //               </div>
  //               <div className={styles.formGroup}>
  //                 <label className={styles.label}>
  //                   Email bestätgen

  //                 </label>
  //                 <input
  //                   type="email"
  //                   value={email2}
  //                   onChange={(e) => setEmail2(e.target.value)}
  //                   required
  //                   className={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                   disabled={isReadOnly}
  //                 />
  //               </div>
  //               <div className={styles.formGroup}>
  //                 <label className={styles.label}>
  //                   Telefon

  //                 </label>

  //                 <PhoneInput
  //                   country={'at'}
  //                   value={telefon}
  //                   onChange={(value) => setTelefon(value)}
  //                   preferredCountries={['at', 'de', 'ch']}
  //                   enableSearch={true}
  //                   disableSearchIcon={false}
  //                   inputProps={{
  //                     name: 'telefon',
  //                     required: true,
  //                     id: 'telefon',
  //                   }}
  //                   containerClass={styles.formGroup}
  //                   inputClass={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                 />
  //               </div>

  //               {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
  //                 <>
  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label}>
  //                       Führerscheinnummer

  //                     </label>
  //                     <input
  //                       type="text"
  //                       value={fuehrerscheinNummer}
  //                       onChange={(e) => setFuehrerscheinNummer(e.target.value)}
  //                       required
  //                       className={styles.input}
  //                     />
  //                   </div>

  //                   {(isAngebotForAgree || !!user) && (
  //                     <div className={styles.formGroup}>
  //                       <label className={styles.label}>
  //                         Preis auswählen
  //                       </label>

  //                       <div className={styles.priceOptionsWrapper}>
  //                         {(!!user ? variantPrices : preiseOptions).map((price, index) => {
  //                           const preisNumber = Number(price.Preis || price.preis);
  //                           const angebotspreisNumber = Number(price.Angebotspreis || price.preis);
  //                           const catId = price.Preiskategorie || price.kategorie_id;

  //                           const cat =
  //                             priceCategories.find((p) => p.id === catId) ||
  //                             priceCategories.find((p) => p.Name === price.kategorieName);

  //                           const angebotStart = price.Angebot_start && new Date(price.Angebot_start);
  //                           const angebotEnd = price.Angebot_end && new Date(price.Angebot_end);
  //                           const today = new Date();

  //                           const isRealAngebot =
  //                             angebotStart &&
  //                             angebotEnd &&
  //                             today >= angebotStart &&
  //                             today <= angebotEnd &&
  //                             price.Angebotspreis;

  //                           const isReduced =
  //                             price.Preis && price.preis && Number(price.Preis) !== Number(price.preis);

  //                           const finalPreis = isRealAngebot
  //                             ? angebotspreisNumber
  //                             : preisNumber;

  //                           const selected = Number(selectedPreis) === finalPreis;

  //                           return (
  //                             <div
  //                               key={index}
  //                               className={`${styles.priceOption} ${selected ? styles.selected : ""}`}
  //                               onClick={() => setSelectedPreis(finalPreis)}
  //                             >
  //                               <strong>{cat?.Name || price.kategorieName || "Allgemein"}</strong>
  //                               <div className={styles.priceAmount}>
  //                                 {isRealAngebot ? (
  //                                   <>
  //                                     <s>{preisNumber.toLocaleString("de-DE")} €</s>{" "}
  //                                     <strong>{angebotspreisNumber.toLocaleString("de-DE")} €</strong>
  //                                   </>
  //                                 ) : isReduced ? (
  //                                   <>
  //                                     <s>{Number(price.Preis).toLocaleString("de-DE")} €</s>{" "}
  //                                     <strong>{Number(price.preis).toLocaleString("de-DE")} €</strong>
  //                                   </>
  //                                 ) : (
  //                                   <span>{finalPreis.toLocaleString("de-DE")} €</span>
  //                                 )}
  //                               </div>
  //                               <small>{cat?.Beschreibung || price.kategorieBeschreibung || ""}</small>
  //                             </div>
  //                           );
  //                         })}
  //                       </div>
  //                     </div>
  //                   )}


  //                   {isModerator && (
  //                     <>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Rabatt (in €)
  //                         </label>
  //                         <input
  //                           type="number"
  //                           className={styles.input}
  //                           value={rabatt}
  //                           onChange={(e) => setRabatt(Number(e.target.value))}
  //                           min={0}
  //                           step={1}
  //                         />
  //                       </div>

  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Endpreis nach Rabatt
  //                         </label>
  //                         <input
  //                           type="text"
  //                           className={styles.input}
  //                           value={`${finalPreis.toLocaleString("de-DE", { minimumFractionDigits: 0 })} €`}
  //                           readOnly
  //                         />
  //                       </div>
  //                     </>
  //                   )}

  //                   <>
  //                     <div className={styles.formGroup}>
  //                       <div>
  //                         <label className={styles.label}>Dokument hochladen:</label>
  //                         <div className={styles.docsLoaderWrap}>
  //                           <div>
  //                             <p>
  //                               Laden Sie hier die Vorderseite Ihres Ausweisdokumentes{" "}
  //                               <b>(Personalausweis, Reisepass, Führerschein oder Aufenthaltstitel)</b> hoch
  //                             </p>
  //                             <ul>
  //                               <li>Stellen Sie sicher das Foto von guter Qualität ist</li>
  //                               <li>Verwenden Sie keinen Blitz</li>
  //                               <li>Stellen Sie sicher das der Ausweis komplett sichbar ist</li>
  //                             </ul>
  //                           </div>

  //                           <label className={styles.fileUploadCustom}>
  //                             <div className={styles.plusCircle}>+</div>
  //                             <span className={styles.fileHint}>(z. B. Reisepass, Ausweis, Führerschein)</span>
  //                             <input
  //                               type="file"
  //                               multiple
  //                               accept="image/*"
  //                               onChange={(e) => {
  //                                 const newFiles = Array.from(e.target.files);
  //                                 setAttachments((prev) => [...prev, ...newFiles]);
  //                               }}
  //                               className={styles.inputHidden}
  //                             />
  //                           </label>

  //                           {attachments.length > 0 && (
  //                             <ul className={styles.fileList}>
  //                               {attachments.map((file, index) => (
  //                                 <li key={index} className={styles.fileListItem}>
  //                                   {file.name}
  //                                   <button
  //                                     type="button"
  //                                     className={styles.removeFileButton}
  //                                     onClick={() => {
  //                                       setAttachments((prev) => prev.filter((_, i) => i !== index));
  //                                     }}
  //                                   >
  //                                     ×
  //                                   </button>
  //                                 </li>
  //                               ))}
  //                             </ul>
  //                           )}
  //                           <br />
  //                           <div className={styles.formGroup}>
  //                             <div style={{ width: '100%' }}>
  //                               <label className={styles.label}>Erste Hilfe Kurs:</label>
  //                               <p>mind. 6 Stunden erforderlich</p>

  //                               <label className={`${styles.fileUploadCustom} ${styles.smallFileUpload}`}>
  //                                 <div className={styles.plusCircle}>+</div>
  //                                 <span className={styles.fileHint}>(z. B. Kursbestätigung als PDF oder Bild)</span>
  //                                 <input
  //                                   type="file"
  //                                   multiple
  //                                   accept="image/*,application/pdf"
  //                                   onChange={(e) => {
  //                                     const newFiles = Array.from(e.target.files);
  //                                     setAttachments((prev) => [...prev, ...newFiles]);
  //                                   }}
  //                                   className={styles.inputHidden}
  //                                 />
  //                               </label>
  //                             </div>
  //                           </div>
  //                           <br />
  //                           <div className={styles.formGroup}>
  //                             <div style={{ width: '100%' }}>
  //                               <label className={styles.label}>Ärztliches Gutachten:</label>
  //                               <p>Ab Untersuchung 18 Monate gültig. Bereits gültiges Ärztliches Gutachten muss direkt bei BH eingereicht werden.</p>

  //                               <label className={`${styles.fileUploadCustom} ${styles.smallFileUpload}`}>
  //                                 <div className={styles.plusCircle}>+</div>
  //                                 <span className={styles.fileHint}>(z. B. Gutachten als PDF oder Bild)</span>
  //                                 <input
  //                                   type="file"
  //                                   multiple
  //                                   accept="image/*,application/pdf"
  //                                   onChange={(e) => {
  //                                     const newFiles = Array.from(e.target.files);
  //                                     setAttachments((prev) => [...prev, ...newFiles]);
  //                                   }}
  //                                   className={styles.inputHidden}
  //                                 />
  //                               </label>
  //                             </div>
  //                           </div>


  //                         </div>
  //                       </div>
  //                     </div>
  //                   </>
  //                 </>
  //               )}

  //               <div className={styles.formGroup}>
  //                 <label className={styles.label} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
  //                   <input
  //                     type="checkbox"
  //                     checked={agbChecked}
  //                     onChange={(e) => setAgbChecked(e.target.checked)}
  //                     required
  //                   />
  //                   <span style={{ fontSize: '0.8rem' }}>
  //                     Ich bin mit den <a href="/agb" target="_blank" rel="noopener noreferrer">AGBs</a> und&nbsp;
  //                     <a href="/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzbestimmungen</a> einverstanden.
  //                   </span>
  //                 </label>
  //               </div>

  //               {isAngebotForAgree && (
  //                 <div className={styles.formGroup}>
  //                   <button
  //                     type="button"
  //                     onClick={handleUpdateData}
  //                     disabled={isUpdating}
  //                     className={styles['summary-submit']}
  //                   >
  //                     {isUpdating ? "Speichern..." : "Daten ergänzen"}
  //                   </button>
  //                 </div>
  //               )}

  //               {updateMessage && (
  //                 <div className={styles.updateMessage}>
  //                   {updateMessage}
  //                 </div>
  //               )}


  //               {isModerator && (
  //                 <button
  //                   className={styles["summary-submit"]}
  //                   type="submit"
  //                   onClick={handleSubmit}
  //                   disabled={submitting}
  //                 >
  //                   Speichern
  //                 </button>
  //               )}

  //             </form>

  //           </div>
  //         </div>
  //       ) : savedSummary2Data ? (
  //         <SavedSummary2
  //           key={savedSummary2Data.timestamp}
  //           data={savedSummary2Data}
  //           onEditClick={() => {
  //             setIsEditing(true);
  //             setSavedSummary2Data(null);
  //           }}
  //           sigPadRef={sigPadRef}
  //           handleClear={handleClear}
  //           handleSave={handleSave}
  //         />

  //       ) : saved && isModerator ? (
  //         <SavedSummary
  //           key={savedSummaryData.timestamp}
  //           data={savedSummaryData}
  //           onEditClick={() => {
  //             setIsEditing(true);
  //             setSaved(false);
  //           }}
  //         />
  //       ) : (
  //         <div style={{ padding: '1.5rem' }}>
  //           <h2 className={styles.title}>Fast geschafft!</h2>
  //           <p>
  //             Damit wir dir dein persönliches Angebot direkt per E-Mail schicken können, brauchen wir jetzt nur
  //             noch deine Kontaktdaten. Versprochen: Wir verwenden deine Angaben nur für dieses Angebot – sonst für nichts.
  //           </p>

  //           <div style={{ position: "relative" }}>

  //             <form
  //               className={styles.form}
  //               style={!isAngebotForAgree ? { paddingBottom: "2.5rem", marginTop: '2.5rem' } : {}}
  //             >
  //               <div style={{ display: "flex", flexDirection: "column" }}>
  //                 <div style={{ alignSelf: "end", width: "60%" }}>
  //                   {isModerator && (
  //                     <div className={styles.toggleButtonsWrapper}>
  //                       <button
  //                         type="button"
  //                         onClick={() => setFormMode("kunde")}
  //                         className={`${styles.toggleButton} ${formMode === "kunde" ? styles.toggleButtonActive : ''}`}
  //                       >
  //                         Kunde
  //                       </button>
  //                       <button
  //                         type="button"
  //                         onClick={() => setFormMode("firma")}
  //                         className={`${styles.toggleButton} ${formMode === "firma" ? styles.toggleButtonActive : ''}`}
  //                       >
  //                         Firma
  //                       </button>
  //                     </div>
  //                   )}
  //                 </div>
  //                 <div>
  //                   {formMode === "kunde" ? (
  //                     <>
  //                       <h3>Persönliche Daten</h3>
  //                       {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
  //                         <>
  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Titel

  //                             </label>
  //                             <input
  //                               type="text"
  //                               value={titel}
  //                               onChange={(e) => setTitel(e.target.value)}
  //                               required
  //                               className={styles.input}
  //                             />
  //                           </div>

  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Geschlecht

  //                             </label>
  //                             <select
  //                               value={geschlecht}
  //                               onChange={(e) => setGeschlecht(e.target.value)}
  //                               className={styles.input}
  //                             >
  //                               <option value="">Bitte wählen</option>
  //                               <option value="w">Weiblich</option>
  //                               <option value="m">Männlich</option>
  //                               <option value="d">Divers</option>
  //                             </select>
  //                           </div>
  //                         </>
  //                       )}

  //                       <div className={styles.formGroup}>
  //                         {submissionSuccess && !isModerator && (
  //                           <div className={styles.successMSG}>
  //                             ✅ Deine Anfrage wurde erfolgreich versendet! Wir melden uns in Kürze per E-Mail.
  //                           </div>
  //                         )}
  //                         <label className={styles.label}>
  //                           Vorname

  //                         </label>
  //                         <input
  //                           type="text"
  //                           value={firstName}
  //                           onChange={(e) => setFirstName(e.target.value)}
  //                           required
  //                           className={`${styles.input} ${styles.anfrage_input_name}`}
  //                         />
  //                         {errors.firstName && <p className={styles.error2}>{errors.firstName}</p>}

  //                       </div>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Nachname

  //                         </label>
  //                         <input
  //                           type="text"
  //                           value={lastName}
  //                           onChange={(e) => setLastName(e.target.value)}
  //                           required
  //                           className={`${styles.input} ${styles.anfrage_input_name}`}
  //                         />
  //                         {errors.lastName && <p className={styles.error2}>{errors.lastName}</p>}

  //                       </div>

  //                       {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
  //                         <>
  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Geburtsdatum

  //                             </label>

  //                             <div style={{ width: "60%" }}>

  //                               <DatePicker
  //                                 locale="de"
  //                                 selected={birthDate}
  //                                 onChange={(date) => setBirthDate(date)}
  //                                 dateFormat="dd.MM.yyyy"
  //                                 maxDate={subYears(new Date(), 14)}
  //                                 minDate={subYears(new Date(), 100)}
  //                                 showYearDropdown
  //                                 showMonthDropdown
  //                                 scrollableYearDropdown
  //                                 yearDropdownItemNumber={100}
  //                                 className={styles.input}
  //                                 withPortal
  //                               />
  //                             </div>
  //                           </div>

  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>Geburtsort</label>
  //                             <input
  //                               type="text"
  //                               value={geburtsort}
  //                               onChange={(e) => setGeburtsort(e.target.value)}
  //                               className={styles.input}
  //                             />
  //                           </div>

  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>Staatsbürgerschaft</label>
  //                             <select
  //                               value={staatsbuergerschaft}
  //                               onChange={(e) => setStaatsbuergerschaft(e.target.value)}
  //                               className={styles.input}
  //                             >
  //                               <option value="">Bitte wählen</option>
  //                               <optgroup label="EU-Länder">
  //                                 {euCountryNames.map((country, index) => (
  //                                   <option key={`eu-${index}`} value={country}>
  //                                     {country}
  //                                   </option>
  //                                 ))}
  //                               </optgroup>
  //                               <optgroup label="Nicht-EU-Länder">
  //                                 {nonEuCountryNames.map((country, index) => (
  //                                   <option key={`non-eu-${index}`} value={country}>
  //                                     {country}
  //                                   </option>
  //                                 ))}
  //                               </optgroup>
  //                             </select>
  //                           </div>

  //                         </>
  //                       )}

  //                       {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
  //                         <>
  //                           <h3>Adresse Daten</h3>
  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Straße

  //                             </label>
  //                             <input
  //                               type="text"
  //                               value={strasse}
  //                               onChange={(e) => setStrasse(e.target.value)}
  //                               className={styles.input}
  //                             />
  //                           </div>
  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Hausnummer

  //                             </label>
  //                             <input
  //                               type="text"
  //                               value={hausnummer}
  //                               onChange={(e) => setHausnummer(e.target.value)}
  //                               className={styles.input}
  //                             />
  //                           </div>
  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               PLZ

  //                             </label>
  //                             <input
  //                               type="text"
  //                               value={plz}
  //                               onChange={(e) => setPlz(e.target.value)}
  //                               className={styles.input}
  //                             />
  //                           </div>
  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Ort

  //                             </label>
  //                             <input
  //                               type="text"
  //                               value={ort}
  //                               onChange={(e) => setOrt(e.target.value)}
  //                               className={styles.input}
  //                             />
  //                           </div>
  //                         </>
  //                       )}

  //                       <h3>Kontakt Daten</h3>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Email

  //                         </label>
  //                         <input
  //                           type="email"
  //                           value={email}
  //                           onChange={(e) => setEmail(e.target.value)}
  //                           required
  //                           className={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                           disabled={isReadOnly}
  //                         />
  //                         {errors.email && <p className={styles.error2}>{errors.email}</p>}

  //                       </div>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Email bestätigen

  //                         </label>
  //                         <input
  //                           type="email"
  //                           value={email2}
  //                           onChange={(e) => setEmail2(e.target.value)}
  //                           required
  //                           className={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                           disabled={isReadOnly}
  //                         />
  //                         {errors.email2 && <p className={styles.error2}>{errors.email2}</p>}

  //                       </div>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Telefon

  //                         </label>

  //                         <PhoneInput
  //                           country={'at'}
  //                           value={telefon}
  //                           onChange={(value) => setTelefon(value)}
  //                           preferredCountries={['at', 'de', 'ch']}
  //                           enableSearch={true}
  //                           disableSearchIcon={false}
  //                           inputProps={{
  //                             name: 'telefon',
  //                             required: true,
  //                             id: 'telefon',
  //                           }}
  //                           containerClass={styles.formGroup}
  //                           inputClass={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                         />

  //                         {errors.telefon && <p className={styles.error2}>{errors.telefon}</p>}

  //                       </div>

  //                       {!isAngebotForAgree && (
  //                         <div className={styles["start-ort-container"]}>
  //                           <h3 className={styles["start-ort-title"]}>Wo möchtest du starten?</h3>
  //                           {loadingPlaces ? (
  //                             <p>Laden der Standorte...</p>
  //                           ) : errorPlaces ? (
  //                             <p>Fehler beim Laden der Standorte: {errorPlaces}</p>
  //                           ) : places && places.length > 0 ? (
  //                             (() => {
  //                               const uniqueOrte = Array.from(new Set(places.map((place) => place.Ort)));

  //                               return (
  //                                 <div className={styles["start-ort-grid"]}>
  //                                   {uniqueOrte.map((ort, idx) => (
  //                                     <div
  //                                       key={idx}
  //                                       className={`${styles["start-ort-item"]} ${selectedPlace === ort ? styles["start-ort-item-selected"] : ""
  //                                         }`}
  //                                       onClick={() => setSelectedPlace(ort)}
  //                                     >
  //                                       {ort}
  //                                     </div>
  //                                   ))}
  //                                   <div
  //                                     className={`${styles["start-ort-item"]} ${selectedPlace === "egal" ? styles["start-ort-item-selected"] : ""
  //                                       }`}
  //                                     onClick={() => setSelectedPlace("egal")}
  //                                   >
  //                                     egal
  //                                   </div>
  //                                 </div>
  //                               );
  //                             })()
  //                           ) : (
  //                             <p>Standorte nicht gefunden</p>
  //                           )}
  //                         </div>
  //                       )}


  //                       {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
  //                         <>
  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Führerscheinnummer

  //                             </label>
  //                             <input
  //                               type="text"
  //                               value={fuehrerscheinNummer}
  //                               onChange={(e) => setFuehrerscheinNummer(e.target.value)}
  //                               required
  //                               className={styles.input}
  //                             />
  //                           </div>


  //                           {(isAngebotForAgree || !!user) && (
  //                             <div className={styles.formGroup}>
  //                               <label className={styles.label}>
  //                                 Preis auswählen!
  //                               </label>

  //                               <div className={styles.priceOptionsWrapper}>
  //                                 {(user ? variantPrices : getFinalPrices()).map((price, index) => {
  //                                   const preisNumber = Number(price.Preis || price.preis);
  //                                   const angebotspreisNumber = Number(price.Angebotspreis || price.preis);
  //                                   const catId = price.Preiskategorie || price.kategorie_id;

  //                                   const cat =
  //                                     priceCategories.find((p) => p.id === catId) ||
  //                                     priceCategories.find((p) => p.Name === price.kategorieName);

  //                                   console.log("CAT:", cat);
  //                                   console.log("PRICE:", price);

  //                                   const isRealAngebot =
  //                                     price.Angebotspreis && price.Angebot_start && price.Angebot_end;
  //                                   const isReduced =
  //                                     price.Preis && price.preis && Number(price.Preis) !== Number(price.preis);

  //                                   const selected = angebotspreisNumber === Number(selectedPreis);

  //                                   return (
  //                                     <div
  //                                       key={index}
  //                                       className={`${styles.priceOption} ${selected ? styles.selected : ""}`}
  //                                       onClick={() => setSelectedPreis(angebotspreisNumber)}
  //                                     >
  //                                       <strong>
  //                                         {cat?.Name || price.kategorieName || "Allgemein"}{" "}
  //                                         {cat?.Code || price.kategorieCode ? (
  //                                           <span className={styles.code}>({cat?.Code || price.kategorieCode})</span>
  //                                         ) : null}
  //                                       </strong>

  //                                       <div className={styles.priceAmount}>
  //                                         {isRealAngebot || isReduced ? (
  //                                           <>
  //                                             <s>{preisNumber.toLocaleString("de-DE")} €</s>{" "}
  //                                             <strong>{angebotspreisNumber.toLocaleString("de-DE")} €</strong>
  //                                           </>
  //                                         ) : (
  //                                           <span>{angebotspreisNumber.toLocaleString("de-DE")} €</span>
  //                                         )}
  //                                       </div>

  //                                       <small>{cat?.Beschreibung || price.kategorieBeschreibung || ""}</small>
  //                                     </div>

  //                                   );
  //                                 })}
  //                               </div>
  //                             </div>
  //                           )}


  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>Dokument hochladen:</label>

  //                             <label className={styles.fileUploadCustom}>
  //                               <div className={styles.plusCircle}>+</div>
  //                               <span className={styles.fileHint}>
  //                                 (z. B. Reisepass, Ausweis, Führerschein)
  //                               </span>
  //                               <input
  //                                 type="file"
  //                                 multiple
  //                                 accept="image/*"
  //                                 onChange={(e) => {
  //                                   const newFiles = Array.from(e.target.files);
  //                                   setAttachments((prev) => [...prev, ...newFiles]);
  //                                 }}
  //                                 className={styles.inputHidden}
  //                               />
  //                             </label>


  //                           </div>

  //                           {attachments.length > 0 && (
  //                             <ul className={styles.fileList}>
  //                               {attachments.map((file, index) => (
  //                                 <li key={index} className={styles.fileListItem}>
  //                                   {file.name}
  //                                   <button
  //                                     type="button"
  //                                     className={styles.removeFileButton}
  //                                     onClick={() => {
  //                                       setAttachments((prev) =>
  //                                         prev.filter((_, i) => i !== index)
  //                                       );
  //                                     }}
  //                                   >
  //                                     ×
  //                                   </button>
  //                                 </li>
  //                               ))}
  //                             </ul>
  //                           )}


  //                         </>
  //                       )}


  //                       {!isAngebotForAgree && (
  //                         <>
  //                           {isModerator ? (
  //                             <div className={styles.formGroup}>
  //                               <label className={styles.label}>Gutscheincode auswählen</label>
  //                               <select
  //                                 className={styles.input}
  //                                 value={selectedGutscheinId || ""}
  //                                 onChange={(e) => setSelectedGutscheinId(Number(e.target.value))}
  //                               >
  //                                 <option value="">— Kein Gutschein ausgewählt —</option>
  //                                 {availableGutscheine.map((g) => (
  //                                   <option key={g.id} value={g.id}>
  //                                     {g.Code} – {Number(g.Rabatt).toFixed(2)} €
  //                                     {g.Startdatum && g.Enddatum
  //                                       ? ` (${new Date(g.Startdatum).toLocaleDateString("de-DE")} bis ${new Date(g.Enddatum).toLocaleDateString("de-DE")})`
  //                                       : ""}
  //                                   </option>
  //                                 ))}
  //                               </select>
  //                             </div>
  //                           ) : (
  //                             <div className={styles.formGroup}>
  //                               <label className={styles.label}>
  //                                 <span style={{ fontSize: "0.8rem" }}>Gutscheincode:</span>
  //                                 <input
  //                                   type="text"
  //                                   value={gutscheinCode}
  //                                   onChange={(e) => {
  //                                     setGutscheinCode(e.target.value);
  //                                     setGutscheinChecked(false);
  //                                     setGutscheinValid(false);
  //                                     setGutscheinError("");
  //                                   }}
  //                                   placeholder="z. B. SOMMER2025"
  //                                   className={styles.input}
  //                                 />
  //                                 <button
  //                                   type="button"
  //                                   onClick={handleCheckGutschein}
  //                                   className={styles.checkButton}
  //                                   style={{
  //                                     padding: "0.25rem 0.5rem",
  //                                     fontSize: "0.75rem",
  //                                     cursor: "pointer",
  //                                     border: "1px solid #ccc",
  //                                     borderRadius: "4px",
  //                                     background: "#f0f0f0",
  //                                   }}
  //                                 >
  //                                   Prüfen
  //                                 </button>
  //                               </label>

  //                               {gutscheinChecked && gutscheinValid && gutscheinAppliedData && (
  //                                 <div
  //                                   style={{
  //                                     marginTop: "0.25rem",
  //                                     fontSize: "0.75rem",
  //                                     color: "green",
  //                                     background: "#e6ffee",
  //                                     padding: "0.25rem 0.5rem",
  //                                     borderRadius: "4px",
  //                                     display: "inline-block",
  //                                   }}
  //                                 >
  //                                   ✅ {gutscheinAppliedData.code} – {gutscheinAppliedData.rabatt.toFixed(2)} €
  //                                 </div>
  //                               )}

  //                               {gutscheinChecked && !gutscheinValid && (
  //                                 <div
  //                                   style={{
  //                                     marginTop: "0.25rem",
  //                                     fontSize: "0.75rem",
  //                                     color: "red",
  //                                   }}
  //                                 >
  //                                   {gutscheinError}
  //                                 </div>
  //                               )}
  //                             </div>
  //                           )}
  //                         </>
  //                       )}
  //                     </>
  //                   ) : (
  //                     <>
  //                       <h3>Persönliche Daten</h3>
  //                       <div className={styles.formGroup}>
  //                         {submissionSuccess && !isModerator && (
  //                           <div className={styles.successMSG}>
  //                             ✅ Deine Anfrage wurde erfolgreich versendet! Wir melden uns in Kürze per E-Mail.
  //                           </div>
  //                         )}
  //                         <label className={styles.label}>
  //                           Firm Name
  //                         </label>
  //                         <input
  //                           type="text"
  //                           value={firstName}
  //                           onChange={(e) => setFirstName(e.target.value)}
  //                           required
  //                           className={styles.input}
  //                         />
  //                         {errors.firstName && <p className={styles.error2}>{errors.firstName}</p>}

  //                       </div>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Kontakt Name
  //                         </label>
  //                         <input
  //                           type="text"
  //                           value={lastName}
  //                           onChange={(e) => setLastName(e.target.value)}
  //                           required
  //                           className={styles.input}
  //                         />
  //                         {errors.lastName && <p className={styles.error2}>{errors.lastName}</p>}

  //                       </div>
  //                       <h3>Kontakt Daten</h3>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Email
  //                         </label>
  //                         <input
  //                           type="email"
  //                           value={email}
  //                           onChange={(e) => setEmail(e.target.value)}
  //                           required
  //                           className={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                           disabled={isReadOnly}
  //                         />
  //                         {errors.email && <p className={styles.error2}>{errors.email}</p>}

  //                       </div>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Email bestätigen
  //                         </label>
  //                         <input
  //                           type="email"
  //                           value={email2}
  //                           onChange={(e) => setEmail2(e.target.value)}
  //                           required
  //                           className={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                           disabled={isReadOnly}
  //                         />
  //                         {errors.email2 && <p className={styles.error2}>{errors.email2}</p>}

  //                       </div>
  //                       <div className={styles.formGroup}>
  //                         <label className={styles.label}>
  //                           Telefon
  //                         </label>

  //                         <PhoneInput
  //                           country={'at'}
  //                           value={telefon}
  //                           onChange={(value) => setTelefon(value)}
  //                           preferredCountries={['at', 'de', 'ch']}
  //                           enableSearch={true}
  //                           disableSearchIcon={false}
  //                           inputProps={{
  //                             name: 'telefon',
  //                             required: true,
  //                             id: 'telefon',
  //                           }}
  //                           containerClass={styles.formGroup}
  //                           inputClass={`${styles.input} ${isAngebotForAgree ? styles.disabled : ''}`}
  //                         />

  //                         {errors.telefon && <p className={styles.error2}>{errors.telefon}</p>}

  //                       </div>

  //                       {formMode === "firma" && chosenVariant && (
  //                         <div className={styles.formGroup}>
  //                           <label className={styles.label}>Preisvariante:</label>
  //                           <div className={styles.priceOptionsWrapper}>
  //                             {firmaPrices.map((price, index) => {
  //                               const cat = getPriceCategoryById(price.Preiskategorie || price.kategorie_id);
  //                               const preisValue = Number(price.Preis);

  //                               const selected = selectedFirmaPreis === preisValue;

  //                               return (
  //                                 <div
  //                                   key={index}
  //                                   className={`${styles.priceOption} ${selected ? styles.selected : ""}`}
  //                                   onClick={() => setSelectedFirmaPreis(preisValue)}
  //                                   style={{ cursor: "pointer" }}
  //                                 >
  //                                   <strong>{cat?.Name || "Allgemein"}</strong>
  //                                   <div className={styles.priceAmount}>
  //                                     {preisValue.toLocaleString("de-DE")} €
  //                                   </div>
  //                                   <small>{cat?.Beschreibung || ""}</small>
  //                                 </div>
  //                               );
  //                             })}
  //                           </div>
  //                         </div>
  //                       )}

  //                       {isModerator && (
  //                         <>
  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Rabatt (in €)
  //                             </label>
  //                             <input
  //                               type="number"
  //                               className={styles.input}
  //                               value={rabatt}
  //                               onChange={(e) => setRabatt(Number(e.target.value))}
  //                               min={0}
  //                               step={1}
  //                             />
  //                           </div>

  //                           <div className={styles.formGroup}>
  //                             <label className={styles.label}>
  //                               Endpreis nach Rabatt
  //                             </label>
  //                             <input
  //                               type="text"
  //                               className={styles.input}
  //                               value={`${finalPreis.toLocaleString("de-DE", { minimumFractionDigits: 0 })} €`}
  //                               readOnly
  //                             />
  //                           </div>
  //                         </>
  //                       )}

  //                     </>
  //                   )}

  //                   <div className={styles.formGroup}>
  //                     <label className={styles.label} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
  //                       <input
  //                         type="checkbox"
  //                         checked={agbChecked}
  //                         onChange={(e) => setAgbChecked(e.target.checked)}
  //                         required
  //                       />
  //                       <span style={{ fontSize: '0.8rem' }}>
  //                         Ich bin mit den <a href="/agb" target="_blank" rel="noopener noreferrer">AGBs</a> und&nbsp;
  //                         <a href="/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzbestimmungen</a> einverstanden.
  //                       </span>
  //                     </label>
  //                     {errors.agbChecked && <p className={styles.error2}>{errors.agbChecked}</p>}

  //                   </div>

  //                   {isAngebotForAgree && (
  //                     <div className={styles.formGroup}>
  //                       <button
  //                         type="button"
  //                         onClick={handleUpdateData}
  //                         disabled={isUpdating}
  //                         className={styles['summary-submit']}
  //                       >
  //                         {isUpdating ? "Speichern..." : "Daten ergänzen"}
  //                       </button>
  //                     </div>
  //                   )}

  //                   {updateMessage && (
  //                     <div className={styles.updateMessage}>
  //                       {updateMessage}
  //                     </div>
  //                   )}


  //                   {isModerator && (
  //                     <button
  //                       className={styles["summary-submit"]}
  //                       type="submit"
  //                       onClick={handleSubmit}
  //                       disabled={submitting}
  //                     >
  //                       Speichern
  //                     </button>
  //                   )}

  //                 </div>
  //               </div>
  //             </form>

  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  const handleNextStep = (trigger) => {

    if (currentStep === 2 && !activeSelector && trigger !== "button") {
      setAlterError('Bitte fülle das Geburtsdatum aus oder wähle direkt das Angebot.');
      return;
    } else {
      setAlterError('');
    }

    if (currentStep === 6) {
      if (!firstName || !lastName || !email || !telefon) {
        setFormError("Bitte fülle alle Formularfelder aus!");
        return;
      } else {
        setFormError("");
      }
    }

    setCurrentStep((prev) => Math.min(prev + 1, 7));
  };


  const renderFooter = () => (
    currentStep !== 1 && (
      <div className={styles['angebot-footer']}>
        <button
          className={styles['footer-btn']}
          onClick={() => {
            const newStep = Math.max(currentStep - 1, 1);

            if (currentStep === 7 && visibleKombis.length === 0) {
              setSelectedAusbildungId(null);
              setCurrentStep(4);
              return;
            }

            if (newStep === 1) {
              setSelectedCategories([]);
            }

            if (currentStep === 4) {
              setSelectedAusbildungId(null);
              setSelectedAusbildungName(null);
              setChosenVariant(null);
              setSelectedAusbildungCombiId(null);
              setSelectedAusbildungCombiName(null);
            }
            setCurrentStep(newStep);
          }}

          disabled={currentStep === 1 || (id && currentStep === 5)}
        >
          Zurück
        </button>

        {currentStep === 6 ? (
          <button
            className={styles['footer-btn']}
            /* type="submit" */
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "Senden..." : "Anfrage senden"}
          </button>
        ) : (
          <button
            className={styles['footer-btn']}
            onClick={() => {
              if (currentStep === 2) {
                const year = parseInt(birthYear, 10);
                if (
                  birthYear.length !== 4 ||
                  isNaN(year) ||
                  year < minYearAlter ||
                  year > maxYearAlter
                ) {
                  setAlterError("Bitte gib ein gültiges Geburtsdatum ein");
                  return;
                }
                setAlterError(null);
              }



              if (currentStep === 4) {
                if (!selectedAusbildungId && !selectedAusbildungCombiId) {
                  setAusbildungError("Bitte wähle eine Ausbildung aus.");
                  return;
                } else {
                  setAusbildungError(null);
                }
              }

              if (currentStep === 5 && visibleKombis.length === 0) {
                setCurrentStep(6);
              } else {
                handleNextStep();
              }

            }}

            disabled={currentStep === 7}
          >
            Weiter
          </button>
        )}
      </div>
    )
  );


  // 👉 3) РАННИЕ ВОЗВРАТЫ (ставим прямо перед большим JSX return)
  if (loadingCritical) {
    return <Loader />;
  }
  if (errorCritical) {
    return (
      <div style={{ padding: "2rem", color: "#b00020" }}>
        Fehler beim Laden der Basisdaten. Bitte Seite neu laden oder später erneut versuchen.
      </div>
    );
  }

  // где-то выше, рядом с остальными хелперами компонента
  // const renderSignatureModalContent = () => (
  //   <div className={styles.modalOverlay}>
  //     <div className={styles.modalContent}>
  //       <h3>Unterschrift</h3>

  //       <div style={{ border: '2px solid #000', borderRadius: 8, overflow: 'hidden' }}>
  //         <SignaturePad
  //           ref={sigPadRef}
  //           canvasProps={{
  //             className: styles.signatureCanvas,
  //             style: { width: '100%', height: '100%', touchAction: 'none', display: 'block' }
  //           }}
  //         />
  //       </div>

  //       <div style={{ marginTop: '1rem', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
  //         <button className={styles.signatureBtn} onClick={handleClear} type="button">
  //           Unterschrift zurücksetzen
  //         </button>
  //         {/* <button className={styles.signatureBtn} onClick={handleSaveSignatureAndClose} type="button">
  //         Unterschreiben!
  //       </button> */}


        
  //         <button
  //           className={styles["summary-submit"]}
  //           onClick={handleSignAndUpdate}
  //         >
  //           Unterschreiben und Daten ergänzen
  //         </button>

  //         <button className={styles["summary-submit"]} onClick={() => setShowSignatureModal(false)}>
  //           Schließen
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );
const handleSaveSignatureAndClose = () => {
  handleSaveSignatureStep();
};

const renderSignatureModalContent = () => (
  <div className={styles.modalOverlay}>
    <div className={styles.modalContainer}>
      <header className={styles.modalHeader}>
        
          {sigStep === 0 ? (
            <h3>Unterschrift <br /><span>Auszubildende/r</span></h3>
          ) : ( 
            <h3>Unterschrift <br /><span>Erziehungsberechtigte/r</span></h3> 
          )}
        
        <p>Unterzeichne den Auftrag einfach im schraffierten Bereich.</p>
      </header>
      <div>
        <SignaturePad
          ref={sigPadRef}
          canvasProps={{
            className: styles.signatureCanvas,
            /* style: { width: "100%", height: "100%", touchAction: "none", display: "block" }, */
          }}
        />
        <div className={styles.resetContainer}>
          <span>{ort}, am {new Date().toLocaleDateString("de-DE")}</span>
          <button className={styles.resetBtn} onClick={handleClear} type="button">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/></svg>
            Unterschrift zurücksetzen
          </button>
        </div>
      </div>
      <main className={styles.modalContent}>
        {needsGuardianSignature && sigStep === 0 ? (
          <>
            <p>Da du nach deinen Angaben leider noch nicht volljährig bist, benötigen wir auch noch die Unterschrift eines Erziehungsberechtigten.</p>
            <p>Du kannst diese im nächsten Schritt eintragen.</p>
          </>
        ) : (
          <>
            <p>Nach dem Absenden ist dein Auftrag unterzeichnet und rechtskräftig.</p>
            <p>Wir senden dir den unterzeichneten Auftrag auch noch einmal per E-Mail zu.</p>
          </>
        )}
        <div className={styles.signatureBtnGroup}>
          {needsGuardianSignature && sigStep === 1 ? (
            <button
              className={`${styles.cancelBtn}`}
              type="button"
              onClick={() => {
                setSigStep(0);
                if (sigPadRef.current) sigPadRef.current.clear();
              }}
            >
              Zurück
            </button>
          ) : (
            <button
              className={styles.cancelBtn}
              type="button"
              onClick={() => setShowSignatureModal(false)}
            >
              Abbrechen
            </button>
          )}

          <button
            className={`${styles.signatureBtn} button pagelink`}
            onClick={handleSaveSignatureStep}
            type="button"
          >
            {needsGuardianSignature && sigStep === 0
              ? "Weiter zur 2. Unterschrift"
              : "Unterschreiben & absenden"}
          </button>

        </div>
      </main>
    </div>  
  </div>
);




  return (
    <div className={styles["angebot-wrapper"]}>

      {loadingOverall ? (
        <Loader />
      ) : errorOverall ? (
        <div>
          {errorKategorien && (
            <p>{errorKategorien}</p>
          )}
          {errorKlassen && <p>{errorKlassen}</p>}
          {errorKombinationen && (
            <p>{errorKombinationen}</p>
          )}
          {errorKlassenKombinationen && (
            <p>
              {errorKlassenKombinationen}
            </p>
          )}
          {errorLicense && <p>{errorLicense}</p>}
          {errorPreise && <p>{errorPreise}</p>}
          {errorAusbildungenPreise && (
            <p>
              {errorAusbildungenPreise}
            </p>
          )}
          {errorPriceCategories && (
            <p>{errorPriceCategories}</p>
          )}
          {errorKurse && <p>{errorKurse}</p>}
          {errorPlaces && <p>{errorPlaces}</p>}
        </div>
      ) : (
        <>
          <div className={styles["angebot-container"]}>
            <div className={styles.btnWrap}>
              {currentStep !== 1 && !isAngebotForAgree && (
                <>
                  <button
                    className={`back-button ${styles['back-btn']}`}

                    onClick={() => {
                      if (currentStep === 7 && !selectedCourse) {
                        setSelectedCourse(null);
                        setCurrentStep(4);
                        return;
                      }

                      if (currentStep === 5 && id) {
                        navigate(-1);
                        return;
                      }

                      if (currentStep === 5 && visibleKombis.length === 0) {
                        setSelectedAusbildungId(null);
                        setCurrentStep(4);
                        return;
                      }

                      const newStep = Math.max(currentStep - 1, 1);

                      if (newStep === 1) {
                        setSelectedCategories([]);
                        setSelectedLicenses([]);
                        setHasLicense(null);
                      }

                      if (currentStep === 4) {
                        setSelectedAusbildungId(null);
                        setSelectedAusbildungName(null);
                        setChosenVariant(null);
                        setSelectedAusbildungCombiId(null);
                        setSelectedAusbildungCombiName(null);
                      }

                      setCurrentStep(newStep);
                    }}


                    disabled={currentStep === 1 /* || (id && currentStep === 5) */}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" /></svg>
                  </button>
                  <div className={styles.stepHeadline}>
                    {currentStep === 2 && <>Alter</> }
                    {currentStep === 3 && <>Führerschein</> }
                    {currentStep === 4 && <>Auswahl</> }
                    {currentStep === 5 && <>Kombi</> }
                    {currentStep === 6 && <>Daten</>}
                  </div>
                </>
              )}

            </div>


            <div className={styles["angebot-main"]}>
              {renderHeader()}
              <>
                {/* {currentStep === 1 && renderStep1()} */}
                {currentStep === 2 && renderStep2()}
                {currentStep === 3 && renderStep3()}
                {currentStep === 4 && renderStep4()}
                {currentStep === 5 && renderStep5()}
                {currentStep === 7 && renderStep6()}
                {currentStep === 6 && (
                  <Step7Panel
                    // режимы
                    styles={styles}
                    isModerator={isModerator}
                    isAngebotForAgree={isAngebotForAgree}
                    formMode={formMode}
                    setFormMode={setFormMode}

                    uuid={uuid}

                    places={places}
                    loadingPlaces={loadingPlaces}
                    errorPlaces={errorPlaces}
                    uniqueOrte={uniqueOrte}
                    selectedPlace={selectedPlace}
                    setSelectedPlace={setSelectedPlace}
                    // поля формы
                    titel={titel} setTitel={setTitel}
                    geschlecht={geschlecht} setGeschlecht={setGeschlecht}
                    firstName={firstName} setFirstName={setFirstName}
                    lastName={lastName} setLastName={setLastName}
                    birthDate={birthDate} setBirthDate={setBirthDate}
                    email={email} setEmail={setEmail}
                    email2={email2} setEmail2={setEmail2}
                    staatsbuergerschaft={staatsbuergerschaft} setStaatsbuergerschaft={setStaatsbuergerschaft}
                    euCountryNames={euCountryNames}
                    nonEuCountryNames={nonEuCountryNames}
                    geburtsort={geburtsort} setGeburtsort={setGeburtsort}
                    strasse={strasse} setStrasse={setStrasse}
                    hausnummer={hausnummer} setHausnummer={setHausnummer}
                    plz={plz} setPlz={setPlz}
                    ort={ort} setOrt={setOrt}
                    telefon={telefon} setTelefon={setTelefon}
                    agbChecked={agbChecked} setAgbChecked={setAgbChecked}
                    fuehrerscheinNummer={fuehrerscheinNummer} setFuehrerscheinNummer={setFuehrerscheinNummer}

                    // цены/варианты/гутшайн

                    priceCategories={priceCategories}
                    /* finalPrices={
                      codePreise?.length ? codePreise
                        : angebotPreise?.length ? angebotPreise
                          : preiseOptions
                    } */
                    finalPrices={
                      codePreise?.length ? codePreise
                        : werbungPreise?.length ? werbungPreise
                          : angebotPreise?.length ? angebotPreise
                            : preiseOptions
                    }

                    // ЦЕНЫ ДЛЯ «Firma»
                    firmaPrices={getPricesForAusbildung(chosenVariant?.id) || []}
                    variantPrices={variantPrices}
                    preiseOptions={preiseOptions}
                    angebotPreise={angebotPreise}
                    codePreise={codePreise}
                    selectedPreis={selectedPreis} setSelectedPreis={setSelectedPreis}
                    selectedPreisIndex={selectedPreisIndex} setSelectedPreisIndex={setSelectedPreisIndex}
                    availableGutscheine={availableGutscheine}
                    selectedGutscheinId={selectedGutscheinId} setSelectedGutscheinId={setSelectedGutscheinId}
                    gutscheinAppliedData={gutscheinAppliedData}
                    gutscheinCode={gutscheinCode} setGutscheinCode={setGutscheinCode}
                    gutscheinValid={gutscheinValid}
                    gutscheinChecked={gutscheinChecked}
                    gutscheinError={gutscheinError}
                    finalPreis={finalPreis}
                    preisInfos={chosenVariant?.Preisinformationen}
                    rabatt={rabatt} setRabatt={setRabatt}
                    selectedFirmaPreis={selectedFirmaPreis} setSelectedFirmaPreis={setSelectedFirmaPreis}

                    // файлы/валидация
                    attachments={attachments} setAttachments={setAttachments}
                    errors={errors}
                    formError={formError}

                    // сабмит/экшены
                    submissionSuccess={submissionSuccess}
                    submitting={submitting}
                    onSubmit={handleSubmit}
                    onCheckGutschein={handleCheckGutschein}
                    onUpdateData={handleUpdateData}
                    isUpdating={isUpdating}
                    updateMessage={updateMessage}
                    setUpdateMessage={setUpdateMessage}
                    isReadOnly={isAngebotForAgree && !isModerator}
                    onSendAngebot={handleSendAngebot}


                    viewMode={isModerator ? "editor" : "viewer"} // или вычисляй иначе для клиента/2-го экрана

                    // onOpenSignature={() => setShowSignatureModal(true)}
                    onOpenSignature={openSignatureModal}



                    // если нужно дать доступ к редактированию/очистке изнутри — можешь также пробросить:
                    onClearSignature={handleClear}
                    onSaveSignature={handleSaveSignatureAndClose}

                    // состояния «сохранено/редактирование»
                    angebotAnfrageId={angebotAnfrageId}
                    savedSummaryData={savedSummaryData}
                    savedSummary2Data={savedSummary2Data}
                    isEditing={isEditing} setIsEditing={setIsEditing}
                    selectedKlasseId={
                      chosenVariant?.Klasse?.id ??
                      chosenVariant?.klasse?.id ??
                      chosenVariant?.Klasse_id ??
                      chosenVariant?.klasse_id ??
                      null
                    }
                  />
                )}
              </>
            </div>
            {/* {showSignatureModal && (
  <div className={styles.modalOverlay}>
    <div className={styles.modalContent}>
      <h3>Unterschrift</h3>

      <SignaturePad ref={sigPadRef} canvasProps={{ className: styles.signatureCanvas }} />

      <div style={{ marginTop: '1rem' }}>
        <button className={styles.signatureBtn} onClick={handleClear} type="button">
          Unterschrift zurücksetzen
        </button>
      </div>

      <div style={{ marginTop: '1rem' }}>
        <button className={styles.signatureBtn} onClick={handleSaveSignatureAndClose} type="button">
          Unterschreiben!
        </button>
      </div>

      <div style={{ marginTop: '1rem' }}>
        <button className={styles["summary-submit"]} onClick={() => setShowSignatureModal(false)}>
          Schließen
        </button>
      </div>
    </div>
  </div>
)} */}

            {/* {showSignatureModal && (
  <div className={styles.modalOverlay}>
    <div className={styles.modalContent}>
      <h3>Unterschrift</h3>

      <div style={{ height: '50vh', border: '2px solid #000', borderRadius: 8, overflow: 'hidden' }}>
        <SignaturePad
          ref={sigPadRef}
          canvasProps={{
            className: styles.signatureCanvas,
            style: { width: '100%', height: '100%', touchAction: 'none', display: 'block' }
          }}
        />
      </div>

      <div style={{ marginTop: '1rem', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <button className={styles.signatureBtn} onClick={handleClear} type="button">
          Unterschrift zurücksetzen
        </button>
        <button className={styles.signatureBtn} onClick={handleSaveSignatureAndClose} type="button">
          Unterschreiben!
        </button>
        <button className={styles["summary-submit"]} onClick={() => setShowSignatureModal(false)}>
          Schließen
        </button>
      </div>
    </div>
  </div>
)} */}

            {showSignatureModal && clientWindow && clientWindow.document
              ? ReactDOM.createPortal(
                renderSignatureModalContent(),
                clientWindow.document.getElementById("client-modal-root") || clientWindow.document.body
              )
              : showSignatureModal
                ? renderSignatureModalContent()
                : null}



            {/* Клиентский контент в отдельном окне */}
            {clientWindow && clientWindow.document
              ? ReactDOM.createPortal(
                <ClientView
                  savedSummaryData={savedSummaryData}
                  savedSummary2Data={savedSummary2Data}
                  // onOpenSignature={() => setShowSignatureModal(true)}
                  onOpenSignature={openSignatureModal}

                  styles={styles}
                />,
                clientWindow.document.getElementById("client-root")
              )
              : null}

            {/* {showSignatureModal && clientWindow && clientWindow.document
  ? ReactDOM.createPortal(
      <div className={styles.modalOverlay}>
        <div className={styles.modalContent}>
          <h3>Unterschrift</h3>

          <SignaturePad ref={sigPadRef} canvasProps={{ className: styles.signatureCanvas }} />

          <div style={{ marginTop: '1rem' }}>
            <button className={styles.signatureBtn} onClick={handleClear} type="button">
              Unterschrift zurücksetzen
            </button>
          </div>

          <div style={{ marginTop: '1rem' }}>
            <button className={styles.signatureBtn} onClick={handleSaveSignatureAndClose} type="button">
              Unterschreiben!
            </button>
          </div>

          <div style={{ marginTop: '1rem' }}>
            <button className={styles["summary-submit"]} onClick={() => setShowSignatureModal(false)}>
              Schließen
            </button>
          </div>
        </div>
      </div>,
      clientWindow.document.getElementById("client-modal-root")
    )
  : null}


{showSignatureModal && (!clientWindow || !clientWindow.document) && (
  <div className={styles.modalOverlay}>
    <div className={styles.modalContent}>
      <h3>Unterschrift</h3>

      <SignaturePad ref={sigPadRef} canvasProps={{ className: styles.signatureCanvas }} />

      <div style={{ marginTop: '1rem' }}>
        <button className={styles.signatureBtn} onClick={handleClear} type="button">
          Unterschrift zurücksetzen
        </button>
      </div>

      <div style={{ marginTop: '1rem' }}>
        <button className={styles.signatureBtn} onClick={handleSaveSignatureAndClose} type="button">
          Unterschreiben!
        </button>
      </div>

      <div style={{ marginTop: '1rem' }}>
        <button className={styles["summary-submit"]} onClick={() => setShowSignatureModal(false)}>
          Schließen
        </button>
      </div>
    </div>
  </div>
)} */}



            {renderSummary()}
          </div>
          {currentStep === 1 && (
            <CSSTransition
              key={1}
              timeout={300}
              classNames="my-node"
            >
              {renderStep1()}
            </CSSTransition>
          )}
        </>
      )}
      {renderFooter()}
    </div>
  );
};

export default AngebotWizard;


